(function () {
  "use strict";

  var config = window.KB_LEADS_CONFIG || {};
  var API_COLLECT = config.collectUrl || "https://app.fordservisbeograd.rs/leads/lead_collect.php";
  var API_EVENT = config.eventUrl || "https://app.fordservisbeograd.rs/leads/lead_event.php";
  var API_DECISION = config.decisionUrl || "https://app.fordservisbeograd.rs/api/customer_brain/decision.php";
  var API_DECISION_EVENT = config.decisionEventUrl || "https://app.fordservisbeograd.rs/api/customer_brain/decision_event.php";
  var API_INCENTIVE = config.incentiveUrl || "https://app.fordservisbeograd.rs/api/customer_brain/incentive.php";
  var FORMS_EMBED_URL = config.formsEmbedUrl || ((config.formsBaseUrl || API_COLLECT.replace(/\/leads\/lead_collect\.php.*$/, "")).replace(/\/$/, "") + "/forms/embed/script.js?v=20260928-form-events-v2");
  var DESIGNER_HELP_FORM_SLUG = config.designerHelpFormSlug || "kucni-brojevi";

  /* Javni ingest token.
     Svaki endpoint na /leads/ i /api/customer_brain/ proverava ga preko
     kb_leads_check_public_token(); bez njega vraca 403 Forbidden.
     Nije tajna i nije autentifikacija — ista vrednost je citljiva iz izvora
     ove stranice. Pravu zastitu radi provereni Origin na serveru. Sluzi da
     odbije skriptovane pozive koji se ne potrude da je procitaju.
     Token ide u TELO, ne u zaglavlje: sendBeacon ne moze da postavi zaglavlje,
     a dodatno zaglavlje bi zahtev ucinilo CORS-slozenim i trazilo preflight
     koji pregledaci pri napustanju stranice redovno odbace. Server prihvata
     oba oblika (HTTP_X_LEAD_INGEST_TOKEN ili payload['ingest_token']).
     Dodato 13.10.2026 — provera je na serveru ukljucena 12.10. u 23:23 dok je
     nijedan klijent nije slao, pa je prijem leadova i dogadjaja stao ~23h. */
  var INGEST_TOKEN = config.ingestToken || "kb_e1ffaa76ac3a8a5ffee73ab452c95e55";

  function kbTelo(payload) {
    var telo = {};
    if (payload && typeof payload === "object") {
      for (var k in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, k)) telo[k] = payload[k];
      }
    }
    telo.ingest_token = INGEST_TOKEN;
    return JSON.stringify(telo);
  }


  var LS_ANON_ID = "gs_anon_id";
  var LS_LEAD_ID = "gs_lead_id";
  var LS_QUEUE = "gs_event_queue";
  var LS_SESSION = "gs_session_id";
  var LS_LAST_ACTIVITY = "gs_last_activity";
  var LS_HAS_REAL_EMAIL = "gs_has_real_email";
  var LS_SKIP_UNTIL = "gs_popup_skip_until";
  var LS_HIDE_HELP = "gs_hide_help_popup";
  var LS_PHONE_IDENTIFIED = "gs_phone_identified";
  var LS_RECOMMENDED_PRODUCTS = "recommended_products";
  var LS_LAST_POPUP_SHOWN_AT = "gs_last_popup_shown_at";
  var LS_CART_POPUP_CLOSED_UNTIL = "gs_cart_popup_closed_until";
  var LS_FREE_DELIVERY_POPUP_CLOSED_UNTIL = "gs_free_delivery_popup_closed_until";
  var LS_SMART_CAPTURE_CLOSED_UNTIL = "gs_smart_capture_closed_until";
  var LS_META_LEAD_EVENT_PREFIX = "gs_meta_lead_event_sent:";
  var LS_MANYCHAT_LANDING_SENT_PREFIX = "gs_manychat_landing_sent:";
  var LS_DESIGN_DRAFT_PREFIX = "kb_table_design_draft:";
  var LS_DESIGN_REMINDER_DISMISSED_UNTIL = "kb_design_reminder_dismissed_until";
  var LS_DESIGN_REMINDER_SHOWN_SESSION = "kb_design_reminder_shown_session";
  var LS_CUSTOMER_BRAIN_INCENTIVE = "kb_customer_brain_incentive";
  var LS_CUSTOMER_BRAIN_COUPON_POPUP_DISMISSED_UNTIL = "kb_customer_brain_coupon_popup_dismissed_until";
  var SS_CUSTOMER_BRAIN_DECISION = "kb_customer_brain_decision_session";
  var SS_CUSTOMER_BRAIN_DECISION_PAYLOAD = "kb_customer_brain_decision_payload";
  var SS_CUSTOMER_BRAIN_COUPON_POPUP = "kb_customer_brain_coupon_popup_session";
  var SS_CUSTOMER_BRAIN_HELP_INTENT = "kb_customer_brain_help_intent";
  var SS_CUSTOMER_BRAIN_PERSONAL_TEXT = "kb_customer_brain_personal_text_context";
  var SS_CUSTOMER_BRAIN_DISMISSED_PREFIX = "kb_customer_brain_dismissed:";
  var CUSTOMER_BRAIN_HELP_INTENT_MS = 10 * 60 * 1000;
  var SS_COUPON_NOTICE = "kb_coupon_notice";

  var SESSION_TIMEOUT_MS = 30 * 60 * 1000;
  var POPUP_SKIP_MS = 60 * 60 * 1000;
  var GLOBAL_POPUP_COOLDOWN_MS = config.globalPopupCooldownMs || 60 * 1000;
  var CART_POPUP_COOLDOWN_MS = config.cartPopupCooldownMs || 30 * 60 * 1000;
  var FREE_DELIVERY_POPUP_COOLDOWN_MS = config.freeDeliveryPopupCooldownMs || 30 * 60 * 1000;
  var CART_DISCOUNT_THRESHOLD = config.cartDiscountThreshold || 5500;
  var MIN_CART_TOTAL_TO_SHOW_CART_DISCOUNT = config.minCartTotalToShowCartDiscount || 1500;
  var FREE_SHIPPING_THRESHOLD = config.freeShippingThreshold || 5500;
  var MIN_CART_TOTAL_TO_SHOW_FREE_DELIVERY = config.minCartTotalToShowFreeDelivery || 4000;
  var FREE_DELIVERY_POPUP_ENABLED = config.freeDeliveryPopup === true;
  var SMART_CAPTURE_ENABLED = config.smartCapture !== false;
  var CUSTOMER_BRAIN_ENABLED = config.customerBrainDecision !== false;
  var SMART_CAPTURE_DELAY_MS = config.smartCaptureDelayMs || 45000;
  var SMART_CAPTURE_COOLDOWN_MS = config.smartCaptureCooldownMs || 30 * 24 * 60 * 60 * 1000;
  var CART_DISCOUNT_CODE = config.cartDiscountCode || "MOJDOM";
  var CART_RECOMMENDATION_LIMIT = config.cartRecommendationLimit || 6;
  var DESIGN_REMINDER_DISMISS_MS = config.designReminderDismissMs || 24 * 60 * 60 * 1000;
  var CUSTOMER_BRAIN_COUPON_POPUP_ENABLED = config.customerBrainCouponPopup !== false;
  var CUSTOMER_BRAIN_COUPON_POPUP_DISMISS_MS = config.customerBrainCouponPopupDismissMs || 6 * 60 * 60 * 1000;
  var DEBUG = config.debug === true;

  // "Pravilo jednog popup-a": max 1 modalni prekid po sesiji, ne u prvih 30s na stranici, ne dok korisnik aktivno personalizuje
  var SS_INTERRUPT_USED = "kb_session_interrupt_used";
  var MIN_TIME_ON_PAGE_MS = config.minTimeOnPageMs || 30000;
  var CONFIGURATOR_IDLE_MS = config.configuratorIdleMs || 60000;
  var bootAt = Date.now();
  var lastConfiguratorActivityAt = 0;
  (function trackConfiguratorActivity() {
    function mark(e) {
      var t = e.target;
      if (t && t.closest && t.closest(".kb-table-designer")) lastConfiguratorActivityAt = Date.now();
    }
    document.addEventListener("pointerdown", mark, true);
    document.addEventListener("input", mark, true);
  })();
  var latestCartSnapshot = null;
  var customerBrainMountReadyTimer = null;
  var customerBrainDecisionSignature = "";
  var customerBrainDecisionSignatureAt = 0;
  var recentEventSignature = "";
  var recentEventSignatureAt = 0;
  var gsFormsEmbedPromise = null;

  function log() {
    if (DEBUG && window.console) console.log.apply(console, arguments);
  }

  function safeJsonParse(value, fallback) {
    try {
      return value ? JSON.parse(value) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function stableStringify(value) {
    if (value === null || typeof value !== "object") return JSON.stringify(value);
    if (Array.isArray(value)) {
      return "[" + value.map(stableStringify).join(",") + "]";
    }
    return "{" + Object.keys(value).sort().map(function (key) {
      return JSON.stringify(key) + ":" + stableStringify(value[key]);
    }).join(",") + "}";
  }

  function eventSignature(type, data, page, cart) {
    return [
      type || "",
      page || "",
      stableStringify(data || {}),
      stableStringify(cart || null)
    ].join("|");
  }

  function shouldSkipRecentEvent(type, data, page, cart) {
    var signature = eventSignature(type, data, page, cart);
    var now = Date.now();
    if (signature === recentEventSignature && now - recentEventSignatureAt < 2000) {
      return true;
    }
    recentEventSignature = signature;
    recentEventSignatureAt = now;
    return false;
  }

  function randId(prefix) {
    if (window.crypto && window.crypto.randomUUID) return prefix + window.crypto.randomUUID();
    return prefix + Math.random().toString(36).slice(2) + Date.now();
  }

  function normalizePhone(phone) {
    if (!phone) return "";
    phone = String(phone).replace(/\s+/g, " ").trim();
    var digits = phone.replace(/\D/g, "");
    if (digits.length < 8) return "";
    if (phone === "+381" || phone === "+381 ") return "";
    return phone;
  }

  function readCookie(name) {
    var prefix = name + "=";
    var parts = String(document.cookie || "").split(";");
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) return decodeURIComponent(part.slice(prefix.length));
    }
    return "";
  }

  function queryParam(name) {
    try {
      return new URLSearchParams(window.location.search || "").get(name) || "";
    } catch (e) {
      return "";
    }
  }

  function queryPositiveInt() {
    for (var i = 0; i < arguments.length; i++) {
      var raw = queryParam(arguments[i]);
      if (!raw || raw.indexOf("{") !== -1) continue;
      var id = parseInt(raw, 10);
      if (!isNaN(id) && id > 0) return id;
    }
    return null;
  }

  function queryCleanId() {
    for (var i = 0; i < arguments.length; i++) {
      var raw = String(queryParam(arguments[i]) || "").trim();
      if (raw && raw.indexOf("{") === -1) return raw.slice(0, 128);
    }
    return "";
  }

  function metaIdentity() {
    var fbclid = queryParam("fbclid");
    var fbc = readCookie("_fbc");
    if (!fbc && fbclid) fbc = "fb.1." + Math.floor(Date.now() / 1000) + "." + fbclid;
    return {
      fbp: readCookie("_fbp"),
      fbc: fbc,
      fbclid: fbclid,
      fb_login_id: facebookLoginId()
    };
  }

  function facebookLoginId() {
    try {
      if (window.KB_META_FB_LOGIN_ID) return String(window.KB_META_FB_LOGIN_ID || "");
      if (window.FB && typeof window.FB.getAuthResponse === "function") {
        var auth = window.FB.getAuthResponse();
        if (auth && auth.userID) return String(auth.userID || "");
      }
    } catch (e) {}
    return "";
  }

  function trackMetaLeadEvent(leadIdValue) {
    var id = parseInt(leadIdValue, 10);
    if (!id || typeof window.fbq !== "function") return;
    var eventId = "shopify_lead_" + id + "_lead";
    var key = LS_META_LEAD_EVENT_PREFIX + eventId;
    try {
      if (localStorage.getItem(key) === "1") return;
      window.fbq("track", "Lead", {}, { eventID: eventId });
      localStorage.setItem(key, "1");
    } catch (e) {}
  }

  function googleClientId() {
    var ga = readCookie("_ga");
    var match = /^GA\d+\.\d+\.(.+)$/.exec(ga);
    return match ? match[1] : "";
  }

  function googleSessionId() {
    var parts = String(document.cookie || "").split(";");
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (part.indexOf("_ga_") !== 0) continue;
      var value = decodeURIComponent(part.slice(part.indexOf("=") + 1));
      var match = /(?:^|\.)s(\d+)(?:\$|\.|$)/.exec(value) || /^GS\d+\.\d+\.(\d+)/.exec(value);
      if (match) return match[1];
    }
    return "";
  }

  function googleIdentity() {
    return {
      gclid: queryParam("gclid"),
      gbraid: queryParam("gbraid"),
      wbraid: queryParam("wbraid"),
      ga_client_id: googleClientId(),
      ga_session_id: googleSessionId()
    };
  }

  function manychatIdentity() {
    var contactId = queryParam("mc_contact_id") || queryParam("manychat_contact_id") || queryParam("mc_subscriber_id");
    if (contactId && contactId.indexOf("{") !== -1) contactId = "";
    var platform = queryParam("mc_platform") || queryParam("platform");
    var igUsername = queryParam("mc_ig_username") || queryParam("ig_username");
    var entryFlow = queryParam("mc_entry_flow");
    var urlLeadId = queryPositiveInt("lead_id", "mc_lead_id");
    var urlAnonId = queryCleanId("anon_id", "mc_anon_id");
    return {
      contact_id: contactId,
      subscriber_id: contactId,
      lead_id: urlLeadId,
      mc_lead_id: urlLeadId,
      anon_id: urlAnonId,
      mc_anon_id: urlAnonId,
      source: contactId ? "manychat" : "",
      platform: platform,
      ig_username: igUsername,
      entry_flow: entryFlow,
      utm_source: queryParam("utm_source"),
      utm_medium: queryParam("utm_medium"),
      utm_campaign: queryParam("utm_campaign"),
      utm_term: queryParam("utm_term"),
      utm_content: queryParam("utm_content")
    };
  }

  function hasManychatIdentity(identity) {
    identity = identity || manychatIdentity();
    return !!String(identity.contact_id || "").trim();
  }

  function shopifyIdentity() {
    return {
      y: readCookie("_shopify_y")
    };
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());
  }

  function isGeneratedEmail(email) {
    return String(email || "").trim().toLowerCase().endsWith("@kucnibrojevi.com");
  }

  function rememberContactState(data) {
    data = data || {};
    var email = String(data.email || "").trim().toLowerCase();
    var phone = normalizePhone(data.phone || "");

    if (email && !isGeneratedEmail(email)) {
      localStorage.setItem(LS_HAS_REAL_EMAIL, "1");
      localStorage.setItem("gs_contact_complete", "1");
      localStorage.removeItem(LS_SKIP_UNTIL);
    } else if (phone && localStorage.getItem(LS_HAS_REAL_EMAIL) !== "1") {
      localStorage.setItem("gs_contact_complete", "0");
    }
  }

  function isCheckoutPage() {
    return window.location.pathname.indexOf("/checkouts") !== -1 ||
      window.location.pathname.indexOf("/checkout") !== -1;
  }

  function isCooldownActive(key) {
    var until = parseInt(localStorage.getItem(key) || "0", 10);
    return !!until && Date.now() < until;
  }

  function canShowAnyPopup() {
    if (isCheckoutPage()) return false;
    if (window.kbAnyPopupOpen) return false;
    try { if (sessionStorage.getItem(SS_INTERRUPT_USED) === "1") return false; } catch (e) {}
    if (Date.now() - bootAt < MIN_TIME_ON_PAGE_MS) return false;
    if (document.body && document.body.classList.contains("kb-configurator-open")) return false;
    if (lastConfiguratorActivityAt && Date.now() - lastConfiguratorActivityAt < CONFIGURATOR_IDLE_MS) return false;

    var lastShownAt = parseInt(localStorage.getItem(LS_LAST_POPUP_SHOWN_AT) || "0", 10);
    if (lastShownAt && Date.now() - lastShownAt < GLOBAL_POPUP_COOLDOWN_MS) return false;

    return true;
  }

  function markPopupShown() {
    localStorage.setItem(LS_LAST_POPUP_SHOWN_AT, String(Date.now()));
    try { sessionStorage.setItem(SS_INTERRUPT_USED, "1"); } catch (e) {}
    window.kbAnyPopupOpen = true;
  }

  function releasePopupLock() {
    window.kbAnyPopupOpen = false;
  }

  function shouldShowLeadPopup(options) {
    options = options || {};
    if (!canShowAnyPopup()) return false;
    if (localStorage.getItem(LS_HAS_REAL_EMAIL) === "1") return false;
    if (localStorage.getItem(LS_HIDE_HELP) === "1") return false;
    if (isCooldownActive(LS_SKIP_UNTIL)) return false;
    if (config.customilyIntercept === false && options.ignoreCustomilyIntercept !== true) return false;
    return true;
  }

  function needsEmailPopup() {
    return shouldShowLeadPopup();
  }

  function hasAnyContact() {
    return localStorage.getItem(LS_HAS_REAL_EMAIL) === "1" ||
      !!localStorage.getItem(LS_PHONE_IDENTIFIED);
  }

  function promptForEmailIfNeeded(delayMs) {
    if (!needsEmailPopup()) return;
    setTimeout(function () {
      if (needsEmailPopup() && typeof window.kbShowLeadPopup === "function") {
        window.kbShowLeadPopup();
      }
    }, delayMs || 1200);
  }

  var urlAnonId = queryCleanId("anon_id", "mc_anon_id");
  var anonId = urlAnonId || localStorage.getItem(LS_ANON_ID);
  if (!anonId) {
    anonId = randId("anon_");
  }
  localStorage.setItem(LS_ANON_ID, anonId);

  var urlLeadId = queryPositiveInt("lead_id", "mc_lead_id");
  var leadId = urlLeadId || parseInt(localStorage.getItem(LS_LEAD_ID) || "", 10);
  if (isNaN(leadId)) leadId = null;
  if (leadId) localStorage.setItem(LS_LEAD_ID, String(leadId));

  function getSessionId() {
    var now = Date.now();
    var last = parseInt(localStorage.getItem(LS_LAST_ACTIVITY) || "0", 10);
    var sessionId = localStorage.getItem(LS_SESSION);
    if (!sessionId || !last || now - last > SESSION_TIMEOUT_MS) sessionId = randId("sess_");
    localStorage.setItem(LS_SESSION, sessionId);
    localStorage.setItem(LS_LAST_ACTIVITY, String(now));
    return sessionId;
  }

  var sessionId = getSessionId();

  function touchSession() {
    localStorage.setItem(LS_LAST_ACTIVITY, String(Date.now()));
  }

  function handleLeadResponse(res) {
    rememberContactState(res);

    if (res && res.anon_id && res.anon_id !== anonId) {
      anonId = res.anon_id;
      localStorage.setItem(LS_ANON_ID, anonId);
      window.gsAnonId = anonId;
    }

    if (res && res.lead_id) {
      var id = parseInt(res.lead_id, 10);
      if (!isNaN(id)) {
        leadId = id;
        localStorage.setItem(LS_LEAD_ID, String(id));
        window.gsLeadId = id;
        flushQueue();
      }
    }

    return res;
  }

  function fetchCart() {
    return fetch("/cart.js").then(function (r) {
      return r.json();
    }).catch(function () {
      return {};
    });
  }

  function cartItemCount(cart) {
    cart = cart || {};
    if (typeof cart.item_count === "number") return Math.max(0, cart.item_count);
    return cart.items && Array.isArray(cart.items) ? cart.items.length : 0;
  }

  function customerBrainNormalizeText(value) {
    value = String(value || "").trim();
    value = value.replace(/\s+/g, " ");
    return value;
  }

  function customerBrainTextKey(value) {
    value = normalizeCategoryText(customerBrainNormalizeText(value));
    var cyr = {
      "а": "a", "б": "b", "в": "v", "г": "g", "д": "d", "ђ": "dj", "е": "e", "ж": "z", "з": "z", "и": "i",
      "ј": "j", "к": "k", "л": "l", "љ": "lj", "м": "m", "н": "n", "њ": "nj", "о": "o", "п": "p", "р": "r",
      "с": "s", "т": "t", "ћ": "c", "у": "u", "ф": "f", "х": "h", "ц": "c", "ч": "c", "џ": "dz", "ш": "s"
    };
    value = value.replace(/[абвгдђеєжзијклљмнњопрстћуфхцчџш]/g, function (ch) { return cyr[ch] || ch; });
    return value.toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  }

  function customerBrainIsDemoText(value) {
    var key = customerBrainTextKey(value);
    if (!key) return true;
    var demos = [
      "vojvodjanska", "vojvodjanska 23", "bojbodjanska", "bojvodjanska", "pinkijeva",
      "vozda karadjordja", "12", "25 oktobra",
      "23", "28", "48", "154a", "petrovic", "porodica petrovic", "dr popovic bosa",
      "posta", "postansko sanduce"
    ];
    return demos.indexOf(key) !== -1;
  }

  function customerBrainTextRole(value, fields) {
    var key = customerBrainTextKey(value);
    fields = fields || {};
    if (fields.extra_text || fields.mailbox_bottom_text) return "surname_or_family";
    if (/\b(stan|ulaz|sprat)\b/.test(key)) return "apartment_label";
    if (/\b(doo|ordinacija|salon|firma|kancelarija)\b/.test(key)) return "company";
    if (/\d/.test(key) && /[a-z]/.test(key)) return "street";
    return "surname_or_family";
  }

  function customerBrainCleanPersonalValue(value) {
    value = customerBrainNormalizeText(value);
    if (!value || value.length < 2 || value.length > 80) return "";
    if (customerBrainIsDemoText(value)) return "";
    return value;
  }

  function customerBrainTextFromObject(obj, keys) {
    obj = obj || {};
    for (var i = 0; i < keys.length; i++) {
      var value = customerBrainCleanPersonalValue(obj[keys[i]]);
      if (value) return value;
    }
    return "";
  }

  function customerBrainItemFields(item) {
    item = item || {};
    var props = item.properties && typeof item.properties === "object" ? item.properties : {};
    var fields = {
      street: props.Natpis || props.natpis || props.Ulica || props.ulica || props["Gornji tekst"] || props.street || "",
      number: props.Broj || props.broj || props.Number || props.number || "",
      extra_text: props["Dodatni natpis"] || props.extra_text || props.Prezime || props.prezime || props.Napomena || "",
      mailbox_top_text: props["Gornji tekst"] || props.mailbox_top_text || "",
      mailbox_bottom_text: props["Donji tekst"] || props.mailbox_bottom_text || ""
    };
    Object.keys(fields).forEach(function (key) { fields[key] = customerBrainNormalizeText(fields[key]); });
    return fields;
  }

  function customerBrainBestTextFromFields(fields) {
    fields = fields || {};
    return customerBrainTextFromObject(fields, ["extra_text", "mailbox_bottom_text", "street"]);
  }

  function customerBrainReadStoredPersonalText() {
    try {
      var stored = safeJsonParse(sessionStorage.getItem(SS_CUSTOMER_BRAIN_PERSONAL_TEXT), null);
      if (stored && stored.display_text && !customerBrainIsDemoText(stored.display_text)) return stored;
    } catch (e) {}
    return null;
  }

  function customerBrainSavePersonalText(context) {
    if (!context || !context.display_text) return;
    try { sessionStorage.setItem(SS_CUSTOMER_BRAIN_PERSONAL_TEXT, JSON.stringify(context)); } catch (e) {}
  }

  function customerBrainBuildPromptPersonalTextContext(text, offer) {
    text = customerBrainCleanPersonalValue(text || "");
    if (!text) return null;
    var fields = { extra_text: text };
    return {
      has_text: true,
      display_text: text,
      role: customerBrainTextRole(text, fields),
      source_category: (offer && offer.source_category) || "",
      confidence: "high",
      source: "customer_brain_prompt",
      fields: fields
    };
  }

  function customerBrainCartPersonalTextContext(cart) {
    cart = cart || {};
    var stored = customerBrainReadStoredPersonalText();
    var items = Array.isArray(cart.items) ? cart.items : [];
    var cartCategories = [];
    var best = null;
    items.forEach(function (item) {
      var category = detectCustomerBrainCategory([
        item.handle || "",
        item.product_handle || "",
        item.product_type || "",
        item.title || "",
        item.product_title || "",
        item.url || ""
      ].join(" "));
      if (category && cartCategories.indexOf(category) === -1) cartCategories.push(category);
      var fields = customerBrainItemFields(item);
      var text = customerBrainBestTextFromFields(fields);
      if (!text) return;
      best = {
        has_text: true,
        display_text: text,
        role: customerBrainTextRole(text, fields),
        source_category: category || "",
        confidence: "high",
        source: "cart_properties",
        fields: fields
      };
    });
    if (best) {
      customerBrainSavePersonalText(best);
      return best;
    }
    if (stored) return stored;

    try {
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (!key || key.indexOf(LS_DESIGN_DRAFT_PREFIX) !== 0) continue;
        var draft = safeJsonParse(localStorage.getItem(key), null);
        var cfg = draft && draft.config ? draft.config : {};
        var fields = {
          street: customerBrainNormalizeText(cfg.street || cfg.characters || ""),
          number: customerBrainNormalizeText(cfg.number || ""),
          extra_text: customerBrainNormalizeText(cfg.extra_text || ""),
          mailbox_top_text: customerBrainNormalizeText(cfg.mailbox_top_text || ""),
          mailbox_bottom_text: customerBrainNormalizeText(cfg.mailbox_bottom_text || "")
        };
        var text = customerBrainBestTextFromFields(fields);
        if (!text) continue;
        var sourceCategory = detectCustomerBrainCategory((draft.product_handle || cfg.product_handle || key).replace(LS_DESIGN_DRAFT_PREFIX, ""));
        best = {
          has_text: true,
          display_text: text,
          role: customerBrainTextRole(text, fields),
          source_category: sourceCategory,
          confidence: "medium",
          source: "design_draft",
          fields: fields
        };
        customerBrainSavePersonalText(best);
        return best;
      }
    } catch (e) {}

    return {
      has_text: false,
      display_text: "",
      role: "free_text",
      source_category: cartCategories[0] || "",
      confidence: "none",
      source: "none",
      fields: {}
    };
  }

  function initLeadOnce() {
    if (leadId) return Promise.resolve(leadId);

    return fetch(API_COLLECT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: kbTelo({
        anon_id: anonId,
        lead_id: leadId,
        page: window.location.href,
        session_id: sessionId,
        event_type: "init",
        meta: metaIdentity(),
        google: googleIdentity(),
        manychat: manychatIdentity(),
        shopify: shopifyIdentity()
      })
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(handleLeadResponse)
      .then(function () { return leadId; });
  }

  var queue = safeJsonParse(localStorage.getItem(LS_QUEUE), []);
  if (!Array.isArray(queue)) queue = [];
  var flushInProgress = false;

  var GA4_DESIGN_EVENT_MAP = {
    table_design_opened: "table_design_opened",
    table_design_started: "table_design_started",
    table_design_color_preset_click: "table_design_color_preset_click",
    table_design_alternate_shape_click: "table_design_alternate_shape_click",
    table_design_restored: "table_design_restored",
    table_design_reminder_click: "table_design_reminder_click",
    table_design_related_prefill_used: "table_design_related_prefill_used",
    table_design_add_to_cart: "table_design_add_to_cart"
  };

  var GA4_DESIGN_PARAM_ALLOWLIST = [
    "event_id", "source", "product_handle", "product_id", "variant_id",
    "shape", "product_type", "dimensions", "step", "plate_color",
    "text_color", "distancer_color", "engraving_color", "preset",
    "preset_id", "source_product_handle", "target_product_handle", "group",
    "draft_count", "has_street", "has_number", "has_extra_text",
    "has_characters", "has_contact_phone", "street_changed", "number_changed", "draft_source"
  ];

  function ga4DesignEventId() {
    return "kb_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
  }

  function ga4DesignParams(data, eventId) {
    data = data || {};
    var params = { event_id: eventId };
    GA4_DESIGN_PARAM_ALLOWLIST.forEach(function (key) {
      if (key === "event_id" || data[key] === undefined || data[key] === null || data[key] === "") return;
      var value = data[key];
      if (typeof value === "boolean" || typeof value === "number") params[key] = value;
      else params[key] = String(value).slice(0, 100);
    });
    return params;
  }

  function trackGa4DesignEvent(type, data) {
    data = data || {};
    var eventId = data.event_id || ga4DesignEventId();
    if (!data.event_id) data.event_id = eventId;
    var params = ga4DesignParams(data, eventId);
    var events = [];

    if (GA4_DESIGN_EVENT_MAP[type]) events.push(GA4_DESIGN_EVENT_MAP[type]);
    if (type === "table_design_draft_saved" && (data.street_changed === true || data.number_changed === true)) {
      events.push("table_design_edited");
    }
    if ([
      "table_design_alternate_shape_click", "table_design_color_preset_click",
      "table_design_restored", "table_design_reminder_click",
      "table_design_related_prefill_used"
    ].indexOf(type) !== -1) {
      params.hot_reason = type.replace(/^table_design_/, "").slice(0, 100);
      events.push("table_design_hot");
    }

    if (!events.length) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    events.forEach(function (eventName) {
      window.gtag("event", eventName, Object.assign({ send_to: "G-5YTCSZ03NP" }, params));
    });
  }

  window.KB_GA4_TRACK_DESIGN_EVENT = trackGa4DesignEvent;

  function saveQueue() {
    localStorage.setItem(LS_QUEUE, JSON.stringify(queue));
  }

  function enqueueEvent(type, data, page, cart) {
    queue.push({
      type: type,
      data: data || {},
      page: page || window.location.href,
      cart: cart || null,
      ts: new Date().toISOString()
    });
    saveQueue();
  }

  function postEventObject(ev) {
    touchSession();

    var payload = {
      anon_id: anonId,
      lead_id: leadId,
      session_id: sessionId,
      event_type: ev.type,
      event_data: ev.data || {},
      page: ev.page || window.location.href,
      ts: ev.ts || new Date().toISOString(),
      referrer: document.referrer || "",
      ua: navigator.userAgent,
      meta: metaIdentity(),
      google: googleIdentity(),
      manychat: manychatIdentity(),
      shopify: shopifyIdentity()
    };

    if (ev.cart) payload.cart = ev.cart;

    return fetch(API_EVENT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: kbTelo(payload)
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(handleLeadResponse)
      .catch(function () {
        enqueueEvent(ev.type, ev.data, ev.page, ev.cart);
      });
  }

  function flushQueue() {
    if (flushInProgress || !leadId || !queue.length) return;
    flushInProgress = true;
    var copy = queue.slice();
    queue = [];
    saveQueue();

    (function next(i) {
      if (i >= copy.length) {
        flushInProgress = false;
        return;
      }
      postEventObject(copy[i]).finally(function () { next(i + 1); });
    })(0);
  }

  function sendEvent(type, data, opts) {
    opts = opts || {};
    if (isCustomerBrainHelpEvent(type, data || {})) markCustomerBrainHelpIntent(type, data || {});
    if (shouldSkipRecentEvent(type, data || {}, opts.page || window.location.href, opts.cart || null)) {
      log("Skipped duplicate lead event", type);
      return;
    }

    trackGa4DesignEvent(type, data || {});

    var event = {
      type: type,
      data: data || {},
      page: opts.page || window.location.href,
      cart: opts.cart || null,
      ts: new Date().toISOString()
    };

    if (!leadId) {
      enqueueEvent(event.type, event.data, event.page, event.cart);
      return;
    }

    postEventObject(event);
  }

  function collectLead(data) {
    data = data || {};
    rememberContactState(data);
    var shouldTrackMetaLead = !!(data.email || data.phone);

    return initLeadOnce()
      .then(fetchCart)
      .then(function (cart) {
        var payload = {
          anon_id: anonId,
          lead_id: leadId,
          ime: data.ime || data.fname || "",
          prezime: data.prezime || data.lname || "",
          email: data.email || "",
          phone: normalizePhone(data.phone || ""),
          cart: cart,
          page: window.location.href,
          session_id: sessionId,
          event_type: data.event_type || "identify",
          meta: metaIdentity(),
          google: googleIdentity(),
          manychat: manychatIdentity(),
          shopify: shopifyIdentity(),
          extra: data.extra || {}
        };

        return fetch(API_COLLECT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: kbTelo(payload)
        });
      })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (res) {
        handleLeadResponse(res);
        if (shouldTrackMetaLead && res && res.lead_id) trackMetaLeadEvent(res.lead_id);
        return res;
      });
  }

  function normalizeCategoryText(value) {
    value = String(value || "").toLowerCase();
    var map = { "ć": "c", "č": "c", "š": "s", "đ": "dj", "ž": "z" };
    return value.replace(/[ćčšđž]/g, function (match) { return map[match] || match; });
  }

  function detectCustomerBrainCategory(value) {
    value = normalizeCategoryText(value);
    if (value.indexOf("zabranjeno-parkiranje") !== -1 || value.indexOf("zabranjeno parkiranje") !== -1 || value.indexOf("parking") !== -1 || value.indexOf("parkiranje") !== -1) return "zabranjeno_parkiranje";
    if (value.indexOf("objekat-je-pod-video-nadzorom") !== -1 || value.indexOf("video-nadzor") !== -1 || value.indexOf("video nadzor") !== -1 || value.indexOf("nadzor") !== -1) return "video_nadzor";
    if (value.indexOf("podmetac") !== -1 || value.indexOf("podmetaci") !== -1 || value.indexOf("podmetaci-za-case") !== -1 || value.indexOf("case") !== -1) return "podmetac";
    if (value.indexOf("sanduc") !== -1) return "sanduce";
    if (value.indexOf("otirac") !== -1) return "otirac";
    if (value.indexOf("cuvaj-se-psa") !== -1 || value.indexOf("cuvaj se psa") !== -1 || value.indexOf("cuvaj") !== -1) return "cuvaj_se_psa";
    if (value.indexOf("ploc") !== -1 || value.indexOf("vrata") !== -1) return "plocica_vrata";
    if (value.indexOf("kucni") !== -1 || value.indexOf("broj") !== -1 || value.indexOf("oblik-") !== -1) return "kucni_broj";
    return "";
  }

  function customerBrainUrlProfile() {
    var pathname = window.location.pathname || "";
    var cleanPath = ("/" + pathname.replace(/^\/+/, "")).replace(/\/+$/, "") || "/";
    var category = detectCustomerBrainCategory(cleanPath);
    var pageKind = "other";
    var displayAllowed = false;
    var confidence = category ? 0.45 : 0;

    if (cleanPath === "/cart") {
      pageKind = "cart";
      displayAllowed = true;
    } else if (cleanPath.indexOf("/products/") === 0) {
      pageKind = "product";
      displayAllowed = true;
      confidence = category ? 0.95 : 0.6;
    } else if (cleanPath.indexOf("/collections/") === 0) {
      pageKind = "collection";
      displayAllowed = true;
      confidence = category ? 0.8 : 0.45;
    } else if (cleanPath.indexOf("/blogs/") === 0) {
      pageKind = "blog";
      displayAllowed = false;
      confidence = category ? 0.45 : 0;
    } else if (cleanPath.indexOf("/pages/") === 0) {
      var mainLanding = {
        "/pages/kucni-brojevi": "kucni_broj",
        "/pages/plocice-za-vrata": "plocica_vrata",
        "/pages/postanski-sanducici": "sanduce",
        "/pages/brojevi-za-zgrade": "kucni_broj"
      };
      if (mainLanding[cleanPath]) {
        pageKind = "main_landing";
        category = mainLanding[cleanPath];
        displayAllowed = true;
        confidence = 0.75;
      } else if (/^\/pages\/(kucni-brojevi|plocice-za-vrata|postanski-sanducici)-/.test(cleanPath)) {
        pageKind = "city_landing";
        displayAllowed = false;
        confidence = category ? 0.55 : 0;
      } else {
        pageKind = "page";
        displayAllowed = !!category;
        confidence = category ? 0.55 : 0;
      }
    }

    return {
      pathname: cleanPath,
      page_kind: pageKind,
      category: category,
      display_allowed: displayAllowed,
      confidence: confidence
    };
  }

  function currentCustomerBrainCategory() {
    var profile = customerBrainUrlProfile();
    var pathname = window.location.pathname || "";
    var isProductPage = pathname.indexOf("/products/") === 0;
    var parts = [profile.category || pathname];

    if (isProductPage) {
      parts.push((document.querySelector("h1") || {}).innerText || "");
      try {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
          parts.push(window.ShopifyAnalytics.meta.product.type || "");
          parts.push(window.ShopifyAnalytics.meta.product.vendor || "");
          parts.push(window.ShopifyAnalytics.meta.product.id || "");
        }
      } catch (e) {}
    }

    return detectCustomerBrainCategory(parts.join(" "));
  }

  function isHouseNumberProductPage() {
    var pathname = window.location.pathname || "";
    return pathname.indexOf("/products/") === 0 && currentCustomerBrainCategory() === "kucni_broj";
  }

  function loadGsFormsEmbed() {
    if (window.GSForms && typeof window.GSForms.openPopup === "function") {
      return Promise.resolve(window.GSForms);
    }
    if (gsFormsEmbedPromise) return gsFormsEmbedPromise;

    gsFormsEmbedPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector("script[data-kb-gs-forms-embed]");
      if (existing) {
        existing.addEventListener("load", function () { resolve(window.GSForms || null); }, { once: true });
        existing.addEventListener("error", reject, { once: true });
        return;
      }

      var script = document.createElement("script");
      script.src = FORMS_EMBED_URL;
      script.async = true;
      script.setAttribute("data-kb-gs-forms-embed", "1");
      script.onload = function () { resolve(window.GSForms || null); };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return gsFormsEmbedPromise;
  }

  function openHouseNumberDesignerForm(source) {
    if (!isHouseNumberProductPage()) return false;
    try {
      sendEvent("floating_action_click", {
        action: "designer_help",
        source: source || "house_number_product",
        form_slug: DESIGNER_HELP_FORM_SLUG,
        product_handle: getCurrentProductHandle()
      });
    } catch (e) {}

    loadGsFormsEmbed().then(function (forms) {
      if (forms && typeof forms.openPopup === "function") {
        forms.openPopup(DESIGNER_HELP_FORM_SLUG);
      } else if (typeof window.gsShowPopup === "function") {
        window.gsShowPopup();
      }
    }).catch(function () {
      if (typeof window.gsShowPopup === "function") window.gsShowPopup();
    });
    return true;
  }

  function isCustomerBrainHelpEvent(type, data) {
    type = String(type || "");
    data = data || {};
    if (type === "contact_intent_submit" || type.indexOf("contact_request_") === 0) return true;
    if (type !== "floating_action_click") return false;
    return ["open_help_panel", "sms", "viber", "whatsapp", "designer_help"].indexOf(String(data.action || "")) !== -1;
  }

  function markCustomerBrainHelpIntent(type, data) {
    try {
      sessionStorage.setItem(SS_CUSTOMER_BRAIN_HELP_INTENT, JSON.stringify({
        at: Date.now(),
        type: type || "",
        action: data && data.action ? String(data.action) : ""
      }));
    } catch (e) {}
  }

  function hasCustomerBrainHelpIntent() {
    try {
      var raw = sessionStorage.getItem(SS_CUSTOMER_BRAIN_HELP_INTENT);
      if (raw === "1") {
        sessionStorage.removeItem(SS_CUSTOMER_BRAIN_HELP_INTENT);
        return false;
      }
      var state = safeJsonParse(raw, null);
      if (state && state.at && Date.now() - parseInt(state.at, 10) < CUSTOMER_BRAIN_HELP_INTENT_MS) return true;
      if (raw) sessionStorage.removeItem(SS_CUSTOMER_BRAIN_HELP_INTENT);
    } catch (e) {}
    return !!window.kbAnyPopupOpen || !!window.kbLeadPopupOpen;
  }

  function logCustomerBrainDecisionEvent(decisionId, eventType, payload) {
    if (!decisionId) return Promise.resolve(null);

    var body = kbTelo({
      decision_id: decisionId,
      event_type: eventType,
      anon_id: anonId,
      lead_id: leadId,
      session_id: sessionId,
      payload: payload || {}
    });

    if (eventType === "click" && navigator.sendBeacon) {
      try {
        var blob = new Blob([body], { type: "text/plain;charset=UTF-8" });
        if (navigator.sendBeacon(API_DECISION_EVENT, blob)) {
          return Promise.resolve({ status: "queued_beacon" });
        }
      } catch (e) {}
    }

    return fetch(API_DECISION_EVENT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: body,
      keepalive: eventType === "click"
    }).then(function (r) {
      return r.json().catch(function () { return {}; });
    }).catch(function () {
      return null;
    });
  }

  function customerBrainElementVisible(node) {
    if (!node || !node.getBoundingClientRect) return false;
    var current = node;
    while (current && current !== document.documentElement) {
      var style = window.getComputedStyle ? window.getComputedStyle(current) : null;
      if (style && (style.display === "none" || style.visibility === "hidden" || style.opacity === "0")) return false;
      current = current.parentElement;
    }
    var rect = node.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function customerBrainFirstVisible(selector, root) {
    var nodes = (root || document).querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (customerBrainElementVisible(nodes[i])) return nodes[i];
    }
    return null;
  }

  /* Prazan slot se ne sme meriti.

     customerBrainElementVisible trazi nenultu velicinu, a prazan slot je nema.
     Povrh toga, tema sakriva prazan slot pravilom nad :empty, pa mu je i
     display "none" — izmereno u draweru: prazan "none", sa sadrzajem "block"
     363x27. Oba uslova nestaju cim se ponuda ubaci, pa ni jedan nije merilo
     da li slot valja.

     Zato se preskace i velicina i sopstveni display slota; provera krece od
     roditelja. Granica je prosledjeni root — njega je pozivalac vec proverio
     punom proverom (cart-drawer.active mora biti vidljiv i nenulte velicine).

     Bez ovoga je ponuda u draweru zavrsavala u .drawer__footer, gde je na
     pravo mesto dolazila samo slucajno: dobijala je podrazumevani order 0 u
     flex koloni footera. */

  function customerBrainSlotUsable(node, root) {
    var granica = root && root.nodeType === 1 ? root : document.documentElement;
    var current = node.parentElement;
    while (current && current !== granica && current !== document.documentElement) {
      var style = window.getComputedStyle ? window.getComputedStyle(current) : null;
      if (style && (style.display === "none" || style.visibility === "hidden" || style.opacity === "0")) return false;
      current = current.parentElement;
    }
    return !!current;
  }

  function customerBrainSlot(name, root) {
    var nodes = (root || document).querySelectorAll('[data-customer-brain-slot="' + name + '"]');
    for (var i = 0; i < nodes.length; i++) {
      if (customerBrainSlotUsable(nodes[i], root)) return nodes[i];
    }
    return null;
  }

  function customerBrainWizardFinalSlot() {
    var roots = document.querySelectorAll("[data-kb-table-designer]");
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (!customerBrainElementVisible(root)) continue;
      if ((root.getAttribute("data-kb-active-step") || "") !== "details") continue;
      var slot = customerBrainSlot("wizard-final", root);
      if (slot) return slot;
    }
    return null;
  }

  function customerBrainHasVisibleWizard() {
    var roots = document.querySelectorAll("[data-kb-table-designer]");
    for (var i = 0; i < roots.length; i++) {
      if (customerBrainElementVisible(roots[i])) return true;
    }
    return false;
  }

  function customerBrainCartDrawerMountPoint() {
    var root = customerBrainFirstVisible("cart-drawer.active")
      || customerBrainFirstVisible("cart-drawer.is-open")
      || customerBrainFirstVisible("#CartDrawer.active")
      || customerBrainFirstVisible("#CartDrawer.is-open")
      || customerBrainFirstVisible(".cart-drawer.active")
      || customerBrainFirstVisible(".cart-drawer.is-open");
    if (!root) return null;
    return customerBrainSlot("cart-drawer-upsell", root)
      || customerBrainFirstVisible(".drawer__footer", root);
  }

  function customerBrainCartPageMountPoint() {
    return customerBrainSlot("cart-page-upsell")
      || customerBrainFirstVisible("cart-items")
      || customerBrainFirstVisible(".cart-items")
      || customerBrainFirstVisible("form[action='/cart']")
      || customerBrainFirstVisible("form[action*='/cart']")
      || customerBrainFirstVisible("#main-cart-footer")
      || customerBrainFirstVisible(".cart__footer");
  }

  function customerBrainProductMountPoint() {
    var wizardSlot = customerBrainWizardFinalSlot();
    if (wizardSlot) return wizardSlot;
    var productSlot = customerBrainSlot("product-inline");
    if (productSlot) return productSlot;
    if (customerBrainHasVisibleWizard()) return null;
    return customerBrainSlot("special-product-final")
      || customerBrainFirstVisible(".otr-atc-form")
      || customerBrainFirstVisible(".pdm-atc-form")
      || customerBrainFirstVisible("form[action*='/cart/add']");
  }

  function customerBrainPageMountPoint() {
    return customerBrainSlot("page-inline");
  }

  /*
    Posle „Dodaj u korpu" konfigurator vodi na /pages/upotpunite-dom
    (ukljuceno 01.10.2026. preko settings.kb_post_cart_page, od tada
    zacementirano u flowPostCartDestination()), a od 12.10.2026. i /cart
    renderuje istu sekciju upotpunite-dom-visual.liquid. Obe adrese su ISTA
    povrsina — korpa. Lista, ne regex, da se vidi sta je tacno obuhvaceno.
  */
  var CUSTOMER_BRAIN_CART_PATHS = ["/cart", "/pages/upotpunite-dom"];

  function customerBrainIsCartSurface() {
    var p = window.location.pathname.replace(/\/+$/, "");
    for (var i = 0; i < CUSTOMER_BRAIN_CART_PATHS.length; i++) {
      if (p === CUSTOMER_BRAIN_CART_PATHS[i]) return true;
    }
    return false;
  }

  function customerBrainMountPoint() {
    /* Kada je fioka otvorena ona je bliza oku od inline slota, pa ide prva. */
    if (customerBrainIsCartSurface()) {
      return customerBrainCartDrawerMountPoint() || customerBrainCartPageMountPoint();
    }
    if (window.location.pathname.indexOf("/products/") === 0) {
      return customerBrainCartDrawerMountPoint() || customerBrainProductMountPoint();
    }
    return customerBrainCartDrawerMountPoint() || customerBrainPageMountPoint();
  }

  function scheduleCustomerBrainDecisionWhenMountReady(source) {
    if (!CUSTOMER_BRAIN_ENABLED || isCheckoutPage()) return;
    if (customerBrainMountReadyTimer) clearTimeout(customerBrainMountReadyTimer);
    customerBrainMountReadyTimer = setTimeout(function () {
      customerBrainMountReadyTimer = null;
      if (document.querySelector(".kbCustomerBrainOffer")) return;
      var currentCategory = currentCustomerBrainCategory();
      if (!currentCategory && cartItemCount(latestCartSnapshot) <= 0) return;
      if (!customerBrainMountPoint()) return;
      requestCustomerBrainDecision({ source: source || "mount_ready" });
    }, 300);
  }

  function setupCustomerBrainMountObserver() {
    if (!CUSTOMER_BRAIN_ENABLED || !document.body || typeof MutationObserver === "undefined") return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === "childList" && mutations[i].addedNodes && mutations[i].addedNodes.length) {
          scheduleCustomerBrainDecisionWhenMountReady("mount_child");
          return;
        }
        if (mutations[i].type === "attributes") {
          scheduleCustomerBrainDecisionWhenMountReady("mount_attr");
          return;
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "data-kb-active-step", "open"]
    });
  }

  function customerBrainPlacementContext(mount) {
    /* Provera fioke ide PRE adrese: montaza u fioci je 'cart_drawer' svuda,
       pa i na /cart. Ranije je /cart knjizio i fiocne prikaze kao 'cart_page'. */
    if (mount && mount.closest && mount.closest("cart-drawer, #CartDrawer, .cart-drawer")) return "cart_drawer";
    if (mount && mount.matches && mount.matches("cart-drawer, #CartDrawer, .cart-drawer, .drawer__footer")) return "cart_drawer";
    if (customerBrainIsCartSurface()) return "cart_page";
    return "product";
  }

  function customerBrainOfferEyebrow(offer, placement) {
    if (placement === "cart_drawer" || placement === "cart_page") return "Odlično se slažu";
    if (offer && (offer.target_category === "postansko_sanduce" || offer.target_category === "sanduce")) return "Često se kupuje uz kućni broj";
    if (offer && offer.target_category === "plocica_vrata") return "Predlog za kompletiranje ulaza";
    if (offer && offer.target_category === "otirac") return "Predlog za ulazna vrata";
    if (offer && offer.target_category === "kucni_broj") return "Kupci često dodaju i kućni broj";
    if (offer && (offer.target_category === "video_nadzor" || offer.target_category === "zabranjeno_parkiranje")) return "Predlog za kapiju i objekat";
    if (offer && offer.target_category === "podmetac") return "Personalizovani detalj za dom";
    if (offer && offer.target_category === "cuvaj_se_psa") return "Sigurnosna oznaka za ulaz";
    return "Predlog za kompletiranje";
  }

  function customerBrainOfferMeta(offer, placement) {
    var meta = [];
    if (offer && offer.price_label) meta.push(offer.price_label);
    if (placement === "cart_drawer" || placement === "cart_page") meta.push("Personalizacija");
    return meta;
  }

  function customerBrainTargetName(offer) {
    var category = offer && offer.target_category ? String(offer.target_category) : "";
    if (category === "kucni_broj") return "bilo koji kućni broj";
    if (offer && offer.product_title) return offer.product_title;
    var names = {
      sanduce: "poštansko sanduče",
      postansko_sanduce: "poštansko sanduče",
      otirac: "personalizovani otirač",
      kucni_broj: "kućni broj",
      plocica_vrata: "pločicu za vrata",
      video_nadzor: "oznaku za video nadzor",
      zabranjeno_parkiranje: "oznaku za zabranjeno parkiranje",
      cuvaj_se_psa: "tablu čuvaj se psa",
      podmetac: "personalizovane podmetače"
    };
    return names[category] || "preporučeni proizvod";
  }

  function customerBrainTargetButtonName(offer) {
    var category = offer && offer.target_category ? String(offer.target_category) : "";
    if (category === "kucni_broj") return "kućni broj";
    return customerBrainTargetName(offer);
  }

  function customerBrainDeliveryPhrase(offer) {
    return "preporučeni proizvod";
  }

  function customerBrainNoticeTargetPhrase(offer) {
    return customerBrainTargetName(offer);
  }

  function customerBrainFormatRsd(value) {
    var amount = Number(value || 0);
    if (!isFinite(amount) || amount <= 0) return "";
    return Math.round(amount).toLocaleString("sr-RS") + " RSD";
  }

  function customerBrainIncentiveCopy(offer) {
    if (!offer || !offer.incentive) return null;
    var target = customerBrainTargetName(offer);
    var buttonTarget = customerBrainTargetButtonName(offer);
    var deliveryPhrase = customerBrainDeliveryPhrase(offer);
    var amount = customerBrainFormatRsd(offer.incentive.amount_rsd);
    var hours = Number(offer.incentive.expires_in_hours || 12);
    if (!isFinite(hours) || hours <= 0) hours = 12;
    return {
      target: target,
      amount: amount,
      title: amount ? amount + " popusta" : "Kod za " + target,
      body: amount
        ? "Važi " + hours + " sati i samo za " + deliveryPhrase + "."
        : "Važi " + hours + " sati i samo za preporučeni proizvod.",
      button: amount ? "Preuzmi " + amount : "Preuzmi kod"
    };
  }

  function customerBrainCouponPopupKey(decisionId, offer) {
    return [sessionId || "", decisionId || "", (offer && offer.offer_key) || "", (offer && offer.target_category) || ""].join("|");
  }

  function customerBrainCouponPopupDismissed() {
    try {
      var until = parseInt(localStorage.getItem(LS_CUSTOMER_BRAIN_COUPON_POPUP_DISMISSED_UNTIL) || "0", 10);
      return !!until && Date.now() < until;
    } catch (e) {
      return false;
    }
  }

  function customerBrainCanShowCouponPopup(decision, offer, placement) {
    if (!CUSTOMER_BRAIN_COUPON_POPUP_ENABLED) return false;
    if (!decision || !offer || !offer.incentive) return false;
    if (placement !== "cart_drawer" && placement !== "cart_page") return false;
    if (isCheckoutPage()) return false;
    if (window.kbAnyPopupOpen || window.kbLeadPopupOpen) return false;
    if (customerBrainActiveIncentive()) return false;
    if (document.querySelector(".kbCustomerBrainCouponOverlay")) return false;
    try {
      if (sessionStorage.getItem(SS_CUSTOMER_BRAIN_COUPON_POPUP) === customerBrainCouponPopupKey(decision.decision_id || offer.decision_id, offer)) return false;
      var lastShownAt = parseInt(localStorage.getItem(LS_LAST_POPUP_SHOWN_AT) || "0", 10);
      if (lastShownAt && Date.now() - lastShownAt < GLOBAL_POPUP_COOLDOWN_MS) return false;
    } catch (e) {}
    if (customerBrainCouponPopupDismissed()) return false;
    return true;
  }

  function closeCustomerBrainCouponPopup(markDismissed) {
    var overlay = document.querySelector(".kbCustomerBrainCouponOverlay");
    var popup = document.querySelector(".kbCustomerBrainCouponPopup");
    if (overlay) overlay.remove();
    if (popup) popup.remove();
    if (markDismissed) {
      try { localStorage.setItem(LS_CUSTOMER_BRAIN_COUPON_POPUP_DISMISSED_UNTIL, String(Date.now() + CUSTOMER_BRAIN_COUPON_POPUP_DISMISS_MS)); } catch (e) {}
    }
    releasePopupLock();
  }

  function renderCustomerBrainCouponPopup(decision, offer, placement, linkHref) {
    var decisionId = decision && (decision.decision_id || (offer && offer.decision_id));
    var incentiveCopy = customerBrainIncentiveCopy(offer);
    if (!decisionId || !incentiveCopy || !customerBrainCanShowCouponPopup(decision, offer, placement)) return false;

    injectCustomerBrainStyles();
    markPopupShown();
    try { sessionStorage.setItem(SS_CUSTOMER_BRAIN_COUPON_POPUP, customerBrainCouponPopupKey(decisionId, offer)); } catch (e) {}

    var overlay = document.createElement("div");
    overlay.className = "kbCustomerBrainCouponOverlay";

    var popup = document.createElement("div");
    popup.className = "kbCustomerBrainCouponPopup";
    popup.setAttribute("role", "dialog");
    popup.setAttribute("aria-modal", "true");
    popup.setAttribute("aria-label", "Posebna ponuda za preporučeni proizvod");
    popup.innerHTML = [
      '<button class="kbCustomerBrainCouponPopupClose" type="button" aria-label="Zatvori">×</button>',
      '<p class="kbCustomerBrainCouponPopupEyebrow">Posebna ponuda</p>',
      '<div class="kbCustomerBrainCouponPopupGrid">',
      '<a class="kbCustomerBrainCouponPopupMedia" href="#"><img alt="" loading="lazy"></a>',
      '<div class="kbCustomerBrainCouponPopupCopy">',
      '<h2 class="kbCustomerBrainCouponPopupTitle"></h2>',
      '<p class="kbCustomerBrainCouponPopupBody"></p>',
      '<p class="kbCustomerBrainCouponPopupNote"></p>',
      '<div class="kbCustomerBrainCouponPopupActions"><button class="kbCustomerBrainCouponPopupPrimary" type="button"></button><a class="kbCustomerBrainCouponPopupSecondary" href="#"></a></div>',
      '<button class="kbCustomerBrainCouponPopupSkip" type="button">Ne sada</button>',
      '</div>',
      '</div>'
    ].join("");

    var targetName = customerBrainTargetName(offer);
    var amount = incentiveCopy.amount || "";
    var targetUrl = linkHref || offer.url || "/collections/all";
    popup.querySelector(".kbCustomerBrainCouponPopupTitle").textContent = amount ? amount + " popusta za " + targetName : "Sačuvaj kod za " + targetName;
    popup.querySelector(".kbCustomerBrainCouponPopupBody").textContent = offer.body || ("Kupci često uz trenutnu porudžbinu dodaju i " + targetName + ".");
    popup.querySelector(".kbCustomerBrainCouponPopupNote").textContent = amount
      ? "Važi 12 sati. Samo za ovaj proizvod, ne za ostale proizvode u korpi."
      : "Važi 12 sati i samo za ovaj proizvod.";

    var media = popup.querySelector(".kbCustomerBrainCouponPopupMedia");
    var mediaImage = media ? media.querySelector("img") : null;
    if (offer.image_url && media && mediaImage) {
      media.href = targetUrl;
      mediaImage.src = offer.image_url;
      mediaImage.alt = offer.product_title || offer.title || targetName;
    } else if (media) {
      media.style.display = "none";
    }

    var primary = popup.querySelector(".kbCustomerBrainCouponPopupPrimary");
    var secondary = popup.querySelector(".kbCustomerBrainCouponPopupSecondary");
    primary.textContent = amount ? "Preuzmi " + amount : incentiveCopy.button;
    secondary.textContent = "Pogledaj " + customerBrainTargetButtonName(offer);
    secondary.href = targetUrl;

    function logPopupEvent(type, extra) {
      extra = extra || {};
      extra.offer_key = offer.offer_key || "";
      extra.target_category = offer.target_category || "";
      extra.placement = placement;
      extra.ui = "coupon_popup";
      return logCustomerBrainDecisionEvent(decisionId, type, extra);
    }

    function dismissPopup() {
      logPopupEvent("dismiss", { dismiss_ui: "coupon_popup" });
      closeCustomerBrainCouponPopup(true);
    }

    overlay.addEventListener("click", dismissPopup);
    popup.querySelector(".kbCustomerBrainCouponPopupClose").addEventListener("click", dismissPopup);
    popup.querySelector(".kbCustomerBrainCouponPopupSkip").addEventListener("click", dismissPopup);
    secondary.addEventListener("click", function () {
      logPopupEvent("click", { url: targetUrl, action: "view_product" });
      closeCustomerBrainCouponPopup(false);
    });
    if (media) {
      media.addEventListener("click", function () {
        logPopupEvent("click", { url: targetUrl, action: "image_view_product" });
        closeCustomerBrainCouponPopup(false);
      });
    }

    primary.addEventListener("click", function () {
      primary.disabled = true;
      primary.textContent = "Čuvamo kod...";
      reserveCustomerBrainIncentive(decisionId, offer).then(function (result) {
        if (result && result.status === "ok" && result.code) {
          rememberCustomerBrainIncentive(result, offer);
          logPopupEvent("click", {
            url: result.discount_url || targetUrl,
            coupon_code: result.code,
            incentive_reserved: true,
            action: "reserve_coupon"
          });
          closeCustomerBrainCouponPopup(false);
          window.location.href = result.discount_url || targetUrl;
          return;
        }
        logPopupEvent("click", { url: targetUrl, action: "reserve_coupon_failed" });
        closeCustomerBrainCouponPopup(false);
        window.location.href = targetUrl;
      }).catch(function () {
        logPopupEvent("click", { url: targetUrl, action: "reserve_coupon_error" });
        closeCustomerBrainCouponPopup(false);
        window.location.href = targetUrl;
      });
    });

    document.body.appendChild(overlay);
    document.body.appendChild(popup);
    logPopupEvent("impression", { incentive_popup: true });
    return true;
  }

  function customerBrainActiveIncentive() {
    if (!window.localStorage) return null;
    var notice = null;
    try {
      notice = safeJsonParse(localStorage.getItem(LS_CUSTOMER_BRAIN_INCENTIVE), null);
    } catch (e) {
      return null;
    }

    if (!notice || !notice.code) return null;
    var expiresAt = notice.expires_at ? Date.parse(String(notice.expires_at).replace(" ", "T")) : 0;
    if (expiresAt && Date.now() > expiresAt) {
      try { localStorage.removeItem(LS_CUSTOMER_BRAIN_INCENTIVE); } catch (e) {}
      return null;
    }

    notice.expires_at_ts = expiresAt || 0;
    return notice;
  }

  function customerBrainActiveTimeLeft(notice) {
    var expiresAt = notice && notice.expires_at_ts ? Number(notice.expires_at_ts) : 0;
    if (!expiresAt) return "";
    var minutes = Math.max(1, Math.ceil((expiresAt - Date.now()) / (60 * 1000)));
    var hours = Math.floor(minutes / 60);
    var rest = minutes % 60;
    if (hours <= 0) return rest + " min";
    if (rest <= 0) return hours + "h";
    return hours + "h " + rest + "m";
  }

  function renderCustomerBrainActiveIncentive(notice) {
    notice = notice || customerBrainActiveIncentive();
    if (!notice || document.querySelector(".kbCustomerBrainOffer")) return !!notice;

    var mount = customerBrainMountPoint();
    if (!mount) return false;

    injectCustomerBrainStyles();

    var placement = customerBrainPlacementContext(mount);
    var currentCategory = currentCustomerBrainCategory();
    var sameTarget = currentCategory && notice.target_category && currentCategory === notice.target_category;
    var targetName = notice.target_name || "preporučeni proizvod";
    var targetUrl = notice.target_url || "/cart";
    var discountUrl = notice.discount_url || ("/discount/" + encodeURIComponent(notice.code) + "?redirect=" + encodeURIComponent(targetUrl));
    var timeLeft = customerBrainActiveTimeLeft(notice);
    var amount = notice.amount_label || customerBrainFormatRsd(notice.amount_rsd);

    var box = document.createElement("div");
    box.className = "kbCustomerBrainOffer kbCustomerBrainOffer--activeCoupon kbCustomerBrainOffer--" + (placement === "cart_drawer" ? "cartDrawer" : (placement === "cart_page" ? "cartPage" : "product"));
    box.setAttribute("data-placement", placement);
    box.innerHTML = [
      '<div class="kbCustomerBrainOfferInner">',
      '<button class="kbCustomerBrainOfferClose" type="button" aria-label="Zatvori">×</button>',
      '<div class="kbCustomerBrainOfferEyebrow"><span class="kbCustomerBrainOfferDot"></span><span></span></div>',
      '<div class="kbCustomerBrainOfferContent">',
      '<div class="kbCustomerBrainOfferCopy">',
      '<p class="kbCustomerBrainOfferTitle"></p>',
      '<p class="kbCustomerBrainOfferBody"></p>',
      '<div class="kbCustomerBrainOfferMeta"></div>',
      '<div class="kbCustomerBrainOfferIncentive"><p class="kbCustomerBrainOfferIncentiveTitle"></p><p class="kbCustomerBrainOfferIncentiveBody"></p></div>',
      '<div class="kbCustomerBrainOfferActions"><a class="kbCustomerBrainOfferLink" href="#"></a><a class="kbCustomerBrainOfferCoupon" href="#"></a></div>',
      '</div>',
      '</div>',
      '</div>'
    ].join("");

    box.querySelector(".kbCustomerBrainOfferEyebrow span:last-child").textContent = sameTarget ? "Kod važi za ovaj proizvod" : "Imaš aktivan kod";
    box.querySelector(".kbCustomerBrainOfferTitle").textContent = sameTarget ? "Iskoristi sačuvan kod" : "Sačuvan kod za " + targetName;
    box.querySelector(".kbCustomerBrainOfferBody").textContent = sameTarget
      ? "Kod " + notice.code + " je spreman za ovu kupovinu."
      : "Kod " + notice.code + " važi za " + targetName + ". Vrati se na proizvod za koji je rezervisan.";

    var metaNode = box.querySelector(".kbCustomerBrainOfferMeta");
    [notice.code, amount, timeLeft ? ("Još " + timeLeft) : ""].forEach(function (text) {
      if (!text) return;
      var item = document.createElement("span");
      item.textContent = text;
      metaNode.appendChild(item);
    });
    if (!metaNode.childNodes.length) metaNode.style.display = "none";

    var incentiveNode = box.querySelector(".kbCustomerBrainOfferIncentive");
    if (incentiveNode) {
      incentiveNode.querySelector(".kbCustomerBrainOfferIncentiveTitle").textContent = "Kod je već preuzet";
      incentiveNode.querySelector(".kbCustomerBrainOfferIncentiveBody").textContent = amount
        ? "Vrednost koda je " + amount + " za preporučenu kupovinu. Možeš ga primeniti odmah ili otvoriti proizvod za koji važi."
        : "Možeš ga primeniti odmah ili otvoriti proizvod za koji važi.";
      incentiveNode.style.display = "block";
    }

    var targetLink = box.querySelector(".kbCustomerBrainOfferLink");
    targetLink.href = targetUrl;
    targetLink.textContent = sameTarget ? "Nastavi kupovinu" : "Pogledaj proizvod";

    var applyLink = box.querySelector(".kbCustomerBrainOfferCoupon");
    applyLink.href = discountUrl;
    applyLink.textContent = "Primeni kod";

    function trackActiveCouponClick(kind) {
      try {
        sendEvent("customer_brain_active_coupon_click", {
          code: notice.code,
          offer_key: notice.offer_key || "",
          target_category: notice.target_category || "",
          click_type: kind || "open",
          placement: placement
        });
      } catch (e) {}
    }

    targetLink.addEventListener("click", function () { trackActiveCouponClick("target"); });
    applyLink.addEventListener("click", function () { trackActiveCouponClick("apply"); });
    box.querySelector(".kbCustomerBrainOfferClose").addEventListener("click", function () {
      try {
        sendEvent("customer_brain_active_coupon_dismiss", {
          code: notice.code,
          offer_key: notice.offer_key || "",
          target_category: notice.target_category || "",
          placement: placement
        });
      } catch (e) {}
      box.remove();
    });

    if (mount.matches && mount.matches("[data-customer-brain-slot]")) {
      mount.appendChild(box);
    } else if (mount.matches && mount.matches(".kb-table-designer__actions")) {
      mount.insertAdjacentElement("beforebegin", box);
    } else if (mount.matches && mount.matches(".kb-table-designer")) {
      var designerActions = customerBrainFirstVisible(".kb-table-designer__actions", mount);
      if (designerActions) designerActions.insertAdjacentElement("beforebegin", box);
      else mount.appendChild(box);
    } else if (mount.matches && mount.matches(".kbr-hcfg__panel")) {
      var panelActions = customerBrainFirstVisible(".kb-table-designer__actions", mount);
      if (panelActions) panelActions.insertAdjacentElement("beforebegin", box);
      else mount.appendChild(box);
    } else if (mount.matches && mount.matches(".otr-atc-form, .pdm-atc-form")) {
      var specialAddButton = mount.querySelector("button[name='add'], button[type='submit'], input[type='submit']");
      if (specialAddButton) specialAddButton.insertAdjacentElement("beforebegin", box);
      else mount.insertAdjacentElement("beforeend", box);
    } else if (mount.matches && mount.matches("form[action*='/cart/add']")) {
      mount.insertAdjacentElement("afterend", box);
    } else if (mount.matches && mount.matches("cart-drawer .drawer__footer, #CartDrawer .drawer__footer, .drawer__footer")) {
      mount.insertAdjacentElement("beforebegin", box);
    } else if (mount.matches && mount.matches("#main-cart-footer, .cart__footer")) {
      mount.insertAdjacentElement("afterbegin", box);
    } else if (mount.matches && mount.matches("form[action='/cart'], form[action*='/cart'], cart-items, .cart-items")) {
      mount.insertAdjacentElement("afterend", box);
    } else if (mount.matches && mount.matches("main")) {
      mount.insertAdjacentElement("afterbegin", box);
    } else {
      mount.appendChild(box);
    }

    return true;
  }

  function injectCustomerBrainStyles() {
    if (document.getElementById("kbCustomerBrainStyles")) return;
    var style = document.createElement("style");
    style.id = "kbCustomerBrainStyles";
    style.textContent = [
      ".kbCustomerBrainOffer{margin:12px 0;border:1px solid rgba(232, 138, 45,.28);background:#fff;border-radius:0;color:#2b2b2b;font-family:inherit;box-shadow:0 6px 18px rgba(18, 18, 18,0.06);overflow:hidden}",
      ".kbCustomerBrainOfferEyebrow{display:flex;align-items:center;gap:8px;padding:9px 12px;border-bottom:1px solid rgba(232, 138, 45,.16);background:#fdf4ea;color:#6b3c0f;font-size:12px;font-weight:650;line-height:1.2;letter-spacing:0}",
      ".kbCustomerBrainOfferDot{width:8px;height:8px;border-radius:999px;background:#e88a2d;flex:0 0 auto}",
      ".kbCustomerBrainOfferTitle{margin:0 30px 5px 0;font-size:16px;font-weight:650;line-height:1.24;letter-spacing:0;color:#121212}",
      ".kbCustomerBrainOfferBody{margin:0 0 8px 0;font-size:13px;line-height:1.45;color:#595959}",
      ".kbCustomerBrainOfferMeta{display:flex;flex-wrap:wrap;gap:7px;margin:0 0 10px 0}",
      ".kbCustomerBrainOfferMeta span{display:inline-flex;align-items:center;min-height:25px;padding:4px 8px;border-radius:999px;background:#f4f1ec;border:1px solid #e3ddd3;color:#4d4d4d;font-size:12px;font-weight:600;line-height:1}",
      ".kbCustomerBrainPersonalTextPrompt{display:none;margin:0 0 10px 0;padding:11px;border-radius:0;background:#fdf4ea;border:1px solid rgba(232, 138, 45,.24)}",
      ".kbCustomerBrainPersonalTextPrompt label{display:block;margin:0 0 7px 0;font-size:12px;font-weight:650;color:#5f3a12}",
      ".kbCustomerBrainPersonalTextPromptRow{display:flex;gap:8px;align-items:stretch}",
      ".kbCustomerBrainPersonalTextInput{min-width:0;flex:1;height:42px;border:1px solid rgba(18, 18, 18,.18);border-radius:0;padding:9px 11px;font-size:14px;color:#121212;background:#fff;box-shadow:inset 0 1px 0 rgba(18, 18, 18,.03)}",
      ".kbCustomerBrainPersonalTextInput:focus{outline:2px solid rgba(232, 138, 45,.20);border-color:#e88a2d}",
      ".kbCustomerBrainPersonalTextSave{height:42px;border:0;border-radius:0;padding:9px 13px;background:#121212;color:#fff;font-size:13px;font-weight:650;cursor:pointer;white-space:nowrap}",
      ".kbCustomerBrainPersonalTextSave:hover{background:#121212}",
      ".kbCustomerBrainPersonalTextHint{margin:7px 0 0;color:#6e6e6e;font-size:11px;line-height:1.35}",
      ".kbCustomerBrainOfferIncentive{display:none;margin:0 0 10px 0;padding:9px 10px;border-radius:0;background:#fdf4ea;border:1px solid rgba(232, 138, 45,.28);color:#4b2c08}",
      ".kbCustomerBrainOfferIncentiveTitle{margin:0 0 3px 0;font-size:12px;font-weight:650;line-height:1.25;color:#7a4512}",
      ".kbCustomerBrainOfferIncentiveBody{margin:0;font-size:12px;line-height:1.35;color:#5f3a12}",
      ".kbCustomerBrainOfferActions{display:flex;gap:9px;align-items:center;flex-wrap:wrap}",
      ".kbCustomerBrainOfferLink{display:inline-flex;align-items:center;justify-content:center;min-height:40px;padding:9px 14px;border-radius:0;background:#e88a2d;color:#fff;text-decoration:none;font-size:13px;font-weight:650;box-shadow:0 4px 10px rgba(232, 138, 45,0.1)}",
      ".kbCustomerBrainOfferLink:hover{background:#d97a1f;color:#fff;text-decoration:none}",
      ".kbCustomerBrainOfferCoupon{display:inline-flex;align-items:center;justify-content:center;min-height:40px;padding:9px 13px;border-radius:0;border:1px solid #e88a2d;background:#fff;color:#9c5a1a;font-size:13px;font-weight:650;cursor:pointer}",
      ".kbCustomerBrainOfferCoupon:hover{background:#fdf4ea;color:#7a4512}",
      ".kbCustomerBrainOfferCoupon[disabled]{opacity:.65;cursor:wait}",
      ".kbCustomerBrainOfferSkip{display:inline-flex;align-items:center;min-height:36px;padding:6px 4px;border:0;background:transparent;color:#595959;font-size:13px;font-weight:500;cursor:pointer}",
      ".kbCustomerBrainOfferSkip:hover{color:#121212;text-decoration:underline}",
      ".kbCustomerBrainOfferClose{position:absolute;top:6px;right:6px;width:30px;height:30px;border:0;border-radius:999px;background:transparent;color:#6e6e6e;font-size:22px;line-height:1;cursor:pointer;z-index:1}",
      ".kbCustomerBrainOfferClose:hover{background:#f2f2f2;color:#121212}",
      ".kbCustomerBrainOfferInner{position:relative}",
      ".kbCustomerBrainOfferContent{display:flex;gap:13px;align-items:center;min-width:0;padding:12px}",
      ".kbCustomerBrainOfferMedia{display:none;flex:0 0 96px;width:96px;height:88px;border-radius:0;overflow:hidden;background:#f4f1ec;border:1px solid rgba(31,41,55,.10)}",
      ".kbCustomerBrainOfferMedia img{display:block;width:100%;height:100%;object-fit:cover}",
      ".kbCustomerBrainOfferCopy{min-width:0;flex:1}",
      ".kbCustomerBrainOffer--cartDrawer{margin:10px 12px 14px;background:#121212;border-color:#121212;color:#fff;box-shadow:none}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferEyebrow{padding:0 0 8px;border:0;background:transparent;color:#121212;font-size:15px;font-weight:650}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferInner{background:#fff}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferContent{background:#121212;color:#fff;padding:10px;gap:10px}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferTitle{color:#f0a45c;font-size:14px;margin-right:24px}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferBody{color:#dfdfdf;font-size:12px}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainPersonalTextPrompt{background:#121212;border-color:rgba(255,173,70,.28)}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainPersonalTextPrompt label{color:#f0a45c}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainPersonalTextInput{background:#fff;color:#121212}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainPersonalTextSave{background:#f0a45c;color:#121212}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainPersonalTextHint{color:#d5d5d5}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferIncentive{background:rgba(255,173,70,.12);border-color:rgba(255,173,70,.35);color:#fff}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferIncentiveTitle{color:#f0a45c}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferIncentiveBody{color:#f2f2f2}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferMedia{flex-basis:74px;width:74px;height:74px}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferMeta span{background:rgba(255,255,255,.09);border-color:rgba(255,255,255,.12);color:#f4f4f4}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferClose{color:#fff;background:rgba(255,255,255,.08)}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferSkip{color:#f4f4f4}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferCoupon{background:#121212;color:#fff;border-color:#f0a45c}",
      ".kbCustomerBrainOffer--cartDrawer{margin:10px 0 12px}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferEyebrow{padding:6px 10px;font-size:11px;letter-spacing:.05em;text-transform:uppercase}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferContent{padding:9px 10px 10px;gap:8px}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferTitle{font-size:13px;line-height:1.25;margin:0 24px 3px 0}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferBody{font-size:12px;line-height:1.35;margin:0 0 7px}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferMeta{gap:5px;margin:0}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferMeta span{font-size:11px;padding:2px 7px}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferActions{display:flex;flex-direction:row;align-items:stretch;gap:8px;margin-top:9px}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferLink,.kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferCoupon{flex:1 1 0;width:auto;min-width:0;min-height:36px;display:flex;align-items:center;justify-content:center;text-align:center;font-size:13px;padding:6px 10px}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferClose{width:28px;height:28px}",
      /* Eyebrow ("Imas aktivan kod" / "Kod vazi za ovaj proizvod") ponavlja ono
         sto naslov vec kaze, a kosta 25px u draweru gde je prostor najskuplji.
         Na stranici korpe ostaje. Telo se NE krije — kad kod nije za trenutni
         proizvod, ono nosi jedinu uputu kupcu ("Vrati se na proizvod...").
         Mereno 375x812: 247 -> 160 -> 135px, dakle 17% ekrana. */
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferEyebrow{display:none}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferContent{padding:10px}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferActions{margin-top:8px}",
      ".kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferLink,.kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferCoupon{min-height:34px}",
      ".kbCustomerBrainOffer--cartPage{width:min(860px,calc(100% - 32px));margin:22px auto;background:#fdf4ea;border-color:rgba(232, 138, 45,.22)}",
      ".kbCustomerBrainOffer--cartPage .kbCustomerBrainOfferEyebrow{padding:8px 14px;background:#fdf4ea;font-size:12px;font-weight:650}",
      ".kbCustomerBrainOffer--cartPage .kbCustomerBrainOfferContent{padding:14px;align-items:flex-start;gap:14px}",
      ".kbCustomerBrainOffer--cartPage .kbCustomerBrainOfferMedia{flex-basis:86px;width:86px;height:86px}",
      ".kbCustomerBrainOffer--cartPage .kbCustomerBrainPersonalTextPrompt{padding:10px;background:#fff;border-color:rgba(31,41,55,.10)}",
      ".kbCustomerBrainOffer--cartPage .kbCustomerBrainOfferActions{gap:10px}",
      "#main-cart-footer .kbCustomerBrainOffer,.cart__footer .kbCustomerBrainOffer,form[action='/cart'] .kbCustomerBrainOffer,form[action*='/cart'] .kbCustomerBrainOffer,cart-items+.kbCustomerBrainOffer,.cart-items+.kbCustomerBrainOffer{margin:22px auto}",
      ".kbCustomerBrainCouponOverlay{position:fixed;inset:0;z-index:2147483200;background:rgba(18, 18, 18,.45);backdrop-filter:saturate(120%) blur(2px)}",
      ".kbCustomerBrainCouponPopup{position:fixed;left:50%;top:50%;transform:translate(-50%,-50%);z-index:2147483201;width:min(520px,calc(100vw - 28px));max-height:calc(100vh - 28px);overflow:auto;box-sizing:border-box;padding:0;border-radius:0;background:#fff;color:#121212;border:1px solid rgba(232, 138, 45,.38);box-shadow:0 24px 28px rgba(18, 18, 18,0.1);font-family:inherit}",
      ".kbCustomerBrainCouponPopupClose{position:absolute;right:10px;top:10px;width:34px;height:34px;border:0;border-radius:999px;background:#f2f2f2;color:#595959;font-size:22px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:1}",
      ".kbCustomerBrainCouponPopupClose:hover{background:#e3e3e3;color:#121212}",
      ".kbCustomerBrainCouponPopupEyebrow{margin:0;box-sizing:border-box;min-height:54px;display:flex;align-items:center;padding:12px 56px 12px 16px;background:#fdf4ea;border-bottom:1px solid rgba(232, 138, 45,.22);color:#6b3c0f;font-size:13px;font-weight:750;line-height:1.2}",
      ".kbCustomerBrainCouponPopupGrid{display:grid;grid-template-columns:116px minmax(0,1fr);gap:14px;padding:16px}",
      ".kbCustomerBrainCouponPopupMedia{display:block;width:116px;height:116px;border-radius:0;overflow:hidden;background:#f4f1ec;border:1px solid rgba(18, 18, 18,.10)}",
      ".kbCustomerBrainCouponPopupMedia img{display:block;width:100%;height:100%;object-fit:cover}",
      ".kbCustomerBrainCouponPopupTitle{margin:0 34px 7px 0;color:#121212;font-size:22px;font-weight:750;line-height:1.2;letter-spacing:0}",
      ".kbCustomerBrainCouponPopupBody{margin:0 0 10px;color:#595959;font-size:14px;line-height:1.45}",
      ".kbCustomerBrainCouponPopupNote{margin:0 0 13px;padding:9px 10px;border-radius:0;background:#fdf4ea;border:1px solid rgba(232, 138, 45,.25);color:#5f3a12;font-size:12px;line-height:1.35;font-weight:600}",
      ".kbCustomerBrainCouponPopupActions{display:flex;gap:9px;align-items:stretch;flex-wrap:wrap}",
      ".kbCustomerBrainCouponPopupPrimary,.kbCustomerBrainCouponPopupSecondary{min-height:44px;border-radius:999px;padding:10px 14px;display:inline-flex;align-items:center;justify-content:center;text-align:center;font-size:14px;font-weight:750;line-height:1.2;text-decoration:none;cursor:pointer}",
      ".kbCustomerBrainCouponPopupPrimary{border:0;background:#e88a2d;color:#fff;box-shadow:0 10px 22px rgba(232, 138, 45,0.1)}",
      ".kbCustomerBrainCouponPopupPrimary:hover{background:#d97a1f;color:#fff}",
      ".kbCustomerBrainCouponPopupPrimary[disabled]{opacity:.68;cursor:wait}",
      ".kbCustomerBrainCouponPopupSecondary{border:1px solid rgba(18, 18, 18,.14);background:#fff;color:#121212}",
      ".kbCustomerBrainCouponPopupSecondary:hover{background:#f7f7f7;color:#121212;text-decoration:none}",
      ".kbCustomerBrainCouponPopupSkip{margin:10px 0 0;padding:6px 2px;border:0;background:transparent;color:#595959;font-size:13px;font-weight:650;cursor:pointer}",
      ".kbCustomerBrainCouponPopupSkip:hover{color:#121212;text-decoration:underline}",
      "@media(max-width:760px){.kbCustomerBrainOffer--cartPage{width:calc(100% - 24px);margin:16px auto}.kbCustomerBrainOffer--cartPage .kbCustomerBrainOfferContent{flex-direction:column;align-items:stretch;gap:11px;padding:12px}.kbCustomerBrainOffer--cartPage .kbCustomerBrainOfferMedia{flex-basis:82px;width:82px;height:82px}.kbCustomerBrainOffer--cartPage .kbCustomerBrainOfferActions{align-items:stretch}.kbCustomerBrainOffer--cartPage .kbCustomerBrainOfferLink,.kbCustomerBrainOffer--cartPage .kbCustomerBrainOfferCoupon{width:100%}}",
      "@media(max-width:520px){.kbCustomerBrainOffer{margin:10px 0}.kbCustomerBrainOfferContent{align-items:flex-start;padding:11px}.kbCustomerBrainOfferMedia{flex-basis:74px;width:74px;height:74px}.kbCustomerBrainOfferTitle{font-size:15px;margin-right:26px}.kbCustomerBrainOfferBody{font-size:12px}.kbCustomerBrainOfferMeta{gap:6px}.kbCustomerBrainOfferMeta span{font-size:11px}.kbCustomerBrainOfferActions{align-items:stretch}.kbCustomerBrainOfferLink,.kbCustomerBrainOfferCoupon{flex:1;min-width:0;text-align:center}.kbCustomerBrainPersonalTextPromptRow{flex-direction:column}.kbCustomerBrainPersonalTextSave{width:100%}.kbCustomerBrainOffer--cartDrawer{margin-left:10px;margin-right:10px}.kbCustomerBrainOffer--cartDrawer .kbCustomerBrainOfferMedia{flex-basis:72px;width:72px;height:72px}}",
      "@media(max-width:520px){.kbCustomerBrainCouponPopup{width:calc(100vw - 20px);max-height:calc(100vh - 20px)}.kbCustomerBrainCouponPopupGrid{grid-template-columns:82px minmax(0,1fr);gap:11px;padding:13px}.kbCustomerBrainCouponPopupMedia{width:82px;height:82px}.kbCustomerBrainCouponPopupTitle{font-size:18px;margin-right:28px}.kbCustomerBrainCouponPopupBody{font-size:13px}.kbCustomerBrainCouponPopupActions{flex-direction:column}.kbCustomerBrainCouponPopupPrimary,.kbCustomerBrainCouponPopupSecondary{width:100%;font-size:13px}.kbCustomerBrainCouponPopupEyebrow{font-size:12px}}",
      "@media(max-width:360px){.kbCustomerBrainCouponPopupGrid{grid-template-columns:1fr}.kbCustomerBrainCouponPopupMedia{width:100%;height:132px}.kbCustomerBrainCouponPopupTitle{font-size:17px}.kbCustomerBrainCouponPopupBody,.kbCustomerBrainCouponPopupNote{font-size:12px}}",
      ".kb-table-designer .kbCustomerBrainOffer,.kbr-hcfg__panel .kbCustomerBrainOffer{margin:14px 0 10px}",
      ".kb-customer-brain-product-slot .kbCustomerBrainOffer{margin:12px 0 14px}",
      ".otr-atc-form+.kbCustomerBrainOffer,.pdm-atc-form+.kbCustomerBrainOffer,.kbCustomerBrainOffer+.otr-atc-form,.kbCustomerBrainOffer+.pdm-atc-form{margin-top:14px}"
    ].join("");
    document.head.appendChild(style);
  }

  function customerBrainOfferHandle(offer) {
    offer = offer || {};
    var prefill = offer.prefill || {};
    return String(prefill.target_handle || offer.product_handle || "").replace(/^\/+|\/+$/g, "");
  }

  function customerBrainOfferPersonalText(offer, context) {
    offer = offer || {};
    var prefill = offer.prefill || {};
    context = context || offer.personal_text || customerBrainReadStoredPersonalText() || {};
    return customerBrainCleanPersonalValue(prefill.main_text || context.display_text || "");
  }

  function customerBrainIsTableDesignerHandle(handle) {
    handle = String(handle || "");
    return handle === "postansko-sanduce"
      || handle.indexOf("plocica") === 0
      || handle.indexOf("oblik-") === 0
      || handle.indexOf("cuvaj-se-psa") !== -1
      || handle.indexOf("zabranjeno-parkiranje") !== -1
      || handle.indexOf("video-nadzor") !== -1;
  }

  function customerBrainApplyDimensionParams(params, dimensions) {
    var match = String(dimensions || "").match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)/i);
    if (!match) return;
    params.set("kb_w", match[1].replace(",", "."));
    params.set("kb_h", match[2].replace(",", "."));
  }

  function customerBrainBuildSameTextUrl(baseUrl, offer, context) {
    offer = offer || {};
    var prefill = offer.prefill || {};
    var handle = customerBrainOfferHandle(offer);
    if (!baseUrl || !handle) return baseUrl || "/collections/all";
    if (!customerBrainIsTableDesignerHandle(handle)) return baseUrl;

    var url;
    try { url = new URL(baseUrl, window.location.origin); } catch (e) { return baseUrl; }
    var params = url.searchParams;
    var mainText = customerBrainOfferPersonalText(offer, context);
    var bottomText = customerBrainCleanPersonalValue(prefill.mailbox_bottom_text || mainText);

    params.set("kb_cfg", "1");
    params.set("cb_prefill", "customer_brain");

    if (handle === "postansko-sanduce") {
      params.set("kb_extra", customerBrainNormalizeText(prefill.mailbox_top_text || "POŠTA"));
      if (bottomText) params.set("kb_street", bottomText);
    } else if (mainText) {
      params.set("kb_street", mainText);
      customerBrainApplyDimensionParams(params, prefill.recommended_dimensions || "");
    }

    return url.pathname + url.search + url.hash;
  }

  function renderCustomerBrainOffer(decision, logImpression) {
    if (!decision || decision.action !== "show_offer" || !decision.offer) return false;
    var offer = decision.offer;
    var decisionId = decision.decision_id || offer.decision_id;
    if (decisionId) {
      try {
        if (sessionStorage.getItem(SS_CUSTOMER_BRAIN_DISMISSED_PREFIX + decisionId) === "1") return true;
      } catch (e) {}
    }
    if (document.querySelector(".kbCustomerBrainOffer")) return true;
    if (offer.mode === "continue_design" && customerBrainHasVisibleDraftReminder()) return true;

    var mount = customerBrainMountPoint();
    if (!mount) return false;

    injectCustomerBrainStyles();

    var placement = customerBrainPlacementContext(mount);
    var meta = customerBrainOfferMeta(offer, placement);
    var box = document.createElement("div");
    box.className = "kbCustomerBrainOffer kbCustomerBrainOffer--" + (placement === "cart_drawer" ? "cartDrawer" : (placement === "cart_page" ? "cartPage" : "product"));
    box.setAttribute("data-decision-id", String(decisionId || ""));
    box.setAttribute("data-placement", placement);
    box.innerHTML = [
      '<div class="kbCustomerBrainOfferInner">',
      '<button class="kbCustomerBrainOfferClose" type="button" aria-label="Zatvori">×</button>',
      '<div class="kbCustomerBrainOfferEyebrow"><span class="kbCustomerBrainOfferDot"></span><span></span></div>',
      '<div class="kbCustomerBrainOfferContent">',
      '<a class="kbCustomerBrainOfferMedia" href="#" aria-hidden="true" tabindex="-1"><img alt="" loading="lazy"></a>',
      '<div class="kbCustomerBrainOfferCopy">',
      '<p class="kbCustomerBrainOfferTitle"></p>',
      '<p class="kbCustomerBrainOfferBody"></p>',
      '<div class="kbCustomerBrainOfferMeta"></div>',
      '<div class="kbCustomerBrainPersonalTextPrompt"><label>Prezime ili natpis za popunjavanje proizvoda</label><div class="kbCustomerBrainPersonalTextPromptRow"><input class="kbCustomerBrainPersonalTextInput" type="text" maxlength="80" autocomplete="family-name" placeholder="npr. Petrović"><button class="kbCustomerBrainPersonalTextSave" type="button">Otvori popunjeno</button></div><p class="kbCustomerBrainPersonalTextHint">Upišite jednom, a sledeći proizvod otvaramo sa tim natpisom.</p></div>',
      '<div class="kbCustomerBrainOfferIncentive"><p class="kbCustomerBrainOfferIncentiveTitle"></p><p class="kbCustomerBrainOfferIncentiveBody"></p></div>',
      '<div class="kbCustomerBrainOfferActions"><button class="kbCustomerBrainOfferCoupon" type="button">Preuzmi kod</button><a class="kbCustomerBrainOfferLink" href="#"></a><button class="kbCustomerBrainOfferSkip" type="button">Ne sada</button></div>',
      '</div>',
      '</div>',
      '</div>'
    ].join("");

    box.querySelector(".kbCustomerBrainOfferEyebrow span:last-child").textContent = customerBrainOfferEyebrow(offer, placement);
    box.querySelector(".kbCustomerBrainOfferTitle").textContent = offer.title || "Predlog za kompletiranje";
    box.querySelector(".kbCustomerBrainOfferBody").textContent = offer.body || "";
    var metaNode = box.querySelector(".kbCustomerBrainOfferMeta");
    if (offer.personal_text && offer.personal_text.display_text) {
      meta.unshift("Natpis: " + offer.personal_text.display_text);
    }
    if (offer.prefill && offer.prefill.recommended_dimensions) {
      meta.push("Predlog: " + offer.prefill.recommended_dimensions);
    }
    if (meta.length && metaNode) {
      meta.forEach(function (text) {
        var item = document.createElement("span");
        item.textContent = text;
        metaNode.appendChild(item);
      });
    } else if (metaNode) {
      metaNode.style.display = "none";
    }
    var link = box.querySelector(".kbCustomerBrainOfferLink");
    link.textContent = placement === "cart_drawer" ? (offer.cta_label || "+ Pogledaj") : (offer.cta_label || "Pogledaj proizvod");
    function resolveOfferHref(context) {
      return customerBrainBuildSameTextUrl(offer.url || "/collections/all", offer, context || null);
    }
    link.href = resolveOfferHref(null);
    var prompt = box.querySelector(".kbCustomerBrainPersonalTextPrompt");
    var promptInput = box.querySelector(".kbCustomerBrainPersonalTextInput");
    var promptSave = box.querySelector(".kbCustomerBrainPersonalTextSave");
    if (prompt && offer.requires_personal_text) {
      prompt.style.display = "block";
      link.textContent = "Prvo upišite natpis";
      try {
        sendEvent("customer_brain_personal_text_prompt_shown", {
          offer_key: offer.offer_key || "",
          target_category: offer.target_category || "",
          placement: placement
        });
      } catch (e) {}
    }
    var couponButton = box.querySelector(".kbCustomerBrainOfferCoupon");
    var incentiveCopy = customerBrainIncentiveCopy(offer);
    var incentiveNode = box.querySelector(".kbCustomerBrainOfferIncentive");
    if (incentiveCopy && incentiveNode) {
      incentiveNode.querySelector(".kbCustomerBrainOfferIncentiveTitle").textContent = incentiveCopy.title;
      incentiveNode.querySelector(".kbCustomerBrainOfferIncentiveBody").textContent = incentiveCopy.body;
      incentiveNode.style.display = "block";
    }
    if (couponButton && incentiveCopy) {
      couponButton.textContent = incentiveCopy.button;
    } else if (couponButton) {
      couponButton.style.display = "none";
    }
    var media = box.querySelector(".kbCustomerBrainOfferMedia");
    var mediaImage = media ? media.querySelector("img") : null;
    if (offer.image_url && media && mediaImage) {
      media.href = link.href;
      mediaImage.src = offer.image_url;
      mediaImage.alt = offer.product_title || offer.title || "";
      media.style.display = "block";
    }

    box.querySelector(".kbCustomerBrainOfferClose").addEventListener("click", function () {
      if (decisionId) {
        try { sessionStorage.setItem(SS_CUSTOMER_BRAIN_DISMISSED_PREFIX + decisionId, "1"); } catch (e) {}
      }
      logCustomerBrainDecisionEvent(decisionId, "dismiss", { offer_key: offer.offer_key || "" });
      if (offer.requires_personal_text) {
        try {
          sendEvent("customer_brain_personal_text_dismiss", {
            offer_key: offer.offer_key || "",
            target_category: offer.target_category || "",
            placement: placement,
            dismiss_ui: "close"
          });
        } catch (e) {}
      }
      box.remove();
    });
    var skip = box.querySelector(".kbCustomerBrainOfferSkip");
    if (skip) {
      skip.addEventListener("click", function () {
        if (decisionId) {
          try { sessionStorage.setItem(SS_CUSTOMER_BRAIN_DISMISSED_PREFIX + decisionId, "1"); } catch (e) {}
        }
        logCustomerBrainDecisionEvent(decisionId, "dismiss", { offer_key: offer.offer_key || "", dismiss_ui: "skip" });
        if (offer.requires_personal_text) {
          try {
            sendEvent("customer_brain_personal_text_dismiss", {
              offer_key: offer.offer_key || "",
              target_category: offer.target_category || "",
              placement: placement,
              dismiss_ui: "skip"
            });
          } catch (e) {}
        }
        box.remove();
      });
    }

    function trackOfferClick(extra) {
      extra = extra || {};
      logCustomerBrainDecisionEvent(decisionId, "click", {
        offer_key: offer.offer_key || "",
        target_category: offer.target_category || "",
        url: extra.url || link.href,
        coupon_code: extra.coupon_code || "",
        incentive_reserved: extra.incentive_reserved === true
      });
    }
    function rememberSameTextPrefill(extraContext) {
      var context = extraContext || offer.personal_text || customerBrainReadStoredPersonalText() || null;
      if (!context && !offer.prefill) return;
      try {
        sessionStorage.setItem("kb_customer_brain_same_text_prefill", JSON.stringify({
          offer_key: offer.offer_key || "",
          target_category: offer.target_category || "",
          target_handle: (offer.prefill && offer.prefill.target_handle) || offer.product_handle || "",
          personal_text: context,
          prefill: offer.prefill || {},
          ts: Date.now()
        }));
      } catch (e) {}
    }
    function promptContextIfAvailable() {
      if (!offer.requires_personal_text || !promptInput) return null;
      return customerBrainBuildPromptPersonalTextContext(promptInput.value || "", offer);
    }
    function trackAndPrefillClick() {
      var promptContext = promptContextIfAvailable();
      if (offer.requires_personal_text && promptInput && !promptContext) {
        promptInput.focus();
        return false;
      }
      if (promptContext) {
        customerBrainSavePersonalText(promptContext);
        link.href = resolveOfferHref(promptContext);
        if (media) media.href = link.href;
      }
      rememberSameTextPrefill(promptContext || null);
      trackOfferClick({
        same_text: offer.mode === "same_text_addon" || offer.mode === "same_text_prompt",
        url: link.href
      });
      return true;
    }
    link.addEventListener("click", function (e) {
      if (trackAndPrefillClick() === false) e.preventDefault();
    });
    if (media) {
      media.addEventListener("click", function (e) {
        if (trackAndPrefillClick() === false) e.preventDefault();
      });
    }
    if (promptSave && promptInput) {
      promptSave.addEventListener("click", function () {
        var context = customerBrainBuildPromptPersonalTextContext(promptInput.value || "", offer);
        if (!context) {
          promptInput.focus();
          return;
        }
        customerBrainSavePersonalText(context);
        try {
          sendEvent("customer_brain_personal_text_submitted", {
            offer_key: offer.offer_key || "",
            target_category: offer.target_category || "",
            placement: placement,
            role: context.role,
            text_length: context.display_text.length
          });
        } catch (e) {}
        rememberSameTextPrefill(context);
        trackOfferClick({ same_text: true, personal_text_submitted: true });
        window.location.href = resolveOfferHref(context);
      });
    }
    if (couponButton) {
      couponButton.addEventListener("click", function () {
        if (!offer.incentive) return;
        couponButton.disabled = true;
        couponButton.textContent = "Rezervisemo...";
        reserveCustomerBrainIncentive(decisionId, offer).then(function (result) {
          if (result && result.status === "ok" && result.code) {
            rememberCustomerBrainIncentive(result, offer);
            trackOfferClick({
              url: result.discount_url || link.href,
              coupon_code: result.code,
              incentive_reserved: true
            });
            window.location.href = result.discount_url || link.href;
            return;
          }
          trackOfferClick();
          window.location.href = link.href;
        }).catch(function () {
          trackOfferClick();
          window.location.href = link.href;
        });
      });
    }

    if (mount.matches && mount.matches("[data-customer-brain-slot]")) {
      mount.appendChild(box);
    } else if (mount.matches && mount.matches(".kb-table-designer__actions")) {
      mount.insertAdjacentElement("beforebegin", box);
    } else if (mount.matches && mount.matches(".kb-table-designer")) {
      var designerActions = customerBrainFirstVisible(".kb-table-designer__actions", mount);
      if (designerActions) designerActions.insertAdjacentElement("beforebegin", box);
      else mount.appendChild(box);
    } else if (mount.matches && mount.matches(".kbr-hcfg__panel")) {
      var panelActions = customerBrainFirstVisible(".kb-table-designer__actions", mount);
      if (panelActions) panelActions.insertAdjacentElement("beforebegin", box);
      else mount.appendChild(box);
    } else if (mount.matches && mount.matches(".otr-atc-form, .pdm-atc-form")) {
      var specialAddButton = mount.querySelector("button[name='add'], button[type='submit'], input[type='submit']");
      if (specialAddButton) specialAddButton.insertAdjacentElement("beforebegin", box);
      else mount.insertAdjacentElement("beforeend", box);
    } else if (mount.matches && mount.matches("form[action*='/cart/add']")) {
      mount.insertAdjacentElement("afterend", box);
    } else if (mount.matches && mount.matches("cart-drawer .drawer__footer, #CartDrawer .drawer__footer, .drawer__footer")) {
      mount.insertAdjacentElement("beforebegin", box);
    } else if (mount.matches && mount.matches("#main-cart-footer, .cart__footer")) {
      mount.insertAdjacentElement("afterbegin", box);
    } else if (mount.matches && mount.matches("form[action='/cart'], form[action*='/cart'], cart-items, .cart-items")) {
      mount.insertAdjacentElement("afterend", box);
    } else if (mount.matches && mount.matches("main")) {
      mount.insertAdjacentElement("afterbegin", box);
    } else {
      mount.appendChild(box);
    }

    if (logImpression !== false) {
      logCustomerBrainDecisionEvent(decisionId, "impression", {
        offer_key: offer.offer_key || "",
        target_category: offer.target_category || "",
        placement: placement,
        mode: offer.mode || "",
        same_text: !!offer.same_text_candidate,
        personal_text_confidence: offer.personal_text && offer.personal_text.confidence ? offer.personal_text.confidence : ""
      });
    }

    if (incentiveCopy && (placement === "cart_drawer" || placement === "cart_page")) {
      setTimeout(function () {
        renderCustomerBrainCouponPopup(decision, offer, placement, link.href);
      }, 500);
    }

    return true;
  }

  function customerBrainHasVisibleDraftReminder() {
    var reminder = document.querySelector(".kbDraftReminder.is-visible");
    var pill = document.querySelector(".kbDraftPill.is-visible");
    return customerBrainElementVisible(reminder) || customerBrainElementVisible(pill);
  }

  function reserveCustomerBrainIncentive(decisionId, offer) {
    if (!decisionId || !offer || !offer.incentive) return Promise.resolve(null);
    return fetch(API_INCENTIVE, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: kbTelo({
        decision_id: decisionId,
        offer_key: offer.offer_key || "",
        anon_id: anonId,
        lead_id: leadId,
        session_id: sessionId,
        target_url: offer.url || "/cart"
      })
    }).then(function (r) {
      return r.json().catch(function () { return {}; });
    });
  }

  function rememberCustomerBrainIncentive(result, offer) {
    if (!result || !result.code) return;
    var targetName = customerBrainTargetName(offer || { target_category: result.target_category || "" });
    var noticeTargetPhrase = customerBrainNoticeTargetPhrase(offer || { target_category: result.target_category || "" });
    var amountLabel = customerBrainFormatRsd(result.amount_rsd || (offer && offer.incentive ? offer.incentive.amount_rsd : 0));
    var payload = {
      code: result.code,
      offer_key: result.offer_key || "",
      target_category: result.target_category || "",
      target_name: targetName,
      notice_target_phrase: noticeTargetPhrase,
      amount_rsd: result.amount_rsd || 0,
      amount_label: amountLabel,
      target_url: result.target_url || "/cart",
      discount_url: result.discount_url || "",
      expires_at: result.expires_at || "",
      ts: Date.now()
    };
    try { localStorage.setItem(LS_CUSTOMER_BRAIN_INCENTIVE, JSON.stringify(payload)); } catch (e) {}
    try {
      sessionStorage.setItem(SS_COUPON_NOTICE, JSON.stringify({
        code: payload.code,
        threshold: 0,
        source: "customer_brain_incentive",
        target_name: payload.target_name,
        notice_target_phrase: payload.notice_target_phrase,
        amount_label: payload.amount_label,
        redirect: payload.target_url || "/cart",
        discount_url: payload.discount_url || "",
        ts: Date.now()
      }));
    } catch (e) {}
  }

  function customerBrainCartSignature(cart) {
    cart = cart || {};
    var items = Array.isArray(cart.items) ? cart.items : [];
    return [cartItemCount(cart)].concat(items.map(function (item) {
      return String(item.key || item.variant_id || item.id || item.handle || item.product_title || item.title || "") + ":" + String(item.quantity || 1);
    })).join("|");
  }

  function rememberCustomerBrainDecision(decision, cartSignature) {
    sessionStorage.setItem(SS_CUSTOMER_BRAIN_DECISION, sessionId);
    sessionStorage.setItem(SS_CUSTOMER_BRAIN_DECISION_PAYLOAD, JSON.stringify({
      session_id: sessionId,
      pathname: window.location.pathname,
      cart_signature: cartSignature || "",
      decision: decision || null
    }));
  }

  function customerBrainSetNativeValue(input, value) {
    if (!input || value === undefined || value === null || value === "") return false;
    var proto = Object.getPrototypeOf(input);
    var desc = proto && Object.getOwnPropertyDescriptor(proto, "value");
    if (desc && desc.set) desc.set.call(input, value);
    else input.value = value;
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
    return true;
  }

  function customerBrainFindInput(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var input = document.querySelector(selectors[i]);
      if (input) return input;
    }
    return null;
  }

  function customerBrainFindGsField(label) {
    label = customerBrainNormalizeText(label || "");
    if (!label) return null;
    var fields = document.querySelectorAll(".gs-po-field");
    for (var i = 0; i < fields.length; i++) {
      if (customerBrainNormalizeText(fields[i].dataset.label || "") === label) return fields[i];
    }
    return null;
  }

  function customerBrainSetGsChoice(fieldLabel, optionValue) {
    var field = customerBrainFindGsField(fieldLabel);
    if (!field) return false;
    var inputs = field.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    optionValue = customerBrainNormalizeText(optionValue || "");
    for (var i = 0; i < inputs.length; i++) {
      if (customerBrainNormalizeText(inputs[i].value || "") !== optionValue) continue;
      if (!inputs[i].checked) {
        inputs[i].checked = true;
        inputs[i].dispatchEvent(new Event("change", { bubbles: true }));
      }
      return true;
    }
    return false;
  }

  function customerBrainSetGsText(fieldLabel, value) {
    var field = customerBrainFindGsField(fieldLabel);
    if (!field) return false;
    var input = field.querySelector('input[type="text"], textarea');
    return customerBrainSetNativeValue(input, value);
  }

  function customerBrainApplyGsSameTextPrefill(handle, mainText, applied) {
    mainText = customerBrainCleanPersonalValue(mainText || "");
    if (!mainText) return;
    if (handle === "personalizovani-kokos-otirac") {
      if (customerBrainSetGsChoice("Šta želite na otiraču?", "Tekst / natpis")) applied.push("gs_otirac_content_text");
      if (customerBrainSetGsText("Natpis", mainText)) applied.push("gs_otirac_natpis");
      return;
    }
    if (handle === "personalizovani-kameni-podmetaci-za-case") {
      var targetField = mainText.length <= 30 ? "Ime" : "Tekst";
      if (customerBrainSetGsChoice("Sadržaj", targetField)) applied.push("gs_podmetaci_content_" + targetField.toLowerCase());
      if (customerBrainSetGsText(targetField, mainText)) applied.push("gs_podmetaci_" + targetField.toLowerCase());
    }
  }

  function applyCustomerBrainSameTextPrefill() {
    var context = null;
    try { context = safeJsonParse(sessionStorage.getItem("kb_customer_brain_same_text_prefill"), null); } catch (e) {}
    if (!context || !context.prefill || !context.ts || Date.now() - Number(context.ts) > 2 * 60 * 60 * 1000) return false;
    var handle = String(context.target_handle || context.prefill.target_handle || "");
    if (handle && window.location.pathname.indexOf("/products/" + handle) !== 0) return false;

    var applied = [];
    var prefill = context.prefill || {};
    var personalText = context.personal_text || {};
    var mainText = prefill.main_text || (personalText && personalText.display_text) || "";

    function setField(name, value, selectors) {
      value = customerBrainNormalizeText(value || "");
      if (!value) return;
      var input = customerBrainFindInput(selectors);
      if (customerBrainSetNativeValue(input, value)) applied.push(name);
    }

    setField("mailbox_top_text", prefill.mailbox_top_text, [
      'input[name="extra_text"]',
      'textarea[name="extra_text"]',
      'input[name="properties[Gornji tekst]"]',
      'textarea[name="properties[Gornji tekst]"]',
      'input[name="properties[mailbox_top_text]"]',
      'textarea[name="properties[mailbox_top_text]"]'
    ]);
    setField("mailbox_bottom_text", prefill.mailbox_bottom_text || mainText, [
      'input[name="street"]',
      'textarea[name="street"]',
      'input[name="properties[Donji tekst]"]',
      'textarea[name="properties[Donji tekst]"]',
      'input[name="properties[mailbox_bottom_text]"]',
      'textarea[name="properties[mailbox_bottom_text]"]'
    ]);
    setField("main_text", mainText, [
      'input[name="street"]',
      'textarea[name="street"]',
      'input[placeholder*="Porodica"]',
      'textarea[placeholder*="Porodica"]',
      'input[placeholder*="porodica"]',
      'textarea[placeholder*="porodica"]',
      'input[placeholder*="natpis"]',
      'textarea[placeholder*="natpis"]',
      'input[name="properties[Natpis]"]',
      'textarea[name="properties[Natpis]"]',
      'input[name="properties[Prezime]"]',
      'textarea[name="properties[Prezime]"]',
      'input[name="properties[Tekst]"]',
      'textarea[name="properties[Tekst]"]',
      'input[name="properties[Ime porodice]"]',
      'textarea[name="properties[Ime porodice]"]'
    ]);
    customerBrainApplyGsSameTextPrefill(handle, mainText, applied);

    if (applied.length) {
      try {
        sendEvent("customer_brain_same_text_prefill_applied", {
          offer_key: context.offer_key || "",
          target_category: context.target_category || "",
          target_handle: handle,
          fields: applied,
          role: personalText.role || "",
          text_length: String(mainText || prefill.mailbox_bottom_text || "").length
        });
      } catch (e) {}
      return true;
    }
    return false;
  }

  function scheduleCustomerBrainSameTextPrefill() {
    var startedAt = Date.now();
    var attempts = 0;
    function tick() {
      attempts++;
      if (applyCustomerBrainSameTextPrefill()) return;
      if (Date.now() - startedAt > 12000 || attempts >= 28) return;
      setTimeout(tick, attempts < 4 ? 450 : 700);
    }
    setTimeout(tick, 300);
  }

  function renderCustomerBrainDecisionWithRetry(decision, logImpression) {
    var attempts = 0;
    function tryRender() {
      if (renderCustomerBrainOffer(decision, logImpression)) return;
      attempts += 1;
      if (attempts <= 10) setTimeout(tryRender, 350 + attempts * 250);
    }
    tryRender();
  }

  function clearCustomerBrainOffer() {
    var existing = document.querySelector(".kbCustomerBrainOffer");
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    closeCustomerBrainCouponPopup(false);
  }

  function refreshCustomerBrainForCart() {
    return requestCustomerBrainDecision({ force: true, source: "cart_refresh" });
  }

  function requestCustomerBrainDecision(options) {
    options = options || {};
    if (!CUSTOMER_BRAIN_ENABLED || isCheckoutPage()) return Promise.resolve(null);
    var urlProfile = customerBrainUrlProfile();
    var currentCategory = currentCustomerBrainCategory();

    return fetchCart()
      .then(function (cart) {
        latestCartSnapshot = cart || latestCartSnapshot;
        var personalTextContext = customerBrainCartPersonalTextContext(cart || {});
        var cartSignature = customerBrainCartSignature(cart);
        if (!options.force && sessionStorage.getItem(SS_CUSTOMER_BRAIN_DECISION) === sessionId) {
          var cached = safeJsonParse(sessionStorage.getItem(SS_CUSTOMER_BRAIN_DECISION_PAYLOAD), null);
          if (cached && cached.session_id === sessionId && cached.pathname === window.location.pathname && cached.cart_signature === cartSignature && cached.decision) {
            renderCustomerBrainDecisionWithRetry(cached.decision, true);
            return { __customerBrainCached: true, decision: cached.decision };
          }
        }
        sessionStorage.removeItem(SS_CUSTOMER_BRAIN_DECISION);
        sessionStorage.removeItem(SS_CUSTOMER_BRAIN_DECISION_PAYLOAD);
        if (options.force) clearCustomerBrainOffer();
        var activeIncentive = customerBrainActiveIncentive();
        if (activeIncentive && renderCustomerBrainActiveIncentive(activeIncentive)) {
          return { __customerBrainActiveIncentive: true, incentive: activeIncentive };
        }
        if (!currentCategory && cartItemCount(cart) <= 0) {
          return null;
        }
        if (!urlProfile.display_allowed && cartItemCount(cart) <= 0) {
          return null;
        }
        var mount = customerBrainMountPoint();
        if (!mount) {
          scheduleCustomerBrainDecisionWhenMountReady("mount_wait");
          return null;
        }
        if (!options.force
          && window.location.pathname.indexOf("/products/") === 0
          && customerBrainHasVisibleWizard()
          && !customerBrainWizardFinalSlot()
          && !customerBrainCartDrawerMountPoint()) {
          return null;
        }
        var decisionSignature = [
          sessionId,
          window.location.pathname,
          currentCategory || "",
          cartSignature || ""
        ].join("|");
        var now = Date.now();
        if (decisionSignature === customerBrainDecisionSignature && now - customerBrainDecisionSignatureAt < 2500) {
          return null;
        }
        customerBrainDecisionSignature = decisionSignature;
        customerBrainDecisionSignatureAt = now;

        return initLeadOnce().then(function () {
        return fetch(API_DECISION, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: kbTelo({
            anon_id: anonId,
            lead_id: leadId,
            session_id: sessionId,
            page: window.location.href,
            pathname: window.location.pathname,
            url_profile: urlProfile,
            placement: customerBrainPlacementContext(mount),
            current_category: currentCategory,
            cart: cart || {},
            personal_text_context: personalTextContext,
            event_data: {
              designer_engaged: !!window.__kbPendingCustomilyClick,
              help_intent: hasCustomerBrainHelpIntent(),
              draft_reminder_visible: customerBrainHasVisibleDraftReminder()
            },
            shopify: shopifyIdentity()
          })
        });
        });
      })
      .then(function (r) {
        if (!r) return null;
        if (r.__customerBrainCached) return r;
        if (typeof r.json === "function") return r.json().catch(function () { return {}; });
        return r;
      })
      .then(function (decision) {
        if (!decision) return null;
        if (decision.__customerBrainCached) return decision.decision || null;
        rememberCustomerBrainDecision(decision, customerBrainCartSignature(latestCartSnapshot));
        renderCustomerBrainDecisionWithRetry(decision, true);
        return decision;
      })
      .catch(function () {
        return null;
      });
  }

  function buildSmartCapturePayload(scenario, channel, cart) {
    cart = cart || latestCartSnapshot || {};
    var items = cart.items && Array.isArray(cart.items) ? cart.items : [];
    var first = items[0] || {};
    return {
      source: "smart_capture",
      scenario: scenario,
      preferred_channel: channel,
      phone_present: channel !== "email",
      email_present: channel === "email",
      cart_items_count: items.length,
      cart_total: cart.total_price || 0,
      has_design: items.some(function (item) {
        var props = item && item.properties ? item.properties : {};
        return !!(props._design_id || props._crm_design_url || props._preview_url || props["_customily-preview"] || props["_customily-thumb"]);
      }),
      primary_interest: first.product_type || first.vendor || "",
      url: window.location.href,
      pathname: window.location.pathname
    };
  }

  function identifyByPhone(phone, source) {
    phone = normalizePhone(phone || "");
    if (!phone) return Promise.resolve(null);

    if (localStorage.getItem(LS_PHONE_IDENTIFIED) === phone && leadId) {
      promptForEmailIfNeeded();
      return Promise.resolve(leadId);
    }

    return collectLead({
      phone: phone,
      event_type: "identify_phone",
      extra: { source: source || "phone_only" }
    }).then(function (res) {
      localStorage.setItem(LS_PHONE_IDENTIFIED, phone);
      promptForEmailIfNeeded();
      return res;
    });
  }

  function ensureLeadFromCart(cart) {
    cart = cart || {};
    var phone = cart.attributes && typeof cart.attributes.Telefon === "string"
      ? cart.attributes.Telefon.trim()
      : "";

    if (!phone) return Promise.resolve(null);
    return identifyByPhone(phone, "cart_attribute");
  }

  function findScopeWithInputs(el) {
    var node = el;
    var phoneScope = null;

    while (node && node !== document.body) {
      if (node.querySelector) {
        if (node.querySelector("#email, input[type='email']")) return node;
        if (!phoneScope && node.querySelector(".react-international-phone-input, input[type='tel']")) {
          phoneScope = node;
        }
      }
      node = node.parentElement;
    }

    return phoneScope || document;
  }

  function readFields(scope) {
    var root = scope || document;
    var inputs = Array.prototype.slice.call(root.querySelectorAll("input"));

    function bySelector(selector) {
      var el = root.querySelector(selector);
      return el && el.value ? el.value.trim() : "";
    }

    function findValue(predicate) {
      var found = inputs.find(function (input) {
        var h = [
          input.id || "",
          input.name || "",
          input.type || "",
          input.placeholder || "",
          input.getAttribute("aria-label") || "",
          input.className || ""
        ].join(" ").toLowerCase();
        return predicate(input, h);
      });
      return found && found.value ? found.value.trim() : "";
    }

    var fname = bySelector("#first_name") || bySelector("#gsFirstName") ||
      findValue(function (_, h) { return h.includes("first") || h.includes("ime"); });

    var lname = bySelector("#last_name") || bySelector("#gsLastName") ||
      findValue(function (_, h) { return h.includes("last") || h.includes("prezime"); });

    var email = bySelector("#email") || bySelector("#gsEmail") ||
      findValue(function (input, h) { return input.type === "email" || h.includes("email") || h.includes("mail"); }) ||
      ((inputs.find(function (input) { return isValidEmail(input.value || ""); }) || {}).value || "").trim();

    var phone = normalizePhone(window.__kbLastPhone || "") ||
      normalizePhone(bySelector(".react-international-phone-input")) ||
      normalizePhone(bySelector("#gsPhone")) ||
      normalizePhone(findValue(function (input, h) {
        return input.type === "tel" || h.includes("phone") || h.includes("telefon") || h.includes("mobile");
      }));

    return { fname: fname, lname: lname, email: email, phone: phone };
  }

  function injectPopup() {
    if (document.getElementById("gsPopupOverlay")) return;

    var style = document.createElement("style");
    style.textContent = [
      "#gsPopupOverlay{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.48);font-family:inherit;padding:16px;box-sizing:border-box}",
      ".gsPopupContainer{width:min(500px,100%);max-height:calc(100vh - 32px);overflow-y:auto;background:#fff;color:#161616;border:1px solid rgba(0,0,0,.08);border-radius:14px;padding:28px;box-shadow:0 24px 28px rgba(0,0,0,0.1);position:relative;box-sizing:border-box}",
      ".gsCloseBtn{position:absolute;right:12px;top:10px;width:38px;height:38px;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:30px;line-height:1;color:#222;border-radius:999px}",
      ".gsCloseBtn:hover{background:#f4f4f4}",
      ".gsTitle{margin:0 42px 8px 0;font-size:25px;line-height:1.18;font-weight:700;letter-spacing:0;color:#111}",
      ".gsSubtitle{margin:0 0 20px;color:#555;font-size:15px;line-height:1.45}",
      ".gsInputRow{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px}",
      ".gsEmailWrap{margin-bottom:10px}",
      ".gsInput,.gsPhoneInput{width:100%;box-sizing:border-box;border:1px solid #d7d7d7;border-radius:10px;background:#fff;color:#111;padding:13px 14px;font-size:16px;line-height:1.25;outline:none;transition:border-color .18s,box-shadow .18s}",
      ".gsInput:focus,.gsPhoneInput:focus{border-color:#111;box-shadow:0 0 0 3px rgba(0,0,0,0.08)}",
      ".gsPhoneInput{margin-bottom:14px}",
      ".gsButton{width:100%;min-height:48px;border:0;border-radius:999px;background:#111;color:#fff;font-weight:700;cursor:pointer;font-size:15px;line-height:1.2;padding:13px 18px;margin:0 0 10px;transition:transform .16s,opacity .16s,background .16s}",
      ".gsButton:hover{transform:translateY(-1px)}",
      ".gsBtnCart{background:#f3f3f3;color:#555;font-weight:600}",
      ".gsQuickContact{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-top:14px}",
      ".gsQuickBtn{min-height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;text-decoration:none;font-size:14px;font-weight:700;line-height:1.15;color:#111;background:#f6f6f6;border:1px solid #e4e4e4;box-sizing:border-box;text-align:center;padding:8px}",
      ".gsWhatsApp{background:#edf8f1;border-color:#cfeeda;color:#137a35}",
      ".gsViber{background:#f2effb;border-color:#ded5f5;color:#5b3db4}",
      ".gsCall{background:#fff5ea;border-color:#f3dcc0;color:#a75a0b}",
      "@media(max-width:460px){.gsPopupContainer{padding:24px 18px 18px;border-radius:12px}.gsTitle{font-size:22px;margin-right:38px}.gsSubtitle{font-size:14px}.gsInputRow{grid-template-columns:1fr;gap:0}.gsQuickContact{grid-template-columns:1fr}.gsQuickBtn{justify-content:center;min-height:40px}}",
      "@media(max-width:340px){.gsPopupContainer{padding-left:14px;padding-right:14px}.gsTitle{font-size:20px}.gsButton,.gsQuickBtn{font-size:14px}}"
    ].join("");
    document.head.appendChild(style);

    var overlay = document.createElement("div");
    overlay.id = "gsPopupOverlay";
    overlay.innerHTML = [
      "<div class='gsPopupContainer'>",
      "<div id='gsPopupClose' class='gsCloseBtn' aria-label='Zatvori'>&times;</div>",
      "<div class='gsTitle'>Tu smo da vam pomognemo 👋</div>",
      "<div class='gsSubtitle'>Ostavite kratke podatke i javićemo se uskoro putem Vibera ili emaila.</div>",
      "<div class='gsInputRow'>",
      "<input id='gsFirstName' class='gsInput' placeholder='Ime'>",
      "<input id='gsLastName' class='gsInput' placeholder='Prezime'>",
      "</div>",
      "<div class='gsEmailWrap'>",
      "<input id='gsEmail' class='gsInput' type='email' placeholder='Email adresa'>",
      "</div>",
      "<input id='gsPhone' class='gsPhoneInput' value='+381' placeholder='Broj telefona'>",
      "<button id='gsPopupSubmit' class='gsButton'>Kontaktirajte me</button>",
      "<button id='gsSkipPopup' class='gsButton gsBtnCart'>Nastavi bez unosa</button>",
      "<div class='gsQuickContact'>",
      "<a class='gsQuickBtn gsWhatsApp' href='https://wa.me/381658416212' target='_blank' rel='noopener'>💬 WhatsApp</a>",
      "<a class='gsQuickBtn gsViber' href='viber://chat?number=+381658416212'>📲 Viber</a>",
      "<a class='gsQuickBtn gsCall' href='tel:+381658416212'>📞 Poziv</a>",
      "</div>",
      "</div>"
    ].join("");
    document.body.appendChild(overlay);

    function hide() {
      overlay.style.display = "none";
      window.kbLeadPopupOpen = false;
      releasePopupLock();
    }

    function getLeadPopupEventData(action, options) {
      options = options || {};
      return {
        popup_type: "lead_help",
        action: action || "",
        source: options.source || "auto",
        url: window.location.href,
        pathname: window.location.pathname,
        has_lead_id: !!leadId
      };
    }

    window.kbShowLeadPopup = function (options) {
      options = options || {};
      if (!shouldShowLeadPopup(options)) return;
      overlay.style.display = "flex";
      window.kbLeadPopupOpen = true;
      markPopupShown();
      sendEvent("lead_popup_shown", getLeadPopupEventData("shown", options));
      setTimeout(function () {
        var firstName = document.getElementById("gsFirstName");
        if (firstName) firstName.focus();
      }, 50);
    };

    window.gsShowPopup = function () {
      window.kbShowLeadPopup({
        ignoreCustomilyIntercept: true,
        source: "cart_help"
      });
    };

    document.getElementById("gsPopupClose").onclick = function () {
      localStorage.setItem(LS_HIDE_HELP, "1");
      sendEvent("lead_popup_closed", getLeadPopupEventData("close_button", { source: "close_button" }));
      hide();
    };

    document.getElementById("gsSkipPopup").onclick = function () {
      localStorage.setItem(LS_SKIP_UNTIL, String(Date.now() + POPUP_SKIP_MS));
      sendEvent("lead_popup_skip", getLeadPopupEventData("skip", { source: "skip_button" }));
      hide();
    };

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) {
        sendEvent("lead_popup_closed", getLeadPopupEventData("overlay_click", { source: "overlay_click" }));
        hide();
      }
    });

    var quickLinks = [
      { selector: ".gsWhatsApp", event: "lead_popup_quick_whatsapp_click", source: "whatsapp" },
      { selector: ".gsViber", event: "lead_popup_quick_viber_click", source: "viber" },
      { selector: ".gsCall", event: "lead_popup_quick_call_click", source: "call" }
    ];

    quickLinks.forEach(function (item) {
      var link = overlay.querySelector(item.selector);
      if (!link) return;
      link.addEventListener("click", function () {
        sendEvent(item.event, getLeadPopupEventData("quick_contact", {
          source: item.source
        }));
      });
    });

    document.getElementById("gsPopupSubmit").onclick = function () {
      var data = {
        fname: document.getElementById("gsFirstName").value.trim(),
        lname: document.getElementById("gsLastName").value.trim(),
        email: document.getElementById("gsEmail").value.trim(),
        phone: normalizePhone(document.getElementById("gsPhone").value.trim()),
        extra: { source: "custom_popup" }
      };

      if (!data.fname || !data.lname || !isValidEmail(data.email) || !data.phone) {
        alert("Molimo proverite ime, prezime, email i telefon.");
        return;
      }

      sendEvent("lead_popup_submit", getLeadPopupEventData("submit", {
        source: "submit_button"
      }));

      collectLead(data).then(function () {
        hide();
      });
    };
  }

  function injectSmartCapture() {
    if (!SMART_CAPTURE_ENABLED || document.getElementById("kbSmartCaptureOverlay")) return;

    var style = document.createElement("style");
    style.id = "kbSmartCaptureStyles";
    style.textContent = [
      "#kbSmartCaptureOverlay{position:fixed;inset:0;z-index:2147483001;display:none;align-items:center;justify-content:center;background:rgba(18, 18, 18,.52);font-family:inherit;padding:16px;box-sizing:border-box;overflow-y:auto;-webkit-overflow-scrolling:touch;padding-top:max(16px,env(safe-area-inset-top));padding-bottom:max(16px,env(safe-area-inset-bottom))}",
      ".kbSmartCaptureBox{width:min(460px,100%);max-height:calc(100dvh - 32px);overflow-y:auto;overscroll-behavior:contain;background:#fff;color:#121212;border:1px solid rgba(18, 18, 18,.12);border-radius:0;padding:24px;box-shadow:0 24px 28px rgba(18, 18, 18,0.1);position:relative;box-sizing:border-box}",
      ".kbSmartClose{position:absolute;right:12px;top:10px;width:36px;height:36px;border:0;background:#f2f2f2;border-radius:999px;color:#121212;font-size:24px;line-height:1;cursor:pointer}",
      ".kbSmartTitle{margin:0 42px 8px 0;font-size:22px;line-height:1.18;font-weight:800;color:#121212}",
      ".kbSmartText{margin:0 0 16px;color:#595959;font-size:14px;line-height:1.45}",
      ".kbSmartChannels{display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-bottom:12px}",
      ".kbSmartChannel{min-height:40px;border:1px solid #dcdcdc;background:#f7f7f7;border-radius:0;color:#121212;font-size:13px;font-weight:800;cursor:pointer}",
      ".kbSmartChannel.is-active{border-color:#e88a2d;background:#fdf4ea;color:#d97a1f}",
      ".kbSmartInput{width:100%;box-sizing:border-box;border:1px solid #dcdcdc;border-radius:0;background:#fff;color:#121212;padding:12px 13px;font-size:16px;line-height:1.25;outline:none;margin-bottom:10px}",
      ".kbSmartInput:focus{border-color:#e88a2d;box-shadow:0 0 0 3px rgba(232, 138, 45,0.1)}",
      ".kbSmartSubmit{width:100%;min-height:46px;border:0;border-radius:999px;background:#121212;color:#fff;font-weight:800;cursor:pointer;font-size:15px;padding:12px 16px}",
      ".kbSmartSkip{width:100%;min-height:40px;border:0;background:transparent;color:#6e6e6e;font-weight:700;cursor:pointer;margin-top:8px}",
      ".kbSmartHint{font-size:12px;color:#6e6e6e;margin-top:8px;line-height:1.35}",
      "@media(max-width:460px){#kbSmartCaptureOverlay{align-items:flex-end;padding-left:10px;padding-right:10px}.kbSmartCaptureBox{width:100%;max-height:calc(100dvh - 24px);border-radius:0;padding:22px 16px}.kbSmartChannels{grid-template-columns:repeat(2,1fr)}.kbSmartChannel{min-height:44px}.kbSmartSubmit{min-height:48px}.kbSmartSkip{min-height:44px}.kbSmartClose{width:40px;height:40px}}",
      "@media(max-width:340px){.kbSmartTitle{font-size:20px}.kbSmartText{font-size:13px}.kbSmartChannel{font-size:12px;padding-left:6px;padding-right:6px}}"
    ].join("");
    document.head.appendChild(style);

    var overlay = document.createElement("div");
    overlay.id = "kbSmartCaptureOverlay";
    overlay.innerHTML = [
      "<div class='kbSmartCaptureBox'>",
      "<button class='kbSmartClose' type='button' aria-label='Zatvori'>&times;</button>",
      "<h2 class='kbSmartTitle' id='kbSmartTitle'>Sačuvaćemo vašu korpu</h2>",
      "<p class='kbSmartText' id='kbSmartText'>Ostavite kontakt i javićemo vam se sa proizvodima koje ste izabrali.</p>",
      "<div class='kbSmartChannels' role='group' aria-label='Kanal kontakta'>",
      "<button class='kbSmartChannel is-active' type='button' data-channel='viber'>Viber</button>",
      "<button class='kbSmartChannel' type='button' data-channel='whatsapp'>WhatsApp</button>",
      "<button class='kbSmartChannel' type='button' data-channel='phone'>Poziv</button>",
      "<button class='kbSmartChannel' type='button' data-channel='email'>Email</button>",
      "</div>",
      "<input id='kbSmartPhone' class='kbSmartInput' type='tel' inputmode='tel' autocomplete='tel' value='+381' placeholder='Broj telefona'>",
      "<input id='kbSmartEmail' class='kbSmartInput' type='email' inputmode='email' autocomplete='email' placeholder='Email adresa' style='display:none'>",
      "<button id='kbSmartSubmit' class='kbSmartSubmit' type='button'>Pošaljite mi detalje</button>",
      "<button id='kbSmartSkip' class='kbSmartSkip' type='button'>Ne sada</button>",
      "<div class='kbSmartHint'>Kontakt koristimo samo da odgovorimo na ovaj zahtev. Ne označava automatsku porudžbinu.</div>",
      "</div>"
    ].join("");
    document.body.appendChild(overlay);

    var activeScenario = "save_cart";
    var activeChannel = "viber";
    var activeCart = null;

    function scenarioCopy(scenario) {
      if (scenario === "design_review") {
        return { title: "Proverićemo vaš dizajn", text: "Ostavite kontakt i operater će proveriti dizajn pre izrade.", submit: "Želim proveru dizajna" };
      }
      if (scenario === "product_help") {
        return { title: "Pomoć oko izbora", text: "Ako niste sigurni oko modela, dimenzije ili materijala, možemo da pomognemo.", submit: "Želim pomoć oko izbora" };
      }
      if (scenario === "price_help") {
        return { title: "Proverićemo najpovoljniju opciju", text: "Možemo da proverimo pogodnost ili najisplativiju kombinaciju za vašu porudžbinu.", submit: "Proverite pogodnost" };
      }
      return { title: "Sačuvaćemo vašu korpu", text: "Ostavite kontakt i javićemo vam se sa proizvodima koje ste izabrali.", submit: "Pošaljite mi detalje" };
    }

    function setChannel(channel) {
      activeChannel = channel || "viber";
      overlay.querySelectorAll(".kbSmartChannel").forEach(function (btn) {
        btn.classList.toggle("is-active", btn.getAttribute("data-channel") === activeChannel);
      });
      var emailMode = activeChannel === "email";
      document.getElementById("kbSmartPhone").style.display = emailMode ? "none" : "block";
      document.getElementById("kbSmartEmail").style.display = emailMode ? "block" : "none";
    }

    function hide(skip) {
      overlay.style.display = "none";
      window.kbLeadPopupOpen = false;
      releasePopupLock();
      if (skip) {
        localStorage.setItem(LS_SMART_CAPTURE_CLOSED_UNTIL, String(Date.now() + SMART_CAPTURE_COOLDOWN_MS));
      }
    }

    window.kbShowSmartCapture = function (scenario, cart, options) {
      options = options || {};
      if (!SMART_CAPTURE_ENABLED || hasAnyContact()) return false;
      if (!options.force && !canShowAnyPopup()) return false;
      if (!options.force && isCooldownActive(LS_SMART_CAPTURE_CLOSED_UNTIL)) return false;

      activeScenario = scenario || "save_cart";
      activeCart = cart || latestCartSnapshot || {};
      var copy = scenarioCopy(activeScenario);
      document.getElementById("kbSmartTitle").textContent = copy.title;
      document.getElementById("kbSmartText").textContent = copy.text;
      document.getElementById("kbSmartSubmit").textContent = copy.submit;
      setChannel(activeChannel);

      overlay.style.display = "flex";
      window.kbLeadPopupOpen = true;
      markPopupShown();
      sendEvent("contact_intent_shown", buildSmartCapturePayload(activeScenario, activeChannel, activeCart), { cart: activeCart });
      setTimeout(function () {
        var input = activeChannel === "email" ? document.getElementById("kbSmartEmail") : document.getElementById("kbSmartPhone");
        if (input) input.focus();
      }, 50);
      return true;
    };

    overlay.querySelectorAll(".kbSmartChannel").forEach(function (btn) {
      btn.addEventListener("click", function () {
        setChannel(btn.getAttribute("data-channel"));
      });
    });

    overlay.querySelector(".kbSmartClose").addEventListener("click", function () {
      sendEvent("contact_intent_dismissed", buildSmartCapturePayload(activeScenario, activeChannel, activeCart), { cart: activeCart });
      hide(true);
    });

    document.getElementById("kbSmartSkip").addEventListener("click", function () {
      sendEvent("contact_intent_dismissed", buildSmartCapturePayload(activeScenario, activeChannel, activeCart), { cart: activeCart });
      hide(true);
    });

    overlay.addEventListener("click", function (e) {
      if (e.target !== overlay) return;
      sendEvent("contact_intent_dismissed", buildSmartCapturePayload(activeScenario, activeChannel, activeCart), { cart: activeCart });
      hide(true);
    });

    document.getElementById("kbSmartSubmit").addEventListener("click", function () {
      var phone = normalizePhone(document.getElementById("kbSmartPhone").value.trim());
      var email = String(document.getElementById("kbSmartEmail").value || "").trim();
      if (activeChannel === "email") {
        if (!isValidEmail(email)) {
          alert("Unesite ispravnu email adresu.");
          return;
        }
      } else if (!phone) {
        alert("Unesite broj telefona.");
        return;
      }

      var payload = buildSmartCapturePayload(activeScenario, activeChannel, activeCart);
      payload.phone_present = !!phone;
      payload.email_present = !!email;

      collectLead({ email: email, phone: phone, event_type: "smart_capture", extra: payload }).then(function () {
        if (phone) localStorage.setItem(LS_PHONE_IDENTIFIED, phone);
        var channelEvent = activeChannel === "phone" ? "call" : activeChannel;
        sendEvent("contact_intent_submit", payload, { cart: activeCart });
        sendEvent("contact_request_" + channelEvent, payload, { cart: activeCart });
        if (activeScenario !== "contact_request") {
          sendEvent("contact_request_" + activeScenario, payload, { cart: activeCart });
        }
        hide(false);
      });
    });
  }

  function smartCaptureScenarioFromCart(cart) {
    cart = cart || {};
    var items = cart.items && Array.isArray(cart.items) ? cart.items : [];
    if (!items.length) return "";
    var hasDesign = items.some(function (item) {
      var props = item && item.properties ? item.properties : {};
      return !!(props._design_id || props._crm_design_url || props._preview_url || props["_customily-preview"] || props["_customily-thumb"]);
    });
    return hasDesign ? "design_review" : "save_cart";
  }

  function maybeShowSmartCapture(cart, reason) {
    if (!SMART_CAPTURE_ENABLED || hasAnyContact()) return;
    if (typeof window.kbShowSmartCapture !== "function") return;
    cart = cart || latestCartSnapshot || {};
    var scenario = smartCaptureScenarioFromCart(cart);
    if (!scenario && reason === "product_help") scenario = "product_help";
    if (!scenario) return;
    window.kbShowSmartCapture(scenario, cart);
  }

  function bindEcomSend(root) {
    root = root || document;
    var buttons = root.querySelectorAll(".ecomsend__Button, .ecomsend button, [class*='ecomsend'] button, [id^='ecomsend-submit-button'] [role='button']");
    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.__kbLeadBound) return;
      btn.__kbLeadBound = true;
      btn.addEventListener("click", function () {
        setTimeout(function () {
          var scope = findScopeWithInputs(btn);
          var data = readFields(scope);
          data.extra = { source: "ecomsend_button", label: (btn.innerText || "").trim() };
          log("KB EcomSend fields", data);
          if (data.email || data.phone) collectLead(data);
        }, 300);
      }, true);
    });

    var forms = root.querySelectorAll(".ecomsend form, form[class*='ecomsend']");
    Array.prototype.forEach.call(forms, function (form) {
      if (form.__kbLeadBound) return;
      form.__kbLeadBound = true;
      form.addEventListener("submit", function () {
        setTimeout(function () {
          var data = readFields(form);
          data.extra = { source: "ecomsend_submit" };
          if (data.email || data.phone) collectLead(data);
        }, 300);
      }, true);
    });
  }

  function setupPhoneCapture() {
    var timer = null;
    document.addEventListener("input", function (e) {
      var el = e.target;
      if (!el || !el.classList || !el.classList.contains("react-international-phone-input")) return;

      var phone = normalizePhone(el.value || el.getAttribute("value") || "");
      window.__kbLastPhone = phone;
      var scope = findScopeWithInputs(el);
      var hasEmailField = !!scope.querySelector("#email, input[type='email']");

      if (!hasEmailField && phone) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          identifyByPhone(phone, "customily_phone");
        }, 900);
      }
    }, true);
  }

  // Local candidate: observe successful cart requests; never replace the caller's response.
  function installConfirmedCartObserver(originalFetch, sendCartEvent) {
    var requestSerial = 0;
    function endpoint(input, init) {
      try {
        var url = new URL(typeof input === 'string' ? input : input.url, location.href);
        var method = String(init && init.method || input && input.method || 'GET').toUpperCase();
        if (url.origin !== location.origin || method !== 'POST') return '';
        var match = url.pathname.match(/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/cart\/(add|update|change)(?:\.js|\.json)?\/?$/i);
        return match ? match[1].toLowerCase() : '';
      } catch (_) { return ''; }
    }
    function normalizeItem(value) {
      if (!value || typeof value !== 'object') return null;
      var id = String(value.id || value.variant_id || '');
      var quantity = value.quantity === undefined ? 1 : Number(value.quantity);
      var properties = value.properties || {};
      if (!/^\d+$/.test(id) || !Number.isInteger(quantity) || quantity < 1 || !properties || typeof properties !== 'object' || Array.isArray(properties)) return null;
      return {id:id,quantity:quantity,properties:properties};
    }
    function bodyItems(body) {
      var data;
      try {
        if (typeof body === 'string') {
          try { data = JSON.parse(body); } catch (_) { body = new URLSearchParams(body); }
        }
        if (!data && body && typeof body.get === 'function' && typeof body.forEach === 'function') {
          data = {id:body.get('id'),quantity:body.get('quantity') || 1,properties:{}};
          body.forEach(function(value,key) {
            var property = key.match(/^properties\[([^\]]+)\]$/);
            if (property) data.properties[property[1]] = value;
          });
        }
        if (!data) return null;
        var items = Array.isArray(data.items) ? data.items : [data];
        if (!items.length || items.length > 100) return null;
        var normalized = items.map(normalizeItem);
        if (normalized.some(function(item) { return !item; })) return null;
        // A repeated variant/property pair needs quantity aggregation; fail closed for now.
        var keys = normalized.map(function(item) { return item.id + JSON.stringify(Object.keys(item.properties).sort().map(function(key) { return [key,item.properties[key]]; })); });
        return new Set(keys).size === keys.length ? normalized : null;
      } catch (_) { return null; }
    }
    function requestItems(input, init) {
      try {
        if (init && Object.prototype.hasOwnProperty.call(init,'body')) return Promise.resolve(bodyItems(init.body));
        if (input && typeof input.clone === 'function') return input.clone().text().then(bodyItems,function() { return null; });
      } catch (_) {}
      return Promise.resolve(null);
    }
    function matchingResponse(items, payload) {
      if (!items || !payload || typeof payload !== 'object') return false;
      var returned = Array.isArray(payload.items) ? payload.items : [payload];
      if (returned.length !== items.length) return false;
      var used = new Set();
      return items.every(function(item) {
        var index = returned.findIndex(function(line,i) {
          if (!line || used.has(i) || String(line.variant_id || line.id || '') !== item.id) return false;
          if (!Number.isInteger(Number(line.quantity)) || Number(line.quantity) < item.quantity) return false;
          var properties = line.properties || {};
          // Compare all requested properties, including native operation/design keys.
          return Object.keys(item.properties).every(function(key) {
            var value = item.properties[key];
            if (value === '' || value === null) return properties[key] === undefined || properties[key] === '' || properties[key] === null;
            return typeof value !== 'object' && String(properties[key]) === String(value);
          });
        });
        if (index < 0) return false;
        used.add(index);return true;
      });
    }
    function confirm(operation, response) {
      if (operation.done || !response || !response.ok || typeof response.clone !== 'function') return Promise.resolve(false);
      // Claim before awaiting JSON so duplicate resolution cannot publish twice.
      operation.done = true;
      return Promise.all([operation.items,response.clone().json()]).then(function(values) {
        if (!matchingResponse(values[0],values[1])) return false;
        sendCartEvent('add_to_cart',{operation_id:operation.id});return true;
      },function() { return false; });
    }
    function wrapped(input, init) {
      var kind = endpoint(input,init);
      var operation = kind === 'add' ? {done:false,items:requestItems(input,init),id:'cart_'+Date.now().toString(36)+'_'+(++requestSerial).toString(36)+'_'+Math.random().toString(36).slice(2,8)} : null;
      var result = originalFetch.apply(this,arguments);
      if (kind) Promise.resolve(result).then(function(response) {
        if (kind === 'add') return confirm(operation,response);
        if (response && response.ok) sendCartEvent('update_cart');
      }).catch(function() {});
      return result;
    }
    return {fetch:wrapped,confirm:confirm,bodyItems:bodyItems,matchingResponse:matchingResponse};
  }

  function setupCartTracking() {
    var lastCount = 0;

    function updateCartCount() {
      return fetchCart().then(function (cart) {
        latestCartSnapshot = cart || {};
        lastCount = cart.items && Array.isArray(cart.items) ? cart.items.length : 0;
        return cart;
      });
    }

    function sendCartEvent(type, confirmation) {
      setTimeout(function () {
        fetchCart().then(function (cart) {
          latestCartSnapshot = cart || {};
          ensureLeadFromCart(cart);
          sendEvent(type, {
            cart_operation_id: type === "add_to_cart" && confirmation ? confirmation.operation_id : undefined,
            total_price: cart.total_price || 0,
            item_count: cart.items && Array.isArray(cart.items) ? cart.items.length : 0,
            items: cart.items || []
          }, { cart: cart });
          updateCartCount();
          if (type === "add_to_cart" && cart && cart.items && cart.items.length) {
            setTimeout(function () {
              maybeShowSmartCapture(cart, "add_to_cart");
            }, 18000);
          }
        });
      }, 250);
    }

    var cartObserver = installConfirmedCartObserver(window.fetch, sendCartEvent);
    window.fetch = cartObserver.fetch;

    updateCartCount().then(function (cart) {
      latestCartSnapshot = cart || {};
      ensureLeadFromCart(cart);
      sendEvent("cart_snapshot", {
        total_price: cart.total_price || 0,
        item_count: cart.items && Array.isArray(cart.items) ? cart.items.length : 0,
        items: cart.items || []
      }, { cart: cart });
      if (cart && cart.items && cart.items.length) {
        setTimeout(function () {
          maybeShowSmartCapture(cart, "cart_snapshot");
        }, SMART_CAPTURE_DELAY_MS);
      }
    });
  }

  function parseMoneyText(text) {
    var value = String(text || "")
      .replace(/\s/g, "")
      .replace(/[^\d,.-]/g, "");
    var lastComma = value.lastIndexOf(",");
    var lastDot = value.lastIndexOf(".");
    var decimalSeparator = "";

    if (lastComma > -1 && lastDot > -1) {
      decimalSeparator = lastComma > lastDot ? "," : ".";
    } else if (lastComma > -1) {
      decimalSeparator = value.length - lastComma - 1 === 3 ? "" : ",";
    } else if (lastDot > -1) {
      decimalSeparator = value.length - lastDot - 1 === 3 ? "" : ".";
    }

    if (decimalSeparator) {
      var thousandsSeparator = decimalSeparator === "," ? "." : ",";
      value = value.split(thousandsSeparator).join("").replace(decimalSeparator, ".");
    } else {
      value = value.replace(/[,.]/g, "");
    }

    var parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  }

  function getCartDrawerTotal() {
    var totalEl = document.querySelector("#CartDrawer .totals__total-value, .totals__total-value");
    return totalEl ? parseMoneyText(totalEl.textContent) : 0;
  }

  function getStoredRecommendedProducts() {
    var products = safeJsonParse(localStorage.getItem(LS_RECOMMENDED_PRODUCTS), []);
    return Array.isArray(products) ? products : [];
  }

  function absoluteShopUrl(path) {
    if (!path) return "";
    if (path.indexOf("//") === 0) return "https:" + path;
    if (path.indexOf("http") === 0) return path;
    return window.location.origin + path;
  }

  function shopRedirectPath(url) {
    var absoluteUrl = absoluteShopUrl(url);
    if (!absoluteUrl) return "/cart";

    try {
      var parsed = new URL(absoluteUrl, window.location.origin);
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (e) {
      return "/cart";
    }
  }

  function formatThreshold(value) {
    var amount = parseInt(value || 0, 10);
    if (isNaN(amount) || amount <= 0) return "";
    return amount.toLocaleString("sr-RS") + " RSD";
  }

  function rememberCouponNotice(options, redirect) {
    if (!window.sessionStorage) return;

    try {
      sessionStorage.setItem(SS_COUPON_NOTICE, JSON.stringify({
        code: CART_DISCOUNT_CODE,
        threshold: options.threshold || 0,
        source: options.shownEvent || "",
        redirect: redirect || "/cart",
        ts: Date.now()
      }));
    } catch (e) {}
  }

  function injectCouponNoticeStyles() {
    if (document.getElementById("kbCouponNoticeStyles")) return;

    var style = document.createElement("style");
    style.id = "kbCouponNoticeStyles";
    style.textContent = [
      ".kbCouponNotice{position:fixed;left:50%;bottom:18px;transform:translateX(-50%);z-index:2147482996;width:min(560px,calc(100vw - 28px));box-sizing:border-box;background:#121212;color:#fff;border-radius:0;box-shadow:0 18px 28px rgba(0,0,0,0.1);padding:14px 14px 14px 16px;font-family:inherit;display:flex;align-items:center;gap:12px}",
      ".kbCouponNoticeText{margin:0;flex:1;font-size:15px;line-height:1.38;color:#fff}",
      ".kbCouponNoticeText b{color:#fff}",
      ".kbCouponNoticeCart{flex:0 0 auto;border:0;border-radius:999px;background:#E88A2D;color:#fff;text-decoration:none;font-weight:700;font-size:13px;line-height:1;padding:11px 14px;white-space:nowrap}",
      ".kbCouponNoticeClose{flex:0 0 auto;width:34px;height:34px;border:0;border-radius:999px;background:rgba(255,255,255,.12);color:#fff;font-size:24px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center}",
      ".kbCouponNotice--brain{top:12px;bottom:auto;background:#121212;border:1px solid rgba(232, 138, 45,.45)}",
      "@media(max-width:520px){.kbCouponNotice{left:14px;right:14px;bottom:12px;transform:none;width:auto;align-items:stretch;display:grid;grid-template-columns:1fr 34px;gap:10px}.kbCouponNotice--brain{top:10px;bottom:auto}.kbCouponNoticeCart{grid-column:1 / 3;text-align:center;padding-top:12px;padding-bottom:12px}.kbCouponNoticeText{font-size:14px}}"
    ].join("");
    document.head.appendChild(style);
  }

  function showPendingCouponNotice() {
    if (!window.sessionStorage) return;

    var notice = null;
    try {
      notice = safeJsonParse(sessionStorage.getItem(SS_COUPON_NOTICE), null);
      sessionStorage.removeItem(SS_COUPON_NOTICE);
    } catch (e) {
      return;
    }

    if (!notice || !notice.code) return;
    if (notice.ts && Date.now() - parseInt(notice.ts, 10) > 10 * 60 * 1000) return;

    injectCouponNoticeStyles();

    var threshold = formatThreshold(notice.threshold);
    var isFreeDelivery = notice.source === "free_delivery_popup_shown";
    var text = "Kod " + notice.code + " je aktiviran.";
    if (threshold && isFreeDelivery) {
      text += " Važi za besplatnu dostavu preko " + threshold + ".";
    } else if (threshold) {
      text += " Važi za korpe preko " + threshold + ".";
    }

    var bar = document.createElement("div");
    bar.className = "kbCouponNotice";
    bar.setAttribute("role", "status");

    var copy = document.createElement("p");
    copy.className = "kbCouponNoticeText";
    copy.innerHTML = text.replace(notice.code, "<b>" + notice.code + "</b>");

    var cartLink = document.createElement("a");
    cartLink.className = "kbCouponNoticeCart";
    cartLink.href = notice.discount_url || "/cart";
    cartLink.textContent = notice.source === "customer_brain_incentive" ? "PRIMENI KOD" : "IDI U KORPU";

    var close = document.createElement("button");
    close.type = "button";
    close.className = "kbCouponNoticeClose";
    close.setAttribute("aria-label", "Zatvori");
    close.innerHTML = "&times;";

    function removeNotice() {
      if (bar.parentNode) bar.parentNode.removeChild(bar);
    }

    close.addEventListener("click", removeNotice);
    bar.appendChild(copy);
    bar.appendChild(cartLink);
    bar.appendChild(close);
    document.body.appendChild(bar);

    setTimeout(removeNotice, 12000);
  }

  function showActiveCustomerBrainIncentive() {
    if (!window.localStorage) return;
    if (document.querySelector(".kbCouponNotice--brain")) return;

    var notice = null;
    try {
      notice = safeJsonParse(localStorage.getItem(LS_CUSTOMER_BRAIN_INCENTIVE), null);
    } catch (e) {
      return;
    }

    if (!notice || !notice.code) return;
    var expiresAt = notice.expires_at ? Date.parse(String(notice.expires_at).replace(" ", "T")) : 0;
    if (expiresAt && Date.now() > expiresAt) {
      try { localStorage.removeItem(LS_CUSTOMER_BRAIN_INCENTIVE); } catch (e) {}
      return;
    }

    injectCouponNoticeStyles();

    var bar = document.createElement("div");
    bar.className = "kbCouponNotice kbCouponNotice--brain";
    bar.setAttribute("role", "status");

    var copy = document.createElement("p");
    copy.className = "kbCouponNoticeText";
    var targetName = notice.target_name || "preporučeni proizvod";
    var noticeTargetPhrase = notice.notice_target_phrase || targetName;
    var text = "Kod " + notice.code + " za " + noticeTargetPhrase + " je sačuvan.";
    if (notice.amount_label) {
      text += " Vrednost: " + notice.amount_label + ".";
    }
    if (expiresAt) {
      var hours = Math.max(1, Math.ceil((expiresAt - Date.now()) / (60 * 60 * 1000)));
      text += " Važi još " + hours + "h.";
    }
    copy.innerHTML = text.replace(notice.code, "<b>" + notice.code + "</b>");

    var cartLink = document.createElement("a");
    cartLink.className = "kbCouponNoticeCart";
    cartLink.href = notice.discount_url || ("/discount/" + encodeURIComponent(notice.code) + "?redirect=" + encodeURIComponent(notice.target_url || "/cart"));
    cartLink.textContent = "PRIMENI KOD";

    var close = document.createElement("button");
    close.type = "button";
    close.className = "kbCouponNoticeClose";
    close.setAttribute("aria-label", "Zatvori");
    close.innerHTML = "&times;";
    close.addEventListener("click", function () { if (bar.parentNode) bar.parentNode.removeChild(bar); });

    bar.appendChild(copy);
    bar.appendChild(cartLink);
    bar.appendChild(close);
    document.body.appendChild(bar);
  }

  function injectFloatingActionsStyles() {
    if (document.getElementById("kbFloatingActionsStyles")) return;

    var style = document.createElement("style");
    style.id = "kbFloatingActionsStyles";
    style.textContent = [
      ".kbFloatingActions{position:fixed;right:18px;bottom:126px;z-index:2147482988;font-family:inherit;display:flex;flex-direction:column;align-items:flex-end;gap:10px}",
      ".kbFloatingMain{display:flex;flex-direction:column;gap:10px}",
      ".kbFloatingBtn{width:56px;height:56px;border:0;border-radius:999px;background:#121212;color:#fff;box-shadow:0 12px 24px rgba(0,0,0,0.18);display:flex;align-items:center;justify-content:center;text-decoration:none;cursor:pointer;position:relative;font-size:20px;line-height:1;transition:transform .16s,opacity .16s,background .16s,box-shadow .16s}",
      ".kbFloatingBtn:hover{transform:translateY(-1px);background:#222;color:#fff;box-shadow:0 14px 24px rgba(0,0,0,0.18)}",
      ".kbFloatingBtn:focus-visible{outline:3px solid rgba(232,138,45,.35);outline-offset:3px}",
      ".kbFloatingBtnHelp{background:#E88A2D}",
      ".kbFloatingBtnHelp:hover{background:#d97a1f}",
      ".kbFloatingCartCount{position:absolute;right:-4px;top:-4px;min-width:20px;height:20px;border-radius:999px;background:#E88A2D;color:#fff;border:2px solid #fff;font-size:11px;font-weight:700;line-height:16px;display:flex;align-items:center;justify-content:center;padding:0 5px;box-sizing:border-box}",
      ".kbFloatingCartCount.is-empty{display:none}",
      ".kbFloatingPanel{position:absolute;right:0;bottom:132px;width:min(260px,calc(100vw - 32px));background:#fff;color:#121212;border:1px solid rgba(0,0,0,.1);border-radius:0;box-shadow:0 18px 28px rgba(0,0,0,0.1);padding:8px;box-sizing:border-box;opacity:0;visibility:hidden;transform:translateY(8px);pointer-events:none;transition:opacity .16s,transform .16s,visibility .16s}",
      ".kbFloatingPanel.is-open{opacity:1;visibility:visible;transform:translateY(0);pointer-events:auto}",
      ".kbFloatingLink{min-height:42px;border-radius:0;display:flex;align-items:center;gap:10px;text-decoration:none;color:#121212;font-size:14px;line-height:1.2;padding:10px 12px;box-sizing:border-box}",
      ".kbFloatingLink:hover{background:#f5f5f5;color:#121212}",
      ".kbFloatingLink i{width:18px;text-align:center;color:#E88A2D;font-size:16px}",
      ".kbDraftReminder{display:none;position:relative;width:min(278px,calc(100vw - 32px));background:#fff;color:#121212;border:1px solid rgba(17,17,17,.12);border-radius:0;box-shadow:0 16px 28px rgba(0,0,0,0.1);padding:10px;box-sizing:border-box}",
      ".kbDraftReminder.is-visible{display:block}",
      ".kbDraftPill{display:none;position:relative}",
      ".kbDraftPill.is-visible{display:flex}",
      ".kbDraftPillCount{position:absolute;right:-4px;top:-4px;min-width:20px;height:20px;border-radius:999px;background:#E88A2D;color:#fff;border:2px solid #fff;font-size:11px;font-weight:700;line-height:16px;display:flex;align-items:center;justify-content:center;padding:0 5px;box-sizing:border-box}",
      ".kbDraftReminderMini{display:flex;align-items:center;justify-content:space-between;gap:10px}",
      ".kbDraftReminderText{display:grid;gap:2px;min-width:0}",
      ".kbDraftReminderText strong{font-size:13px;line-height:1.2;font-weight:750;color:#121212}",
      ".kbDraftReminderText span{font-size:12px;line-height:1.25;color:#666;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}",
      ".kbDraftReminderBadge{min-width:22px;height:22px;border-radius:999px;background:#E88A2D;color:#fff;display:inline-flex;align-items:center;justify-content:center;font-size:12px;font-weight:750;padding:0 7px;box-sizing:border-box}",
      ".kbDraftReminderActions{display:flex;gap:8px;margin-top:9px}",
      ".kbDraftReminderContinue{flex:1;min-height:38px;border:0;border-radius:999px;background:#121212;color:#fff;text-decoration:none;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:750;padding:0 14px}",
      ".kbDraftReminderContinue:hover{background:#222;color:#fff}",
      ".kbDraftReminderDismiss{width:38px;height:38px;border:1px solid rgba(17,17,17,.12);border-radius:999px;background:#fff;color:#555;font-size:18px;line-height:1;cursor:pointer}",
      ".kbDraftReminderDismiss:hover{background:#f5f5f5;color:#121212}",
      "@media(max-width:520px){.kbFloatingActions{right:12px;bottom:156px}.kbFloatingMain{gap:10px}.kbFloatingBtn{width:56px;height:56px;font-size:20px}.kbFloatingPanel{bottom:132px;right:0}.kbDraftReminder{width:min(282px,calc(100vw - 24px))}}"
    ].join("");
    document.head.appendChild(style);
  }

  function openFloatingCart(ev) {
    if (ev) ev.preventDefault();

    var drawer = document.querySelector("cart-drawer") || document.getElementById("CartDrawer");
    if (drawer && typeof drawer.open === "function") {
      drawer.open();
      return;
    }

    var cartIcon = document.querySelector("#cart-icon-bubble, a[href='/cart']");
    if (cartIcon && cartIcon.getAttribute("aria-controls")) {
      cartIcon.click();
      return;
    }

    window.location.href = "/cart";
  }

  function trackFloatingAction(action) {
    sendEvent("floating_action_click", {
      action: action,
      url: window.location.href,
      pathname: window.location.pathname
    });
  }

  function draftStepLabel(step) {
    if (step === "colors") return "Izbor boja";
    if (step === "details") return "Detalji";
    if (step === "text") return "Tekst";
    return "Personalizacija";
  }

  function hasMeaningfulDesignDraft(config) {
    if (!config) return false;
    return !!(
      config.street ||
      config.number ||
      config.extra_text ||
      config.characters ||
      config.mailbox_top_text ||
      config.mailbox_bottom_text ||
      config.note ||
      config.contact_phone ||
      (config.dog_symbol_key && config.dog_symbol_key !== "lovacki_01") ||
      (config.number_align && config.number_align !== "right") ||
      (config.plate_style && config.plate_style !== "rectangular")
    );
  }

  /* Lazni podsetnici "Nastavi unos", 03.11.2026.
     Polja konfiguratora dolaze POPUNJENA primerom (snippets/kb-house-plate-
     configurator.liquid + locales/en.default.json -> configurator_examples), a
     nacrt se cuva na svaku izmenu, pa i na samu promenu boje. Zato je nacrt mogao
     da postane "znacajan" iako kupac nije otkucao ni jedno slovo. Mereno u CRM-u
     za 7 dana: 2.169 sacuvanih nacrta, 1.649 prikazanih podsetnika, a samo 276
     leadova je zaista nesto otkucalo.

     Ovde se NE menja kada se nacrt cuva (to je kb-table-designer.js) niti
     dogadjaj table_design_draft_saved — filtrira se samo PRIKAZ podsetnika. */
  var DESIGN_DRAFT_TEXT_FIELDS = [
    "street", "number", "extra_text", "characters",
    "mailbox_top_text", "mailbox_bottom_text"
  ];

  /* Podrazumevane vrednosti procitane sa produkcije koje customerBrainIsDemoText
     jos ne pokriva. Samo za filter podsetnika — lista u customerBrainIsDemoText
     se namerno ne dira da se ne pomeri ponasanje ponuda (customer brain). */
  var DESIGN_DRAFT_DEMO_KEYS = [
    "cuvaj se psa", "zabranjeno parkiranje", "upozorenje",
    "objekat je pod video nadzorom", "8"
  ];

  function designDraftTextIsDemo(value) {
    if (customerBrainIsDemoText(value)) return true;
    return DESIGN_DRAFT_DEMO_KEYS.indexOf(customerBrainTextKey(value)) !== -1;
  }

  /* true SAMO kada je nacrt postao "znacajan" isključivo zbog primera.
     U nedoumici vraca false — radije prikazi podsetnik nego sakrij pravi nacrt. */
  function designDraftIsDemoOnly(config) {
    if (!config) return false;

    /* Polja koja konfigurator nikad ne popunjava primerom: ako su popunjena,
       kupac ih je sam uneo. */
    if (customerBrainNormalizeText(config.note)) return false;
    if (customerBrainNormalizeText(config.contact_phone)) return false;

    /* Nije tekst, ali je svestan izbor kupca — podsetnik ostaje. */
    if (config.dog_symbol_key && config.dog_symbol_key !== "lovacki_01") return false;
    if (config.number_align && config.number_align !== "right") return false;
    if (config.plate_style && config.plate_style !== "rectangular") return false;

    var imaTekst = false;
    for (var i = 0; i < DESIGN_DRAFT_TEXT_FIELDS.length; i++) {
      var value = customerBrainNormalizeText(config[DESIGN_DRAFT_TEXT_FIELDS[i]]);
      if (!value) continue;
      imaTekst = true;
      if (!designDraftTextIsDemo(value)) return false;
    }
    return imaTekst;
  }

  function readDesignDrafts() {
    var drafts = [];
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (!key || key.indexOf(LS_DESIGN_DRAFT_PREFIX) !== 0) continue;
        var draft = safeJsonParse(localStorage.getItem(key), null);
        if (!draft || !hasMeaningfulDesignDraft(draft.config)) continue;
        var productHandle = draft.product_handle || (draft.config && draft.config.product_handle) || key.replace(LS_DESIGN_DRAFT_PREFIX, "");
        drafts.push({
          key: key,
          product_handle: productHandle,
          product_id: draft.product_id || "",
          saved_at: draft.saved_at || "",
          config: draft.config || {},
          url: productHandle ? "/products/" + encodeURIComponent(productHandle) : "/collections/all"
        });
      }
    } catch (err) {}
    drafts.sort(function (a, b) {
      return String(b.saved_at || "").localeCompare(String(a.saved_at || ""));
    });
    return drafts;
  }

  function draftSummary(draft) {
    var cfg = draft && draft.config ? draft.config : {};
    var text = cfg.street || cfg.characters || cfg.mailbox_bottom_text || cfg.extra_text || "";
    var number = cfg.number ? " " + cfg.number : "";
    var dims = cfg.dimensions || ((cfg.width_cm || cfg.height_cm) ? ((cfg.width_cm || "") + "x" + (cfg.height_cm || "") + " cm") : "");
    var parts = [];
    if (text || number) parts.push((text + number).trim());
    if (dims) parts.push(dims);
    if (cfg.step) parts.push(draftStepLabel(cfg.step));
    return parts.join(" · ") || "Nedovršena personalizacija";
  }

  function draftReminderTitle(draft) {
    var cfg = draft && draft.config ? draft.config : {};
    var text = cfg.street || cfg.characters || cfg.mailbox_bottom_text || cfg.extra_text || "";
    var number = cfg.number ? " " + cfg.number : "";
    var title = (text + number).trim();
    return title ? "Nastavi: " + title : "Nastavi dizajn";
  }

  function reminderAllowed() {
    var path = window.location.pathname || "";
    if (/^\/(cart|checkout)(\/|$)/.test(path)) return false;
    var dismissedUntil = parseInt(localStorage.getItem(LS_DESIGN_REMINDER_DISMISSED_UNTIL) || "0", 10);
    return !dismissedUntil || Date.now() > dismissedUntil;
  }

  function sendDesignReminderEvent(type, draft, extra) {
    var cfg = draft && draft.config ? draft.config : {};
    sendEvent(type, Object.assign({
      product_handle: draft ? draft.product_handle : "",
      product_id: draft ? draft.product_id : "",
      url: window.location.href,
      pathname: window.location.pathname,
      draft_url: draft ? draft.url : "",
      step: cfg.step || "",
      shape: cfg.shape || "",
      product_type: cfg.product_type || "",
      dimensions: cfg.dimensions || ((cfg.width_cm || "") + "x" + (cfg.height_cm || "")),
      street: cfg.street || "",
      number: cfg.number || "",
      extra_text: cfg.extra_text || "",
      characters: cfg.characters || "",
      contact_phone: cfg.contact_phone || "",
      /* Isti filter kao u `refreshDraftReminder()` — inace CRM broji i nacrte
         koji su samo primer iz konfiguratora, pa se merenje efekta ispravke
         gleda na dva razlicita broja. */
      draft_count: readDesignDrafts().filter(function (d) {
        return !designDraftIsDemoOnly(d.config);
      }).length
    }, extra || {}));
  }

  function setupFloatingActions() {
    if (window.__kbFloatingActionsInit) return;
    window.__kbFloatingActionsInit = true;

    var legacy = document.querySelector(".floating-buttons-container:not([data-kb-floating-actions])");
    if (legacy && legacy.parentNode) legacy.parentNode.removeChild(legacy);

    injectFloatingActionsStyles();

    var root = document.createElement("div");
    root.className = "kbFloatingActions";
    root.setAttribute("data-kb-floating-actions", "1");

    var panel = document.createElement("div");
    panel.id = "kbFloatingHelpPanel";
    panel.className = "kbFloatingPanel";
    panel.setAttribute("role", "menu");
    panel.setAttribute("aria-hidden", "true");

    var actions = [
      { label: "Poziv", href: "tel:+381658416212", icon: "fas fa-phone", action: "call" },
      { label: "SMS", href: "sms:+381658416212", icon: "fas fa-sms", action: "sms" },
      { label: "Viber", href: "viber://chat?number=%2B381658416212", icon: "fab fa-viber", action: "viber" },
      { label: "WhatsApp", href: "https://wa.me/381658416212", icon: "fab fa-whatsapp", action: "whatsapp", target: "_blank" },
      { label: "Pomoć dizajnera", href: "/pages/pomoc-dizajnera-za-kucni-broj", icon: "fas fa-paint-brush", action: "designer_help" },
      { label: "Cenovnik", href: "/pages/cenovnik", icon: "fas fa-dollar-sign", action: "price_list" }
    ];

    actions.forEach(function (item) {
      var link = document.createElement("a");
      link.className = "kbFloatingLink";
      link.href = item.href;
      link.setAttribute("role", "menuitem");
      if (item.target) {
        link.target = item.target;
        link.rel = "noopener";
      }
      link.innerHTML = "<i class='" + item.icon + "' aria-hidden='true'></i><span>" + item.label + "</span>";
      link.addEventListener("click", function (e) {
        if (item.action === "designer_help" && openHouseNumberDesignerForm("floating_help_panel")) {
          e.preventDefault();
          setPanel(false);
          return;
        }
        trackFloatingAction(item.action);
        setPanel(false);
      });
      panel.appendChild(link);
    });

    var main = document.createElement("div");
    main.className = "kbFloatingMain";

    var helpButton = document.createElement("button");
    helpButton.type = "button";
    helpButton.className = "kbFloatingBtn kbFloatingBtnHelp";
    helpButton.setAttribute("aria-label", "Pomoc");
    helpButton.setAttribute("aria-controls", panel.id);
    helpButton.setAttribute("aria-expanded", "false");
    helpButton.innerHTML = "<i class='fas fa-headset' aria-hidden='true'></i>";

    var cartButton = document.createElement("a");
    cartButton.href = "/cart";
    cartButton.className = "kbFloatingBtn kbFloatingBtnCart";
    cartButton.setAttribute("aria-label", "Korpa");
    cartButton.innerHTML = "<i class='fas fa-shopping-cart' aria-hidden='true'></i><span id='kbFloatingCartCount' class='kbFloatingCartCount is-empty'>0</span>";

    var draftReminder = document.createElement("div");
    draftReminder.className = "kbDraftReminder";
    draftReminder.setAttribute("role", "status");
    draftReminder.setAttribute("aria-live", "polite");
    draftReminder.innerHTML = [
      "<div class='kbDraftReminderMini'>",
      "<div class='kbDraftReminderText'><strong data-kb-draft-title>Nastavi dizajn</strong><span data-kb-draft-summary></span></div>",
      "<span class='kbDraftReminderBadge' data-kb-draft-count>1</span>",
      "</div>",
      "<div class='kbDraftReminderActions'>",
      "<a class='kbDraftReminderContinue' href='/collections/all' data-kb-draft-continue>Nastavi</a>",
      "<button class='kbDraftReminderDismiss' type='button' aria-label='Sakrij podsetnik' data-kb-draft-dismiss>&times;</button>",
      "</div>"
    ].join("");
    var draftTitleEl = draftReminder.querySelector("[data-kb-draft-title]");
    var draftSummaryEl = draftReminder.querySelector("[data-kb-draft-summary]");
    var draftCountEl = draftReminder.querySelector("[data-kb-draft-count]");
    var draftContinueEl = draftReminder.querySelector("[data-kb-draft-continue]");
    var draftDismissEl = draftReminder.querySelector("[data-kb-draft-dismiss]");
    var activeDraft = null;
    var reminderShownSignature = "";
    var reminderExpanded = false;

    var draftPill = document.createElement("button");
    draftPill.type = "button";
    draftPill.className = "kbFloatingBtn kbDraftPill";
    draftPill.setAttribute("aria-label", "Nastavi započeti dizajn");
    draftPill.innerHTML = "<i class='fas fa-pen' aria-hidden='true'></i><span class='kbDraftPillCount' data-kb-draft-pill-count>1</span>";
    var draftPillCountEl = draftPill.querySelector("[data-kb-draft-pill-count]");

    function refreshDraftReminder() {
      /* Nacrt u kome je SVE sto pise zapravo primer iz konfiguratora nije
         kupcev unos — za njega je podsetnik lazan i ne prikazuje se. */
      var drafts = readDesignDrafts().filter(function (draft) {
        return !designDraftIsDemoOnly(draft.config);
      });
      if (!reminderAllowed() || !drafts.length) {
        draftReminder.classList.remove("is-visible");
        draftPill.classList.remove("is-visible");
        reminderExpanded = false;
        activeDraft = null;
        return;
      }
      activeDraft = drafts[0];
      var signature = activeDraft.key + "|" + drafts.length + "|" + (activeDraft.saved_at || "");
      if (draftTitleEl) draftTitleEl.textContent = draftReminderTitle(activeDraft);
      if (draftSummaryEl) draftSummaryEl.textContent = draftSummary(activeDraft);
      if (draftCountEl) {
        draftCountEl.textContent = String(drafts.length);
        draftCountEl.style.display = drafts.length > 1 ? "inline-flex" : "none";
      }
      if (draftContinueEl) draftContinueEl.href = activeDraft.url;
      if (draftPillCountEl) draftPillCountEl.textContent = String(drafts.length);
      draftPill.classList.add("is-visible");
      draftReminder.classList.toggle("is-visible", reminderExpanded);
      if (signature !== reminderShownSignature) {
        reminderShownSignature = signature;
        if (localStorage.getItem(LS_DESIGN_REMINDER_SHOWN_SESSION) !== sessionId) {
          localStorage.setItem(LS_DESIGN_REMINDER_SHOWN_SESSION, sessionId);
          sendDesignReminderEvent("table_design_reminder_shown", activeDraft);
        }
      }
    }

    function setPanel(open) {
      panel.classList.toggle("is-open", open);
      panel.setAttribute("aria-hidden", open ? "false" : "true");
      helpButton.setAttribute("aria-expanded", open ? "true" : "false");
    }

    function refreshCartCount() {
      fetchCart().then(function (cart) {
        var badge = document.getElementById("kbFloatingCartCount");
        if (!badge) return;
        var count = parseInt(cart.item_count || 0, 10);
        badge.textContent = String(count);
        badge.classList.toggle("is-empty", count <= 0);
      });
    }

    helpButton.addEventListener("click", function () {
      trackFloatingAction("open_help_panel");
      setPanel(!panel.classList.contains("is-open"));
    });

    draftPill.addEventListener("click", function () {
      reminderExpanded = !reminderExpanded;
      draftReminder.classList.toggle("is-visible", reminderExpanded);
      if (reminderExpanded && activeDraft) sendDesignReminderEvent("table_design_reminder_click", activeDraft, { source: "pill_expand" });
    });

    cartButton.addEventListener("click", function (ev) {
      trackFloatingAction("cart");
      openFloatingCart(ev);
    });

    if (draftContinueEl) {
      draftContinueEl.addEventListener("click", function () {
        if (!activeDraft) return;
        sendDesignReminderEvent("table_design_reminder_click", activeDraft);
        sendDesignReminderEvent("table_design_restored", activeDraft, { source: "floating_reminder" });
      });
    }

    if (draftDismissEl) {
      draftDismissEl.addEventListener("click", function () {
        if (activeDraft) sendDesignReminderEvent("table_design_reminder_dismiss", activeDraft);
        localStorage.setItem(LS_DESIGN_REMINDER_DISMISSED_UNTIL, String(Date.now() + DESIGN_REMINDER_DISMISS_MS));
        draftReminder.classList.remove("is-visible");
        draftPill.classList.remove("is-visible");
        reminderExpanded = false;
      });
    }

    document.addEventListener("click", function (ev) {
      if (!panel.classList.contains("is-open")) return;
      if (root.contains(ev.target)) return;
      setPanel(false);
    });

    document.addEventListener("keydown", function (ev) {
      if (ev.key === "Escape") setPanel(false);
    });

    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible") {
        refreshCartCount();
        refreshDraftReminder();
      }
    });

    window.addEventListener("storage", function (ev) {
      if (!ev.key || ev.key.indexOf(LS_DESIGN_DRAFT_PREFIX) === 0 || ev.key === LS_DESIGN_REMINDER_DISMISSED_UNTIL) {
        refreshDraftReminder();
      }
    });

    if (!window.__kbFloatingCartFetchPatched) {
      var originalFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === "string" ? input : input && input.url;
        var result = originalFetch.apply(this, arguments);
        if (url && /\/cart\/(add|change|update)\.js?/.test(url)) {
          result.finally(function () { setTimeout(refreshCartCount, 180); });
        }
        return result;
      };
      window.__kbFloatingCartFetchPatched = true;
    }

    window.addEventListener("cart:updated", refreshCartCount);
    window.openFloatingCart = openFloatingCart;

    main.appendChild(draftPill);
    main.appendChild(helpButton);
    main.appendChild(cartButton);
    root.appendChild(panel);
    root.appendChild(draftReminder);
    root.appendChild(main);
    document.body.appendChild(root);
    refreshCartCount();
    refreshDraftReminder();
  }

  function formatPrice(value) {
    var cents = parseInt(value || 0, 10);
    if (isNaN(cents) || cents <= 0) return "";
    return Math.round(cents / 100).toLocaleString("sr-RS") + " RSD";
  }

  function saveRecommendedProducts(products) {
    var seen = {};
    var unique = [];
    products.forEach(function (product) {
      if (!product || !product.name || !product.link) return;
      var key = product.name + "|" + product.link;
      if (seen[key]) return;
      seen[key] = true;
      unique.push(product);
    });
    localStorage.setItem(LS_RECOMMENDED_PRODUCTS, JSON.stringify(unique));
  }

  function addRecommendedProducts(products) {
    saveRecommendedProducts(getStoredRecommendedProducts().concat(products || []));
  }

  function getCurrentProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function getCurrentProductId() {
    if (config.productId) return Promise.resolve(config.productId);
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return Promise.resolve(window.ShopifyAnalytics.meta.product.id);
    }

    var handle = getCurrentProductHandle();
    if (!handle) return Promise.resolve(null);

    return fetch("/products/" + encodeURIComponent(handle) + ".js")
      .then(function (r) { return r.json(); })
      .then(function (product) { return product && product.id ? product.id : null; })
      .catch(function () { return null; });
  }

  function normalizeShopifyProduct(product) {
    if (!product) return null;
    var image = product.featured_image || (product.images && product.images[0]) || "";
    var link = product.url || (product.handle ? "/products/" + product.handle : "");
    var name = product.title || product.name || "";
    if (!name || !link) return null;

    return {
      image: absoluteShopUrl(image),
      link: absoluteShopUrl(link),
      name: name,
      price: product.price ? formatPrice(product.price) : (product.price_min ? formatPrice(product.price_min) : "")
    };
  }

  function collectConfiguredFallbackProducts() {
    if (!Array.isArray(config.cartDiscountFallbackProducts)) return [];
    return config.cartDiscountFallbackProducts.map(function (product) {
      if (!product || !product.name || !product.link) return null;
      return {
        image: absoluteShopUrl(product.image || ""),
        link: absoluteShopUrl(product.link),
        name: product.name,
        price: product.price || ""
      };
    }).filter(Boolean);
  }

  function collectShopifyRecommendationProducts() {
    return getCurrentProductId().then(function (productId) {
      if (!productId) return [];

      var url = "/recommendations/products.json?product_id=" + encodeURIComponent(productId) +
        "&limit=" + encodeURIComponent(CART_RECOMMENDATION_LIMIT) +
        "&intent=related";

      return fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data && Array.isArray(data.products) ? data.products : [];
          return products.map(normalizeShopifyProduct).filter(Boolean);
        })
        .catch(function () { return []; });
    });
  }

  function collectRecommendedProducts() {
    var products = getStoredRecommendedProducts();
    var nodes = document.querySelectorAll("[data-essential-upsell-funnel-content-offer-type='CROSS_SELL'] [data-essential-upsell-element='product']");

    Array.prototype.forEach.call(nodes, function (node) {
      var image = node.querySelector("img[data-essential-upsell-element='image']");
      var title = node.querySelector("a[data-essential-upsell-element='title']");
      var price = node.querySelector("div[data-essential-upsell-element='price']");
      if (!image || !title) return;

      var imageSrc = image.getAttribute("src") || "";
      var href = title.getAttribute("href") || "";
      products.push({
        image: imageSrc.indexOf("//") === 0 ? "https:" + imageSrc : imageSrc,
        link: href.indexOf("http") === 0 ? href : "https://www.kucnibrojevi.com" + href,
        name: title.textContent.trim(),
        price: price ? price.textContent.trim() : ""
      });
    });

    saveRecommendedProducts(products);

    if (products.length) return Promise.resolve(products);

    var configuredFallback = collectConfiguredFallbackProducts();
    if (configuredFallback.length) {
      addRecommendedProducts(configuredFallback);
      return Promise.resolve(configuredFallback);
    }

    return collectShopifyRecommendationProducts().then(function (shopifyProducts) {
      addRecommendedProducts(shopifyProducts);
      return shopifyProducts;
    });
  }

  function getProductPriceValue(product) {
    return parseMoneyText(product && product.price);
  }

  function pickSuggestedProduct(minPrice) {
    var products = getStoredRecommendedProducts();
    var cartItems = Array.prototype.slice.call(document.querySelectorAll("#CartDrawer-CartItems .cart-item__name"))
      .map(function (item) { return item.textContent.trim(); });
    var available = products.filter(function (product) {
      if (cartItems.indexOf(product.name) !== -1) return false;
      if (minPrice && getProductPriceValue(product) < minPrice) return false;
      return true;
    });

    if (!available.length) return null;
    return available[Math.floor(Math.random() * available.length)];
  }

  function getFreeDeliverySuggestedProduct(cartTotal) {
    var missingAmount = Math.max(0, FREE_SHIPPING_THRESHOLD - cartTotal);
    if (!missingAmount) return null;
    return pickSuggestedProduct(missingAmount);
  }

  function isFreeDeliveryPopupApplicable(cartTotal) {
    if (!FREE_DELIVERY_POPUP_ENABLED) return false;
    if (cartTotal <= 0) return false;
    if (cartTotal >= FREE_SHIPPING_THRESHOLD) return false;
    if (cartTotal < MIN_CART_TOTAL_TO_SHOW_FREE_DELIVERY) return false;
    return !!getFreeDeliverySuggestedProduct(cartTotal);
  }

  function shouldShowFreeDeliveryPopup(cartTotal) {
    if (!canShowAnyPopup()) return false;
    if (document.querySelector(".kbCustomerBrainOffer")) return false;
    if (isCooldownActive(LS_FREE_DELIVERY_POPUP_CLOSED_UNTIL)) return false;
    return isFreeDeliveryPopupApplicable(cartTotal);
  }

  function shouldShowRecommendedProductPopup(cartTotal) {
    if (config.cartDiscountPopup === false) return false;
    if (!canShowAnyPopup()) return false;
    if (document.querySelector(".kbCustomerBrainOffer")) return false;
    if (isCooldownActive(LS_CART_POPUP_CLOSED_UNTIL)) return false;
    if (cartTotal <= 0 || cartTotal >= CART_DISCOUNT_THRESHOLD) return false;
    if (cartTotal < MIN_CART_TOTAL_TO_SHOW_CART_DISCOUNT) return false;
    if (isFreeDeliveryPopupApplicable(cartTotal)) return false;
    return true;
  }

  function closeCartPopup() {
    var overlay = document.getElementById("cartDiscountOverlay");
    var popup = document.getElementById("cartDiscountPopup");
    if (overlay) overlay.remove();
    if (popup) popup.remove();
    localStorage.setItem(LS_CART_POPUP_CLOSED_UNTIL, String(Date.now() + CART_POPUP_COOLDOWN_MS));
    releasePopupLock();
  }

  function closeFreeDeliveryPopup() {
    var overlay = document.getElementById("freeDeliveryOverlay");
    var popup = document.getElementById("freeDeliveryPopup");
    if (overlay) overlay.remove();
    if (popup) popup.remove();
    localStorage.setItem(LS_FREE_DELIVERY_POPUP_CLOSED_UNTIL, String(Date.now() + FREE_DELIVERY_POPUP_COOLDOWN_MS));
    releasePopupLock();
  }

  function closeCartDiscountPopup() {
    closeCartPopup();
  }

  function removeLegacyCartPopup() {
    var popups = Array.prototype.slice.call(document.querySelectorAll("#cartDiscountPopup"));
    popups.forEach(function (popup) {
      var text = popup.textContent || "";
      if (text.indexOf(CART_DISCOUNT_CODE) !== -1) return;
      if (text.indexOf("Poklanjamo ti kupon") === -1 && text.indexOf("SSTIPO") === -1) return;

      var overlay = document.getElementById("cartDiscountOverlay");
      if (overlay) overlay.remove();
      popup.remove();
      releasePopupLock();
    });
  }

  function suppressLegacyCartPopup() {
    removeLegacyCartPopup();
  }

  function injectCartPopupStyles() {
    if (document.getElementById("kbCartPopupStyles")) return;

    var style = document.createElement("style");
    style.id = "kbCartPopupStyles";
    style.textContent = [
      ".kbCartPopupOverlay{position:fixed;inset:0;z-index:2147482998;background:rgba(18, 18, 18,.42);padding:16px;box-sizing:border-box}",
      ".kbCartPopup{width:min(480px,calc(100vw - 32px));max-height:calc(100vh - 32px);overflow-y:auto;box-sizing:border-box;background:#fff;color:#121212;border:1px solid rgba(18, 18, 18,.12);box-shadow:0 20px 28px rgba(18, 18, 18,0.1);position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:2147482999;padding:22px;border-radius:0;font-family:inherit}",
      ".kbCartPopupClose{cursor:pointer;position:absolute;right:10px;top:10px;border:0;border-radius:999px;background:#f2f2f2;font-size:22px;line-height:1;width:34px;height:34px;display:flex;align-items:center;justify-content:center;color:#595959}",
      ".kbCartPopupClose:hover{background:#e3e3e3;color:#121212}",
      ".kbCartPopupEyebrow{margin:0 42px 8px 0;color:#6e6e6e;font-size:12px;font-weight:750;letter-spacing:.08em;text-transform:uppercase}",
      ".kbCartPopupTitle{margin:0 42px 8px 0;text-align:left;font-size:22px;line-height:1.22;font-weight:750;letter-spacing:0;color:#121212}",
      ".kbCartPopupText{margin:0 0 16px;text-align:left;line-height:1.48;color:#595959;font-size:15px;max-width:430px}",
      ".kbCartPopupText b{color:#121212;font-weight:750}",
      ".kbCartPopupProduct{display:flex;align-items:center;gap:14px;margin:16px 0 18px;min-width:0;padding:12px;border:1px solid rgba(18, 18, 18,.10);border-radius:0;background:#f7f7f7}",
      ".kbCartPopupProductImage{width:96px;height:96px;max-width:96px;max-height:96px;object-fit:cover;display:block;flex:0 0 auto;border-radius:0;background:#fff}",
      ".kbCartPopupProductCopy{min-width:0;flex:1}",
      ".kbCartPopupProductName{margin:0 0 6px;color:#121212;font-size:15px;font-weight:700;line-height:1.35;overflow-wrap:anywhere}",
      ".kbCartPopupProductPrice{margin:0;color:#E88A2D;font-size:14px;font-weight:750;line-height:1.35}",
      ".kbCartPopupActions{display:flex;flex-direction:column;gap:9px;margin-top:8px}",
      ".kbCartPopupButton{width:100%;min-height:46px;border:none;border-radius:999px;background:#121212;color:#fff;display:inline-flex;align-items:center;justify-content:center;text-align:center;padding:12px 18px;font-size:15px;cursor:pointer;line-height:1.25;font-weight:750}",
      ".kbCartPopupSecondary{width:100%;min-height:40px;border:1px solid rgba(18, 18, 18,.14);border-radius:999px;background:#fff;color:#454545;display:inline-flex;align-items:center;justify-content:center;text-align:center;padding:10px 16px;font-size:14px;cursor:pointer;line-height:1.25;font-weight:650}",
      ".kbCartPopupCode{margin:10px 0 0;text-align:center;color:#6e6e6e;font-size:13px;line-height:1.35}",
      ".kbCartPopupUrgency{display:none}",
      "@media(max-width:420px){.kbCartPopup{padding:18px 16px}.kbCartPopupTitle{font-size:20px}.kbCartPopupText{font-size:14px}.kbCartPopupProduct{gap:10px}.kbCartPopupProductImage{width:78px;height:78px}.kbCartPopupButton{font-size:14px}.kbCartPopupCode{font-size:12px}}",
      "@media(max-width:340px){.kbCartPopup{width:calc(100vw - 20px);padding-left:12px;padding-right:12px}.kbCartPopupTitle{font-size:19px}.kbCartPopupProductImage{width:68px;height:68px}.kbCartPopupProductName,.kbCartPopupProductPrice{font-size:13px}}"
    ].join("");
    document.head.appendChild(style);
  }

  function setupLegacyPopupBlocker() {
    window.triggerCartDiscountPopup = suppressLegacyCartPopup;
    removeLegacyCartPopup();

    var runs = 0;
    var timer = setInterval(function () {
      window.triggerCartDiscountPopup = suppressLegacyCartPopup;
      removeLegacyCartPopup();
      runs += 1;
      if (runs >= 60) clearInterval(timer);
    }, 1000);
  }

  function appendSuggestedProduct(popup, suggestedProduct) {
    if (!suggestedProduct) return;

    var productRow = document.createElement("div");
    productRow.className = "kbCartPopupProduct";

    var imageLink = document.createElement("a");
    imageLink.href = suggestedProduct.link;

    var image = document.createElement("img");
    image.src = suggestedProduct.image;
    image.alt = suggestedProduct.name;
    image.className = "kbCartPopupProductImage";
    imageLink.appendChild(image);

    var copy = document.createElement("div");
    copy.className = "kbCartPopupProductCopy";

    var nameLink = document.createElement("a");
    nameLink.href = suggestedProduct.link;
    nameLink.style.textDecoration = "none";

    var name = document.createElement("p");
    name.textContent = suggestedProduct.name;
    name.className = "kbCartPopupProductName";

    var price = document.createElement("p");
    price.textContent = suggestedProduct.price;
    price.className = "kbCartPopupProductPrice";

    nameLink.appendChild(name);
    copy.appendChild(nameLink);
    copy.appendChild(price);
    productRow.appendChild(imageLink);
    productRow.appendChild(copy);
    popup.appendChild(productRow);
  }

  function showProductPopup(options) {
    if (document.getElementById(options.popupId)) return;
    if (!canShowAnyPopup()) return;

    injectCartPopupStyles();
    markPopupShown();

    var discountRedirect = "/cart";
    if (options.suggestedProduct && options.suggestedProduct.link) {
      discountRedirect = shopRedirectPath(options.suggestedProduct.link);
    }

    var overlay = document.createElement("div");
    overlay.id = options.overlayId;
    overlay.className = "kbCartPopupOverlay";
    overlay.addEventListener("click", options.close);

    var popup = document.createElement("div");
    popup.id = options.popupId;
    popup.className = "kbCartPopup";

    var closeButton = document.createElement("button");
    closeButton.type = "button";
    closeButton.setAttribute("aria-label", "Zatvori");
    closeButton.innerHTML = "&times;";
    closeButton.className = "kbCartPopupClose";
    closeButton.addEventListener("click", options.close);

    var eyebrow = document.createElement("p");
    eyebrow.textContent = options.eyebrow || "Predlog za korpu";
    eyebrow.className = "kbCartPopupEyebrow";

    var heading = document.createElement("h2");
    heading.textContent = options.heading;
    heading.className = "kbCartPopupTitle";

    var subheading = document.createElement("p");
    subheading.innerHTML = options.bodyHtml;
    subheading.className = "kbCartPopupText";

    popup.appendChild(closeButton);
    popup.appendChild(eyebrow);
    popup.appendChild(heading);
    popup.appendChild(subheading);
    appendSuggestedProduct(popup, options.suggestedProduct);

    var button = document.createElement("button");
    button.type = "button";
    button.textContent = options.ctaLabel || (options.suggestedProduct ? "Pogledaj predlog" : "Primeni kod");
    button.className = "kbCartPopupButton";
    button.addEventListener("click", function () {
      rememberCouponNotice(options, discountRedirect);
      sendEvent(options.clickEvent, {
        code: CART_DISCOUNT_CODE,
        cart_total: options.cartTotal,
        threshold: options.threshold,
        missing_amount: options.missingAmount || 0,
        suggested_product: options.suggestedProduct || null,
        redirect: discountRedirect
      });
      window.location.href = "https://www.kucnibrojevi.com/discount/" + encodeURIComponent(CART_DISCOUNT_CODE) + "?redirect=" + encodeURIComponent(discountRedirect);
    });

    var secondary = document.createElement("button");
    secondary.type = "button";
    secondary.textContent = options.secondaryLabel || "Nastavi bez predloga";
    secondary.className = "kbCartPopupSecondary";
    secondary.addEventListener("click", options.close);

    var additionalMessage = document.createElement("p");
    additionalMessage.innerHTML = "Kod za besplatnu dostavu: <b>" + CART_DISCOUNT_CODE + "</b>";
    additionalMessage.className = "kbCartPopupCode";

    var actions = document.createElement("div");
    actions.className = "kbCartPopupActions";
    actions.appendChild(button);
    actions.appendChild(secondary);

    popup.appendChild(actions);
    popup.appendChild(additionalMessage);
    document.body.appendChild(overlay);
    document.body.appendChild(popup);

    sendEvent(options.shownEvent, {
      code: CART_DISCOUNT_CODE,
      cart_total: options.cartTotal,
      threshold: options.threshold,
      missing_amount: options.missingAmount || 0,
      suggested_product: options.suggestedProduct || null,
      redirect: discountRedirect
    });
  }

  function showFreeDeliveryPopup(cartTotal) {
    var missingAmount = Math.max(0, Math.ceil(FREE_SHIPPING_THRESHOLD - cartTotal));
    var suggestedProduct = getFreeDeliverySuggestedProduct(cartTotal);
    if (!suggestedProduct) return;

    showProductPopup({
      overlayId: "freeDeliveryOverlay",
      popupId: "freeDeliveryPopup",
      close: closeFreeDeliveryPopup,
      eyebrow: "Besplatna dostava",
      heading: "Još " + missingAmount.toLocaleString("sr-RS") + " RSD do besplatne dostave",
      bodyHtml: "Kod MOJDOM važi za besplatnu dostavu preko 5.500 RSD. Možeš dodati proizvod koji se uklapa uz porudžbinu.",
      ctaLabel: "Pogledaj predlog",
      suggestedProduct: suggestedProduct,
      cartTotal: cartTotal,
      threshold: FREE_SHIPPING_THRESHOLD,
      missingAmount: missingAmount,
      shownEvent: "free_delivery_popup_shown",
      clickEvent: "free_delivery_coupon_click"
    });
  }

  function showCartDiscountPopup(cartTotal) {
    var total = typeof cartTotal === "number" ? cartTotal : getCartDrawerTotal();
    var missingAmount = Math.max(0, Math.ceil(CART_DISCOUNT_THRESHOLD - total));
    var suggestedProduct = pickSuggestedProduct();

    showProductPopup({
      overlayId: "cartDiscountOverlay",
      popupId: "cartDiscountPopup",
      close: closeCartPopup,
      eyebrow: "Predlog za kompletiranje",
      heading: "Još " + missingAmount.toLocaleString("sr-RS") + " RSD do MOJDOM dostave",
      bodyHtml: suggestedProduct ? "Predlog za kompletiranje korpe, bez obaveze. Kod MOJDOM važi za besplatnu dostavu preko 5.500 RSD." : "Korpa je blizu uslova za MOJDOM besplatnu dostavu.",
      ctaLabel: suggestedProduct ? "Pogledaj predlog" : "Primeni kod",
      suggestedProduct: suggestedProduct,
      cartTotal: total,
      threshold: CART_DISCOUNT_THRESHOLD,
      missingAmount: missingAmount,
      shownEvent: "cart_discount_popup_shown",
      clickEvent: "cart_discount_coupon_click"
    });
  }

  function setupCartDiscountPopup() {
    /* Ovde je ranije stajalo:  if (config.cartDiscountPopup === false) return;
       Taj rani izlazak je gasio i posmatraca drawera, a isti posmatrac poziva
       refreshCustomerBrainForCart() — dakle gasenje popupa sa popustom
       oslabilo bi i Customer Brain, koji sa njim nema veze.

       Posmatrac sada uvek radi. Same popupe gase shouldShowRecommendedProductPopup()
       (proverava config.cartDiscountPopup) i shouldShowFreeDeliveryPopup()
       (preko FREE_DELIVERY_POPUP_ENABLED), pa je ponasanje konfiguracije
       nepromenjeno — samo vise ne obara Customer Brain sa sobom. */

    if (window.location.pathname.indexOf("/products/") !== -1) {
      setTimeout(collectRecommendedProducts, 4000);
    }

    var cartDrawer = document.querySelector("cart-drawer.drawer");
    if (!cartDrawer) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== "attributes" || mutation.attributeName !== "class") return;
        if (!mutation.target.classList.contains("active")) return;

        setTimeout(function () {
          refreshCustomerBrainForCart();
          collectRecommendedProducts().finally(function () {
            var total = getCartDrawerTotal();
            if (shouldShowFreeDeliveryPopup(total)) {
              showFreeDeliveryPopup(total);
            } else if (shouldShowRecommendedProductPopup(total)) {
              showCartDiscountPopup(total);
            }
          });
        }, 3000);
      });
    });

    observer.observe(cartDrawer, { attributes: true, attributeFilter: ["class"] });
    log("KB cart discount popup observer started");
  }

  /* ---------------------------------------------------------------
     Sažetak sesije — VRAĆENO 18.09.2026.

     Radilo je do maja 2026. u staroj temi (`shopify_code.before_kb_embed.php`,
     funkcija `sendSessionSummary`), pa je ispalo pri prelasku na kb embed.
     Posledica: 53% sesija nema izmereno trajanje, jer se vreme inače izvodi
     iz razmaka između događaja, a konfigurator ih prigušuje
     (DRAFT_ANALYTICS_DELAY_MS 12 s, MIN_INTERVAL 45 s) — pa merenje ima
     grublju rezoluciju od pojave koju meri.
     Vidi docs/LEAD_SISTEM.md, odeljak „Kriva odustajanja po 5 sekundi".

     Četiri razlike u odnosu na staru verziju, sve namerne:

     1. Ide kroz `postEventObject`, pa nosi `session_id`. Stari zapisi ga
        nemaju (NULL do 07.2026), zbog čega se istorija ne može spojiti sa
        krivom po sesiji.
     2. `seconds_on_page` je ograničen na 4 sata. U starim podacima postoji
        zapis od 6.654 s — to je pozadinski tab, ne posetilac.
     3. Ne šalje se pri svakom skrivanju stranice nego tek kad izmereno vreme
        poraste za bar 30 s. Stara verzija je slala pri svakom, odatle
        414.620 zapisa. Pri analizi uzimati MAX po sesiji.
     4. Na `pagehide` koristi `sendBeacon`, jer `fetch` u tom trenutku zna da
        bude prekinut. `sendEvent` ostaje kao rezerva.
  --------------------------------------------------------------- */
  var SESSION_SUMMARY_MAX_SECONDS = 4 * 3600;
  var SESSION_SUMMARY_MIN_DELTA_SECONDS = 30;
  var pageStartTs = Date.now();
  var maxScrollDepth = 0;
  var sessionSummaryLastSec = -1;

  function trackScrollDepth() {
    var doc = document.documentElement;
    var fullHeight = Math.max(
      doc ? doc.scrollHeight : 0,
      document.body ? document.body.scrollHeight : 0
    );
    if (!fullHeight) return;
    var depth = (window.pageYOffset + window.innerHeight) / fullHeight;
    if (depth > maxScrollDepth) maxScrollDepth = Math.min(1, depth);
  }

  function sessionSummaryData() {
    var sec = Math.round((Date.now() - pageStartTs) / 1000);
    return {
      seconds_on_page: Math.max(0, Math.min(sec, SESSION_SUMMARY_MAX_SECONDS)),
      seconds_capped: sec > SESSION_SUMMARY_MAX_SECONDS,
      scroll_depth: Math.round(maxScrollDepth * 100),
      page: window.location.href
    };
  }

  function sendSessionSummary(useBeacon) {
    if (!leadId) return;

    var data = sessionSummaryData();
    if (sessionSummaryLastSec >= 0 &&
        data.seconds_on_page - sessionSummaryLastSec < SESSION_SUMMARY_MIN_DELTA_SECONDS) {
      return;
    }

    var poslato = false;
    if (useBeacon && navigator.sendBeacon) {
      try {
        var payload = {
          anon_id: anonId,
          lead_id: leadId,
          session_id: sessionId,
          event_type: "session_summary",
          event_data: data,
          page: window.location.href,
          ts: new Date().toISOString(),
          referrer: document.referrer || "",
          ua: navigator.userAgent,
          meta: metaIdentity(),
          google: googleIdentity(),
          manychat: manychatIdentity(),
          shopify: shopifyIdentity()
        };
        /* text/plain, ne application/json. JSON tip čini zahtev CORS-složenim, pa traži
           preflight, a preflight pri napuštanju stranice pregledači redovno odbace.
           sendBeacon ipak vrati true jer je zahtev samo stavljen u red, pa ni rezerva
           ispod nije proradila. Mereno 28.09.2026: od 210 sažetaka u 7 dana, 179 su
           bili Meta crawleri — stvarnih ljudi oko 31, ispod 1% sesija.
           Server čita telo preko file_get_contents('php://input') i ne gleda
           Content-Type, pa text/plain prolazi bez izmene na serveru.
           Isti obrazac već koristi decision beacon u ovom fajlu. */
        var blob = new Blob([kbTelo(payload)], { type: "text/plain;charset=UTF-8" });
        poslato = navigator.sendBeacon(API_EVENT, blob);
      } catch (e) {
        poslato = false;
      }
    }

    if (!poslato) sendEvent("session_summary", data);
    sessionSummaryLastSec = data.seconds_on_page;
  }

  function setupSessionSummary() {
    window.addEventListener("scroll", trackScrollDepth, { passive: true });
    trackScrollDepth();

    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") sendSessionSummary(true);
    });
    window.addEventListener("pagehide", function () { sendSessionSummary(true); });
  }

  function setupAutoEvents() {
    initLeadOnce().finally(function () {
      var manychat = manychatIdentity();
      sendEvent("page_view", { title: document.title, url: window.location.href, manychat: manychat });

      if (hasManychatIdentity(manychat)) {
        var landingKey = LS_MANYCHAT_LANDING_SENT_PREFIX + manychat.contact_id + ":" + sessionId;
        try {
          if (localStorage.getItem(landingKey) !== "1") {
            sendEvent("manychat_landing", {
              contact_id: manychat.contact_id,
              subscriber_id: manychat.subscriber_id,
              source: manychat.source,
              platform: manychat.platform,
              ig_username: manychat.ig_username,
              entry_flow: manychat.entry_flow,
              lead_id: manychat.lead_id,
              mc_lead_id: manychat.mc_lead_id,
              anon_id: manychat.anon_id,
              mc_anon_id: manychat.mc_anon_id,
              utm_source: manychat.utm_source,
              utm_medium: manychat.utm_medium,
              utm_campaign: manychat.utm_campaign,
              utm_term: manychat.utm_term,
              utm_content: manychat.utm_content,
              url: window.location.href
            });
            localStorage.setItem(landingKey, "1");
          }
        } catch (e) {}
      }

      if (window.location.pathname.indexOf("/products/") !== -1) {
        sendEvent("view_product", {
          title: (document.querySelector("h1") || {}).innerText || "",
          url: window.location.href
        });
      }

      if (window.location.pathname.indexOf("/collections/") !== -1) {
        sendEvent("view_category", {
          category_title: (window.GS_COLLECTION && window.GS_COLLECTION.title) || document.title,
          category_handle: (window.GS_COLLECTION && window.GS_COLLECTION.handle) || "",
          category_id: (window.GS_COLLECTION && window.GS_COLLECTION.id) || null,
          url: window.location.href
        });
      }

      setTimeout(requestCustomerBrainDecision, 1200);
      window.addEventListener("cart:updated", function () { setTimeout(refreshCustomerBrainForCart, 500); });
    });
  }

  function setupObservers() {
    bindEcomSend(document);
    var observer = new MutationObserver(function (mutations) {
      bindEcomSend(document);
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) bindEcomSend(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function setupPopupTriggers() {
    document.addEventListener("click", function (e) {
      var helpBtn = e.target.closest("[data-kb-lead-help], .gs-help-btn");
      if (!helpBtn) return;

      e.preventDefault();
      if (helpBtn.hasAttribute("data-kb-cart-help") && typeof window.kbShowSmartCapture === "function") {
        fetchCart().then(function (cart) {
          latestCartSnapshot = cart || latestCartSnapshot || {};
          if (!window.kbShowSmartCapture("product_help", latestCartSnapshot, { force: true }) && typeof window.gsShowPopup === "function") {
            window.gsShowPopup();
          }
        });
        return;
      }
      if (openHouseNumberDesignerForm("product_designer_help")) {
        return;
      }
      if (typeof window.gsShowPopup === "function") {
        window.gsShowPopup();
      }
    }, true);

    /* Ovde je stajao presretac klika na #customily-personalize-button: zadrzao bi
       klik, pokazao lead popup, pa posle zatvaranja ponovo kliknuo dugme.
       Uklonjen 03.11.2026. jer je bio mrtav sa dve strane — Customily se ne
       koristi pa dugme ne postoji ni na jednoj stranici, a i da postoji,
       config.customilyIntercept je false pa bi shouldShowLeadPopup() uvek
       vratio false. Uz njega je otisao i continuePendingCustomilyClick(). */
  }

  function boot() {
    window.gsLeadId = leadId;
    window.gsAnonId = anonId;
    window.gsSendLeadBaseData = function (extra) {
      extra = extra || {};
      if (extra.source === "custom_popup") {
        return collectLead({
          fname: extra.fname || "",
          lname: extra.lname || "",
          email: extra.email || "",
          phone: extra.phone || "",
          extra: extra
        });
      }

      var data = readFields(extra.scope || document);
      data.extra = extra;
      if (data.email || data.phone) return collectLead(data);
      return Promise.resolve(null);
    };
    window.ensureLeadFromCart = ensureLeadFromCart;
    window.sendEvent = sendEvent;
    window.kbIdentifyLeadByPhone = identifyByPhone;

    injectPopup();
    injectSmartCapture();
    setupPhoneCapture();
    setupObservers();
    setupPopupTriggers();
    setupCartTracking();
    setupFloatingActions();
    setupLegacyPopupBlocker();
    setupCartDiscountPopup();
    showPendingCouponNotice();
    showActiveCustomerBrainIncentive();
    scheduleCustomerBrainSameTextPrefill();
    setupCustomerBrainMountObserver();
    setupAutoEvents();
    setupSessionSummary();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

(function () {
  if (!/\/products\/postansko-sanduce(?:[/?#]|$)/.test(window.location.pathname + window.location.search)) return;

  var TARGET_DEFAULT = "ПЕТРОВИЋ";
  var OLD_DEFAULTS = ["", "МИЈАТОВИЋ", "MIJATOVIĆ", "MIJATOVIC", "PORODICA PETROVIĆ", "PORODICA PETROVIC"];
  var selector = 'input[name="properties[Donji tekst]"], textarea[name="properties[Donji tekst]"]';

  function setNativeValue(input, value) {
    var proto = Object.getPrototypeOf(input);
    var desc = proto && Object.getOwnPropertyDescriptor(proto, "value");
    if (desc && desc.set) desc.set.call(input, value);
    else input.value = value;
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function patchDefault() {
    var input = document.querySelector(selector);
    if (!input) return false;
    var current = String(input.value || "").trim();
    if (OLD_DEFAULTS.indexOf(current) !== -1) setNativeValue(input, TARGET_DEFAULT);
    return true;
  }

  var tries = 0;
  function tick() {
    tries += 1;
    if (patchDefault() || tries > 40) return;
    window.setTimeout(tick, 250);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", tick);
  else tick();

  if ("MutationObserver" in window) {
    var observer = new MutationObserver(function () {
      if (patchDefault()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 12000);
  }
})();

/*
  ── Prenos identiteta na SEO domene Good Sign mreže ────────────────────────

  postanskosanduce.com, cuvajsepsa.com, plocicezavrata.com i
  brojevizazgrade.com su naši, ali su drugi domen — `localStorage` na njih ne
  prelazi. Bez ovoga bi isti čovek koji odavde pređe tamo dobio nov
  `gs_anon_id`, pa bi u CRM-u bio dva različita posetioca i istorija ponašanja
  bi se prekinula.

  Suprotan smer već radi: ovaj fajl gore čita `anon_id` i `lead_id` iz adrese
  (`queryCleanId` / `queryPositiveInt`), a SEO domeni te parametre upisuju u
  svoje linkove ka prodavnici.

  Radi delegirano, na klik — pa hvata i linkove koje tema ili meni dodaju
  kasnije, bez ijedne dalje izmene ovde. Ako takvih linkova nema, ne radi
  ništa.

  Menja SAMO adrese ka ta četiri domena i nikad ne gazi parametar koji već
  stoji u linku.
*/
(function () {
  "use strict";

  var HOSTS = [
    "postanskosanduce.com",
    "cuvajsepsa.com",
    "plocicezavrata.com",
    "brojevizazgrade.com"
  ];

  function ls(key) {
    try {
      return window.localStorage.getItem(key) || "";
    } catch (e) {
      return "";
    }
  }

  function isNetworkHost(host) {
    var name = String(host || "").toLowerCase().replace(/^www\./, "");
    for (var i = 0; i < HOSTS.length; i += 1) {
      if (name === HOSTS[i]) return true;
    }
    return false;
  }

  function decorate(anchor) {
    var url;
    try {
      url = new URL(anchor.getAttribute("href"), window.location.href);
    } catch (e) {
      return;
    }
    if (!isNetworkHost(url.hostname)) return;

    var anonId = ls("gs_anon_id");
    var leadId = ls("gs_lead_id");
    var sessionId = ls("gs_session_id");

    if (anonId && !url.searchParams.has("anon_id")) url.searchParams.set("anon_id", anonId);
    if (leadId && !url.searchParams.has("lead_id")) url.searchParams.set("lead_id", leadId);
    if (sessionId && !url.searchParams.has("session_id")) url.searchParams.set("session_id", sessionId);

    if (!url.searchParams.has("utm_source")) {
      url.searchParams.set("utm_source", "kucnibrojevi.com");
      url.searchParams.set("utm_medium", "seo-network");
    }

    anchor.setAttribute("href", url.toString());
  }

  function onPointer(event) {
    try {
      var target = event.target;
      if (!target || !target.closest) return;
      var anchor = target.closest("a[href]");
      if (anchor) decorate(anchor);
    } catch (e) {
      /* nikad ne sme da obori klik */
    }
  }

  document.addEventListener("click", onPointer, true);
  /* Srednji taster i „otvori u novoj kartici" ne prolaze kroz `click`. */
  document.addEventListener("auxclick", onPointer, true);
})();

/*
  ── Spajanje korpe prenete sa SEO domena ───────────────────────────────────

  Domeni mreže (postanskosanduce.com, cuvajsepsa.com, plocicezavrata.com)
  imaju svoju Storefront korpu. Kad kupac klikne „Prenesi korpu", dolazi ovamo
  sa `?gs_cart_id=<gid>&kb_merge=1`.

  Zašto ovako, a ne kao ranije: pre je to bio cross-site `POST /cart/add` sa
  skrivenom formom. Shopify kolačić korpe je `SameSite=Lax` i NE ide uz
  cross-site POST, pa je Shopify svaki put otvarao novu korpu i njen kolačić
  upisivao preko starog. Izmereno: kupac koji je već imao sanduče u korpi,
  posle prenosa pločice ostajao je samo sa pločicom.

  Ovde je poziv ka `/cart/add.js` SAME-SITE, dakle nosi kolačić — stavke se
  dodaju na postojeću korpu umesto da je zamene.

  Duple stavke: preskače se svaka linija čiji `_design_id` već stoji u korpi.
  Zato ponovni prenos posle dodavanja još jednog dizajna ne udvaja ono staro.
*/
(function () {
  "use strict";

  var STOREFRONT_DOMAIN = "kucnibrojevi.myshopify.com";
  var STOREFRONT_VERSION = "2026-07";
  var STOREFRONT_TOKEN = "455f572a730abbd5a94ce1c3f9101c38";

  function param(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || "";
    } catch (e) {
      return "";
    }
  }

  var cartId = param("gs_cart_id");
  if (param("kb_merge") !== "1") return;
  if (cartId.indexOf("gid://shopify/Cart/") !== 0) return;

  /* Osvežavanje stranice ne sme da doda isto dvaput. */
  var kljuc = "kb_merged:" + cartId;
  try {
    if (window.sessionStorage.getItem(kljuc) === "1") return;
  } catch (e) { /* privatni prozor — ide se dalje */ }

  function cistaAdresa() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete("gs_cart_id");
      url.searchParams.delete("kb_merge");
      return url.toString();
    } catch (e) {
      return window.location.href;
    }
  }

  function ocistiAdresu() {
    try {
      window.history.replaceState({}, "", cistaAdresa());
    } catch (e) { /* nije kritično */ }
  }

  var UPIT =
    "query($id: ID!) { cart(id: $id) { lines(first: 50) { nodes { quantity " +
    "merchandise { ... on ProductVariant { id } } " +
    "attributes { key value } } } } }";

  function povuciLinije() {
    return fetch("https://" + STOREFRONT_DOMAIN + "/api/" + STOREFRONT_VERSION + "/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query: UPIT, variables: { id: cartId } })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var cart = d && d.data && d.data.cart;
        return cart && cart.lines ? cart.lines.nodes : [];
      });
  }

  function postojeciDizajni() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var skup = {};
        (c.items || []).forEach(function (item) {
          var p = item.properties || {};
          if (p._design_id) skup[p._design_id] = true;
        });
        return skup;
      })
      .catch(function () { return {}; });
  }

  Promise.all([povuciLinije(), postojeciDizajni()])
    .then(function (par) {
      var linije = par[0];
      var vecUKorpi = par[1];
      var stavke = [];

      linije.forEach(function (linija) {
        var svojstva = {};
        var designId = "";
        (linija.attributes || []).forEach(function (a) {
          svojstva[a.key] = a.value;
          if (a.key === "_design_id") designId = a.value;
        });
        if (designId && vecUKorpi[designId]) return;

        var gid = linija.merchandise && linija.merchandise.id;
        if (!gid) return;
        var varijanta = String(gid).split("/").pop();
        if (!varijanta) return;

        stavke.push({ id: varijanta, quantity: linija.quantity || 1, properties: svojstva });
      });

      if (!stavke.length) {
        ocistiAdresu();
        return null;
      }

      return fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: stavke })
      }).then(function (r) { return r.ok ? r.json() : null; });
    })
    .then(function (rezultat) {
      try { window.sessionStorage.setItem(kljuc, "1"); } catch (e) { /* svejedno */ }

      /*
        Korpa je promenjena posle renderovanja stranice — bez ponovnog
        učitavanja bi kupac gledao staro stanje.

        Ide `replace` na očišćenu adresu, ne `reload`: `reload` bi zadržao
        `gs_cart_id` i `kb_merge` u adresi, pa bi ta adresa mogla da se
        podeli ili obeleži, a `replace` je i briše iz istorije.
      */
      if (rezultat) {
        window.location.replace(cistaAdresa());
        return;
      }
      ocistiAdresu();
    })
    .catch(function () {
      ocistiAdresu();
    });
})();

